import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';

import * as pluginDataLabels from 'chartjs-plugin-datalabels';

import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';

import { Label } from 'ng2-charts';
import { Pf16Service } from 'src/app/services/pf16.service';
import { AllPortService } from 'src/app/services/all-port.service';
import { BarsicService } from 'src/app/services/barsic.service';
import { CleaverService } from 'src/app/services/cleaver.service';

import html2canvas from 'html2canvas'; 
import Swal from 'sweetalert2';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DatePipe, formatDate } from '@angular/common';
import { IpvService } from 'src/app/services/ipv.service';
import { KostikService } from 'src/app/services/kostik.service';
import { TermanService } from 'src/app/services/terman.service';
import { ZavicService } from 'src/app/services/zavic.service';
import { EmailService } from 'src/app/services/email.service';
import { Mmpi2Service } from 'src/app/services/mmpi2.service';
import { MmpiaService } from 'src/app/services/mmpia.service';
import { MipsService } from 'src/app/services/mips.service';
import { Bis11Service } from 'src/app/services/bis11.service';
import { ChasideService } from 'src/app/services/chaside.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DominoService } from 'src/app/services/domino.service';
import { DominoInterpretation } from 'src/app/models/domino_models';
import { toHTML } from 'ngx-editor';
import { DOMINO_DATA } from 'src/app/helpers/domino_data';
import { DomainService } from 'src/app/services/domain.service';
import { utils, writeFile } from 'xlsx';
import { SubAccountService } from 'src/app/services/sub-account.service';
import { SubAccount, SubAccountPermisionType } from 'src/app/models/sub_account_model';
import { Folder } from 'src/app/models/folder_model';
import { CleaverHRForm, DiscModel, FORM_DATA } from 'src/app/models/cleaver_hr_form_model';
import { invalid } from '@angular/compiler/src/render3/view/util';
import { FolderPipe } from '../pipes/folder.pipe';
import { TestFilterPipe } from '../pipes/test-filter.pipe';

declare var $:any;

@Component({
  selector: 'app-client-evaluated',
  templateUrl: './client-evaluated.component.html',
  styleUrls: ['styles.css'
  ]
})
export class ClientEvaluatedComponent implements OnInit {

  @ViewChild ('contentToExport') contentToExport: ElementRef;
  @ViewChild ('contentToExport2') contentToExport2: ElementRef;
  @ViewChild ('contentToExport3') contentToExport3: ElementRef;
  @ViewChild ('contentToExport4') contentToExport4: ElementRef;
  @ViewChild ('contentToExport5') contentToExport5: ElementRef;
  @ViewChild ('contentToExportk') contentToExportk: ElementRef;
  @ViewChild ('contentToExport16') contentToExport16: ElementRef;
  @ViewChild ('contentToExport162') contentToExport162: ElementRef;
  @ViewChild ('contentToExportC') contentToExportC: ElementRef;
  @ViewChild ('contentToExportT') contentToExportT: ElementRef;


  @ViewChild ('pfReport') pfReport:ElementRef;
  @ViewChild ('allPortReport') allPortReport:ElementRef;
  @ViewChild ('barsicReport') barsicReport:ElementRef;
  @ViewChild ('cleaverReport') cleaverReport:ElementRef;
  @ViewChild ('ipvReport') ipvReport:ElementRef;
  @ViewChild ('kostikReport') kostikReport:ElementRef;
  @ViewChild ('termanReport') termanReport:ElementRef;
  @ViewChild ('zavicReport') zavicReport:ElementRef;
  @ViewChild ('mmpi2Report') mmpi2Report:ElementRef;
  @ViewChild ('mmpiaReport') mmpiaReport:ElementRef;
  @ViewChild ('mipsReport') mipsReport:ElementRef;
  @ViewChild ('bis11Report') bis11Report:ElementRef;
  @ViewChild ('chasideReport') chasideReport:ElementRef;
  @ViewChild ('dominoReport') dominoReport:ElementRef;
  @ViewChild ('dominoFactor') dominoFactor:ElementRef;

  @ViewChild ('normalHtml') normalHtml:ElementRef;
  @ViewChild ('motivatedHtml') motivatedHtml:ElementRef;
  @ViewChild ('stressHtml') stressHtml:ElementRef;
  @ViewChild ('hfHtml') hfHtml:ElementRef;
  @ViewChild ('hfProfileHtml') hfProfileHtml:ElementRef;


  public loading = false;
  public testData;
  public userPhoto = "";
  public inTrash = false;
  public isExporting = false;
  public isLoading = false;
  public tests=[];
  public user;
  public selectedType;
  public description;
  public report;
  public evaluated;
  public selectedTest;
  public barsicScores;
  public barsicRange;
  public password;
  public answers1AllPort=[];
  public answers2AllPort=[];
  public pe;
  public pn;
  public documentReady = false;
  public mmpi2Baremos;
  public mmpi2Results;
  public mmpi2Combination = {
    code:"",
    description:"",
    definition:""
  }
  public mmpi2Questions = [];
  public mmpi2NullAnswers = [];

  public mmpiaBaremos;
  public mmpiaResults;
  public mmpiaCombination = {
    code:"",
    description:"",
    definition:""
  }
  public mmpiaQuestions = [];
  public mmpiaNullAnswers = [];
  public mipsAjuste = 0;
  public age;

  public mipsTotalItems = [19, 19, 25]
  
  public newDate;
  
  public editingUser;
  
  public cleaverScores;
  public cleaverOriginalScores;
  public cleaverNormal;
  public cleaverMotivated;
  public cleaverPresion;
  public cleaverMaxWishText=[];
  public cleaverMaxRequireText=[];
  public cleaverMinWishText=[];
  public cleaverMinRequireText=[];
  public cleaverPresionMaxText=[];
  public cleaverPresionMinText=[];
  
  public barsicArray=[];
  public pf16Array=[];
  public ipvArray=[];
  public allPortArray=[];
  public kostikInterpretationArray=[];
  public mmpi2Array=[];
  public mmpi2InterpretationTexts=[];
  public mmpiaArray=[];
  public mmpiaInterpretationTexts=[];
  
  public modoDeVidaArray = [];
  public naturalezaSocialArray = [];
  public adaptacionAlTrabajoArray = [];
  public naturalezaEmocionalArray = [];
  public subordinacionArray = [];
  public gradoDeEnergiaArray = [];
  public liderazgoArray = [];
  
  public termanScore;
  public termanArray=[];
  public termanDescriptionsArray=[];
  public termanAnswers=[];
  public termanIq;
  public termanRank;
  public termanCa;
  
  public scoreIpvTypes;
  
  public zavicArray=[];
  public zavicArray1=[];
  public percentCompleted = 0;

  public naturalScore = 0;
  public directScore = 0;
  public testTime = 0;

  public chasideArray = [];
  public chasideScores;
  public chasideInterpretations;



  public bis11Results = {
    "No planificada":0,
    "Motora":0,
    "Cognitiva":0,
    "Puntuación total":0,
  }

  public dominoQuestions = DOMINO_DATA;

  public bis11Array = [];
  public bis11TotalRank = "";
  public bis11NuncaArray = [];
  public bis11OcasionalmenteArray = [];
  public bis11AMenudoArray = [];
  public bis11SiempreArray = [];

  public windowWidth = $(document).width()

  public barChartPlugins = [pluginDataLabels];
  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{gridLines:{display: false}, ticks:{fontSize:10, maxRotation:90, minRotation:90}}], 
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax:9, display: true},
                gridLines:{display: true}
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
    legend: {
      display: false
    }
  }

  public barChartOptionsChaside: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{gridLines:{display: false}, ticks:{fontSize:10, maxRotation:90, minRotation:90}}], 
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax:10, display: true},
                gridLines:{display: true}
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
    legend: {
      display: true
    }
  }

  public barChartOptionsMips: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{gridLines:{display: false}, ticks:{fontSize:10, maxRotation:90, minRotation:90}}], 
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax:40, display: true},
                gridLines:{display: true}
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
    legend: {
      display: false
    }
  }

  public barChartOptionsZavic: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{gridLines:{display: false}, ticks:{fontSize:10, maxRotation:90, minRotation:90}}], 
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax:50, display: true},
                gridLines:{display: true}
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
    legend: {
      display: false
    }
  }

  public barChartOptionsTerman: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{gridLines:{display: false}, ticks:{fontSize:10, maxRotation:90, minRotation:90}}], 
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax:40, display: true},
                gridLines:{display: true}
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
    legend: {
      display: false
    }
  }

  public radarChartOptions: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{
              gridLines:{display: false}, ticks:{display: false},}], 
              yAxes: [{
                ticks:{display: false},
                gridLines:{display: false}
              }] 
    },
    legend: {
      display: false
    }
  }

  public barChartOptionsMmpi2: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{gridLines:{display: false}, ticks:{fontSize:10, maxRotation:90, minRotation:90}}], 
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax:9, display: true},
                gridLines:{display: true}
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        font:{
          size:0
        },
        display: false
      },
      legend: {
        display: false
      }
    },
    legend:{
      display: false
    },    
  }

  public barChartOptionsIpv: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{gridLines:{display: false}}], 
              yAxes: [{ticks:{suggestedMin:0, suggestedMax:9, display: true},
                gridLines:{display: true}}] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    },
    legend: {
      display: false
    }
  }

  public barChartOptionsAllPort: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{
              ticks:{suggestedMin:0, suggestedMax: 70, minRotation: 90, maxRotation: 90},
              gridLines: {
                display:false
              },
            }],
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax: 70, display: true},
                gridLines: {
                  display:true
              }
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    },
    legend: {
      display: false
    },
  }

  public barChartOptionsBarsic: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{
              ticks:{suggestedMin:0, suggestedMax: 70, display: true, minRotation: 90, maxRotation: 90},
              gridLines: {
                display:false
              }}],
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax: 70},
                gridLines: {
                  display:true
              }
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    },
    legend: {
      display: false
    },
  }

  public barChartOptionsCleaver: ChartOptions = {
    responsive: true,
    scales: { xAxes: [{
                gridLines: {
                  display: false
                }
              }], 
              yAxes: [{
                ticks:{suggestedMin:0, suggestedMax: 100, display: true},
                gridLines: {
                  display: true
                }
              }] 
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    },
    elements:{
      line:{
        tension:0,
      }
    },

  }


  public barChartLabels: Label[] = [];
  public barChartLabels2: Label[] = [];
  public barChartLabels3: Label[] = [];
  public barChartLabels4: Label[] = [];
  public barChartType: ChartType = 'bar';
  public lineChartType: ChartType = 'line';
  public barChartLegend = true;

  public ascending = true;


  public barChartData: ChartDataSets[] = [
    { data: [], label: 'Puntaje', backgroundColor:['#019EFA','#019EFA'], hoverBackgroundColor:'#009efb' },

  ];

  public barChartDataChaside: ChartDataSets[] = [
    { data: [], label: 'Intereses', backgroundColor:['#4c9f00', '#4c9f00','#4c9f00', '#4c9f00','#4c9f00', '#4c9f00','#4c9f00'] },
    { data: [], label: 'Aptitudes', backgroundColor:['#009efb', '#009efb','#009efb', '#009efb','#009efb', '#009efb','#009efb']},
  ];

  public barChartDataMmpi2: ChartDataSets[] = [
    { data: [], label: 'Puntuación T', backgroundColor:['grey', 'blue'], hoverBackgroundColor:'#009efb' },
  ];
  public barChartDataMmpi22: ChartDataSets[] = [
    { data: [], label: 'Puntuación T', backgroundColor:['grey', 'blue'], hoverBackgroundColor:'#009efb' },
  ];
  public barChartDataMmpi23: ChartDataSets[] = [
    { data: [], label: 'Puntuación T', backgroundColor:['grey', 'blue'], hoverBackgroundColor:'#009efb' },
  ];
  public barChartDataMmpi24: ChartDataSets[] = [
    { data: [], label: 'Puntuación T', backgroundColor:['grey', 'blue'], hoverBackgroundColor:'#009efb' },
  ];

  public lineChartData: ChartDataSets[] = [

  ];
  public lineChartData2: ChartDataSets[] = [
 
  ];
  public lineChartDataKostik: ChartDataSets[] = [
    { data: [], label: 'Necesidades', backgroundColor:'#4c9f00', hoverBackgroundColor:'#009efb' },

  ];
  public lineChartDataKostik2: ChartDataSets[] = [
    { data: [], label: 'Papeles', backgroundColor:'yellow', hoverBackgroundColor:'#009efb' },

  ];
  public lineChartData3: ChartDataSets[] = [

  ];

  public cleaverFlatData: ChartDataSets[] = [
    { data: [40, 45, 55, 60], label: 'Plano/Indefinido', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb' },
  ]

  public cleaverDepressData: ChartDataSets[] = [
    { data: [20, 30, 35, 20], label: 'Deprimido', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb' },
  ]

  public cleaverExtremeData: ChartDataSets[] = [
    { data: [85, 5, 30, 60], label: 'Puntuaciones extremas', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb' },
  ]

  public cleaverElevatedData: ChartDataSets[] = [
    { data: [60, 70, 85, 90], label: 'Elevado', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb' },
  ]

  public cleaverTenseData: ChartDataSets[] = [
    { data: [90, 60, 20, 90], label: 'Tenso', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb' },
  ]

  public cleaverApatheticData: ChartDataSets[] = [
    { data: [10, 60, 30, 8], label: 'Apático', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb' },
  ]

  public cleaverHfData: ChartDataSets[] = [
    { data: [0, 0, 0, 0], label: 'Factor Humano', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb' },
  ]

  public radarChartLabels: Label[] = [];

  public radarChartData: ChartDataSets[] = [
    { data: [], label: 'Puntaje', backgroundColor:'#4c9f00',borderColor:'#4c9f00', hoverBackgroundColor:'#009efb' },

  ];

  public logoBase64;
  public mipsMotivacionalesArray = [];
  public mipsCognitivosArray = [];
  public mipsInterpersonalesArray = [];
  public mipsValidezArray = [];
  public mipsArray = [];


  public trigger = false;

  public formModel = {};

  public testFilter = '';

  public newTagName = '';
  public newTagColor = '';
  public addingTagTestIndex = -1;

  public actualPage = 1;

  public viewForms = false;

  public filterTags = [];
  public filterTag = ''
  public filteredTags = []

  public filterTests = [];
  public filterTest = ''
  public filteredTests = []

  public startDateFilter?: Date;
  public endDateFilter?: Date;
  public aprovedFilter = false;
  public testsForReport = [];
  public viewMassive = false;
  public massiveData = [];

  public userList: string[] = []

  public folder: Folder = {
    accountId: '',
    name: '',
    parentId: '',
    color: '#f5f5f5'
  }

  public editingFolderId = '';
  public folders: Folder[] = [];
  public folderFilter = null;
  public selectingFolderId = '';
  public editingFolderTestId = '';
  public isCleaverValid: boolean;
  public selectedHfTest: any;

  public hfR = {
    d: 0,
    i: 0,
    s: 0,
    c: 0
  }
  public hfD = {
    d: 0,
    i: 0,
    s: 0,
    c: 0
  }
  public hfDP = {
    d: 0,
    i: 0,
    s: 0,
    c: 0
  }
  public hf = {
    d: 0,
    i: 0,
    s: 0,
    c: 0
  }

  public hfProfile = '';
  public evaluatedHfProfile = '';
  public hrFormData = FORM_DATA;

  constructor(
    private testService:TestService, 
    private userService:UserService, 
    private Pf16Service:Pf16Service,
    private allPortService:AllPortService,
    private barsicService:BarsicService,
    private cleaverService:CleaverService,
    private ipvService:IpvService,
    private kostikService:KostikService,
    private termanService:TermanService,
    private zavicService:ZavicService,
    private emailService:EmailService,
    private mmpi2Service:Mmpi2Service,
    private mmpiaService:MmpiaService,
    private mipsService:MipsService,
    private bis11Service:Bis11Service,
    private chasideService:ChasideService,
    private route: ActivatedRoute,
    private router: Router,
    private dominoService: DominoService,
    public domainService: DomainService,
    private accountService: SubAccountService,
    private foldersPipe: FolderPipe,
    private testFilterPipe: TestFilterPipe
    ) { 


  }

  updateTestFolder(){
    let obj = {
      _id: this.editingFolderTestId,
      path: this.selectingFolderId
    }

    this.testService.updateTest(obj, false).subscribe(
      resp => {
        this.tests = this.tests.map(
          x => {
            if (x._id == this.editingFolderTestId){
              x.path = this.selectingFolderId;
            }
            return x;
          }
        )
        this.selectingFolderId = '';
        $('#selectFolderModal').modal('hide');
      }
    )
  }

  closeHfModal(){
    $('#hfModal').modal('hide');  
  }

  handleDeleteFolder(folderId: string){
    Swal.fire({
      icon: 'warning',
      text: '¿Estás seguro de eliminar esta carpeta?',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    }).then(
      resp => {
        $('#folderModal').modal('hide');
        if (resp.isConfirmed){
          let testsInFolder = this.tests.filter(
            x => x.path == folderId
          )
          if (testsInFolder.length > 0){
            Swal.fire({
              icon: 'error',
              text: 'No se puede eliminar la carpeta porque contiene pruebas',
            })
            return
          }
          this.testService.deleteFolder(folderId).subscribe(
            resp => {
              this.folders = this.folders.filter(
                x => x._id != folderId
              )
            }
          )
        }
      }
    )
  }

  createFolder(){
    if (this.folder.name == ''){
      return
    }
    if (!this.editingFolderId){
      this.folder.accountId = this.user._id;
      this.testService.createFolder(this.folder).subscribe(
        resp => {
          this.folders.push(resp);
          $('#folderModal').modal('hide');

        }
      )
    }else{
      this.testService.updateFolder(this.editingFolderId, this.folder).subscribe(
        resp => {
          this.folders = this.folders.map(
            x => {
              if (x._id == this.editingFolderId){
                x.name = this.folder.name;
              }
              return x;
            }
          )
          $('#folderModal').modal('hide');

        }
      )
    }
    this.editingFolderId = '';
    this.folder = {
      accountId: this.user._id,
      name: '',
      parentId: '',
      color: '#f5f5f5'
    }
  }
  
  addFilterTag(tag){
    if (!this.filteredTags.includes(tag)){
      this.filteredTags.push(tag);
    }
  }

  removeFilteredTag(index){
    this.filteredTags.splice(index, 1);
  }

  addFilterTest(test){
    if (!this.filteredTests.includes(test)){
      this.filteredTests.push(test);
    }
  }

  removeFilteredTest(index){
    this.filteredTests.splice(index, 1);
  }

  execute(test){
    if (test.isLocal){
      if (!test.isCompleted&&test.isStarted){
        return Swal.fire({
          icon: 'info',
          text: 'La prueba se encuentra bloqueada.'
        })
      }
      this.testService.setLocal(true);
      this.userService.setUserInTest(true);
      // localStorage.removeItem('token')
          if (!test.isCustomTest && test.isSecure){
            document.addEventListener("visibilitychange", () => {
              if (document.visibilityState === 'visible') {
                
              } else {
                if (this.testService.testStarted){
                  Swal.fire({
                    icon: 'warning',
                    text: 'La prueba ha sido bloqueada por cambiar de pestaña o minimizar la ventana',
                    confirmButtonText: 'Aceptar'
                  }).then(() => {
                    this.router.navigateByUrl('').then(() => {
                      location.reload()
                    });
                  })
                }
              }
            });
          }
    }
    if(test.type == "16PF"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/pf16');
    }

    if(test.type == "CLEAVER"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/cleaver');
    }

    if(test.type == "TERMAN"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/terman');
    }

    if(test.type == "ALL PORT"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/allPort');
    }

    if(test.type == "KOSTIK"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/kostik');
    }

    if(test.type == "IPV"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/ipv');
    }

    if(test.type == "ZAVIC"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/zavic');
    }

    if(test.type == "BARSIC"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/barsic');
    }

    if(test.type == "MMPI2"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/mmpi2');
    }

    if(test.type == "MMPIA"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/mmpia');
    }

    if(test.type == "MIPS"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/mips');
    }

    if(test.type == "BIS11"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/bis11');
    }

    if(test.type == "CHASIDE"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/chaside');
    }

    if(test.type == "FORMULARIO"){
      this.testService.selectedTestData = test;
      this.testData = test;
      this.router.navigate(['dashboard/requestedTests'], {queryParams:{action: 'form'}});
    }

    if(test.type == "DOMINO"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/domino');
    }

    if (test.isCustomTest){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/custom-test/'+test.completeForm);
    }
  }

  sendForm(){
    this.trigger = !this.trigger;
    let obj = {
      _id:this.testService.selectedTestData._id,
      formData:this.formModel,
      isCompleted:true,
      completeDate:Date.now()
    }
    this.testService.updateTest(obj).subscribe(
      resp=>{
        $('#formModal').modal('hide');
        this.testService.getEvaluatedTests(this.user.email).subscribe(
          resp=>{
            this.tests = resp;
          },
          err=>console.log(err)
        )
      },
      err=>console.log(err)
    );
  }

  async getTestsWithPermissions(userId: string){
    let accountPermission: SubAccount | null = null;
    try {
      accountPermission = await this.accountService.getSubAccount({subaccountId: userId}).toPromise().catch(err => null)
    } catch (error) {
      
    }
    let result = []
    result = result.concat(await this.getSubAccountTests(userId));

    if (!accountPermission){
      return result
    }

    if (accountPermission.permissionType == 'none'){
      return []
    }
    if (accountPermission.permissionType == 'limited'){
      let tests = await this.testService.getClientTests(accountPermission.accountEmail).toPromise();
      result = tests
    }
    if (accountPermission.permissionType == 'full'){
      let accounts = await this.accountService.getSubAccounts({accountId: accountPermission.accountId}).toPromise()
      let tests = await this.testService.getClientTests(accountPermission.accountEmail).toPromise();
      for (let account of accounts){
        if (account.subaccountId != userId){
          let accountTests = await this.testService.getClientTests(account.subaccountEmail).toPromise();
          tests = tests.concat(accountTests);
        }
      }
      result = tests;
    }
    return result
  }

  async getSubAccountTests(userId: string){
    let accounts = await this.accountService.getSubAccounts({accountId: userId}).toPromise()
    let tests = []
    for (let account of accounts){
      let accountTests = await this.testService.getClientTests(account.subaccountEmail).toPromise();
      tests = tests.concat(accountTests);
    }
    return tests;
  }

  

  async ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false
    this.testService.getTexts().subscribe(
      resp=>{
        this.description = resp;
      }
    )
    let shared = this.route.snapshot.queryParamMap.get('share');

    if (!localStorage.getItem('token') && !shared){
      this.testService.setLocal(false);
      return this.router.navigateByUrl('login');
    }

    let action = this.route.snapshot.queryParamMap.get('action');
    if (action == 'massive'){
      this.viewMassive = true;
    }

    if (!shared){
      this.userService.getUser().subscribe(
        resp => {
          this.user = resp;
          this.testService.getFolders({accountId: resp._id}).subscribe(
            resp => {
              this.folders = resp;
            }
          )
          this.testService.getClientTests(resp.email).subscribe(
            async tests => {
              setTimeout(() => {
                this.folderFilter = '';
              }, 1000)
              let addingTests = []
              try {
                addingTests = await this.getTestsWithPermissions(resp._id);
                
              } catch (error) {
                // console.error('Error fetching tests with permissions:', error);
              }
              tests = tests.concat(addingTests);
              tests.sort((a, b) => {
                let dateA = new Date(a.createDate);
                let dateB = new Date(b.createDate);
                return dateB.getTime() - dateA.getTime();
              })
              tests.map(
                x=>{
                  // console.log(x)
                  if (!x.trash){
                    this.tests.push(x);
                  }
                  if (x.type == 'FORMULARIO' && x.completeForm){
                    if (x.tags && x.tags.length > 0){
                      x.tags.map(
                        t => {
                          let obj = {
                            tag: t.name,
                            formName: x.completeForm.title,
                            test: x,
                            tagColor: t.color
                          }
                          let index = this.massiveData.findIndex(y=>y[0].tag == t.name && y[0].formName == x.completeForm.title);
                          if (index == -1){
                            this.massiveData.push([obj]);
                          }else{
                            this.massiveData[index].push(obj);
                          }
                        }
                      )
                    }else{
                      return
                      let obj = {
                        tag: 'Sin etiqueta',
                        formName: x.completeForm.title,
                        test: x,
                        tagColor: 'gray'
                      }
                      let index = this.massiveData.findIndex(y=>y[0].tag == 'Sin etiqueta' && y[0].formName == x.completeForm.title);
                      if (index == -1){
                        this.massiveData.push([obj]);
                      }else{
                        this.massiveData[index].push(obj);
                      }

                    }
                  }
                }
              )
              this.massiveData = this.massiveData.filter(x=>x.length > 1);
              // console.log(this.massiveData)
              
            },
            err=>console.log(err)
          )
        },
        err=>{
          console.log(err)
        }
      )
    }else{
      this.loading = true;
      this.testService.getTestById(shared).subscribe(
        resp=>{
          if (!resp.public){
            this.loading = false;
            return Swal.fire({
              icon: 'info',
              text: 'Reporte privado',
              showConfirmButton: false,
              timer: 1500
            }).then(
              resp=>{
                this.router.navigate(['']);
              }
            )
          }
          setTimeout( async ()=>{
            let client = await this.userService.getUserByQuery({email:resp.client}).toPromise()
            localStorage.setItem('uid', client._id);
            this.domainService.inirService()
            this.loading = false;
            if (resp.type == 'FORMULARIO'){
              this.viewForm(resp);
            }else{
              this.viewTest(resp);
            }
          }, 1000)
        },
        err=>{
          this.loading = false;
          alert('Link inválido')
        }
      )
    }
  }

  getPages(qty: number){
    return Math.ceil(qty / 7)
  }

  ngAfterViewInit(){

  }

  handleCreateReport(){
    let tags = [];
    this.tests.map(
      test => {
        if (test.type == "FORMULARIO"){
          try{
            if (!this.filterTests.includes(test.completeForm.title)){
              this.filterTests.push(test.completeForm.title);
            }
          }catch(e){

          }
          test.tags.map(
            tag => {
              if (!tags.includes(tag)){
                tags.push(tag);
              }
            }
          )
        }
      }
    )
    this.filterTags = tags;
    $('#createReportModal').modal('show');
  }


  generateFormReport(){
    let tests = [];
    this.tests.map(
      test => {
        if (test.type == "FORMULARIO" && test.isCompleted){
          if (this.filteredTags.length == 0 || this.filteredTags[0] == 'Sin etiqueta'){
            try{
              if (this.filterTest == test.completeForm.title){
                tests.push(test);
              }
            }catch(e){

            }
          }else{

            let inlcuded = false;
            for (let tag of this.filteredTags){
              test.tags.map(
                t => {
                  if (t.name == tag){
                    inlcuded = true;
                  }
                }
              )
            }
            if (inlcuded){
              try{
                if (this.filterTest == test.completeForm.title){
                  tests.push(test);
                }
              }catch(e){
  
              }
            }
          }
        }
      }
    )
    // if (this.startDateFilter){
    //   tests = tests.filter(
    //     x=>{
    //       let date = new Date(x.completeDate);
    //       return date.getTime() >= new Date(this.startDateFilter).getTime();
    //     }
    //   )
    // }
    // if (this.endDateFilter){
    //   tests = tests.filter(
    //     x=>{
    //       let date = new Date(x.completeDate);
    //       return date.getTime() <= new Date(this.endDateFilter).getTime();
    //     }
    //   )
    // }
    // if (this.aprovedFilter){
    //   tests = tests.filter(
    //     x=>{
    //       if (x.formScore >= x.completeForm.aprovationScore){
    //         return true;
    //       }
    //     }
    //   )
    // }
    this.testsForReport = tests;
    if (this.testsForReport.length == 0){
      return Swal.fire({
        icon: 'info',
        text: 'No hay formularios para generar reporte',
      })
    }else{
      this.selectedType = "FORMULARIOREPORT";
      $('#createReportModal').modal('hide');
      this.viewTest(this.testsForReport[0]);
    }
  }



  reloadTest(test){

    Swal.fire({
      text:"¿Reiniciar test para este usuario?",
      showCancelButton:true
    }).then(async result=>{
      if(result.isConfirmed){
        let backups = await this.testService.getTestBackups({testId: test._id}).toPromise();
        if (backups.length > 0){
          let deleteBackup =  await Swal.fire({
            text:"¿Restaurar desde punto de guardado?",
            showCancelButton:true,
            showDenyButton:true,
            confirmButtonText: 'Restaurar',
            cancelButtonText: 'Reiniciar y borrar respuestas guardadas',
            denyButtonText: 'Cancelar',
            allowOutsideClick: false,
            customClass: {
              confirmButton: 'w-100',
              cancelButton: 'w-100',
              denyButton: 'w-100'
            }
          })
          if (deleteBackup.isDenied){
            return
          }
          if (!deleteBackup.isConfirmed){
            let backup = backups[0];
            this.testService.deleteTestBackup(backup._id).subscribe()
          }
        }
        var testData = test;
        testData.isStarted = false;
        this.testService.updateTest(testData).subscribe(
          resp=>{
            window.location.reload();
          },
          err=>console.log(err)
        )

      }

    })
  }

  changeVisibility(test){

    Swal.fire({
      text:"¿Cambiar visibilidad del reporte?",
      showCancelButton:true
    }).then(result=>{

      if(result.isConfirmed){
        var testData = test;
        testData.public = !testData.public;
        this.testService.updateTest(testData, false).subscribe(
          resp=>{
            window.location.reload();
          },
          err=>console.log(err)
        )

      }

    })
  }

  trash(test){
    var text;
    if(test.trash) text = "¿Restaurar?";
    else text = "¿Enviar a la papelera?";  
    Swal.fire({
      text:text,
      showCancelButton:true
    }).then(result=>{

      if(result.isConfirmed){
        var testData = {
          _id:test._id,
          evaluatedName:test.evaluatedName,
          client:test.client,
          type:test.type,
          trash:!test.trash
        }
        this.testService.updateTest(testData).subscribe(
          resp=>{
            window.location.reload();
          },
          err=>console.log(err)
        )
      }
    })
  }

  showTrash(){
    this.inTrash = true;
    this.tests = [];
    this.userService.getUser().subscribe(
      resp=>{
        this.user = resp;
        this.testService.getClientTests(resp.email).subscribe(
          resp=>{
            resp.map(
              x=>{
                if (x.trash){
                  this.tests.push(x);
                }
              }
            )
            
          },
          err=>console.log(err)
        )
      },
      err=>{
        console.log(err)
      }
    )
  }


  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.setAttribute("style", "background-color:white")
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "#FFF";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/jpeg");
        resolve(dataURL);
      };
      img.onerror = error => {
        reject(error);
      };
      img.src = url;
    });
  }

  public async generatePdf(){
    this.percentCompleted = 0;
    this.isExporting = true;
    let logoUrl = this.domainService.logoUrl || 'https://i.imgur.com/EFIjUdn.png';
    if(this.documentReady){
      
      $('#exportingModal').modal('show');


      if (this.selectedType=="FORMULARIOREPORT"){
        scrollTo(1,0);

        let interpretations = [];
        let index = 0;
        for (let field of this.testData.formModel){
          let title = {
            text: `${index + 1} - ${field.text}`,
            bold: true,
            alignment: 'justify',
            margin: [0, 0, 0, 5]
          }
          interpretations.push(title);

          index++
        }

        let testsRows = []
        for (let test of this.testsForReport){
          let row = [
            test.evaluatedName,
            new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate'),
            test.formScore,
            test.completeForm.aprovationScore <= test.formScore ? 'Aprobado' : 'NO aprobado',
          ]
          testsRows.push(row);
        }

        let doc = {
          info:{
            title:`${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          pageMargins: [ 40, 70, 40, 60 ],
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          content:[
            {
              text: `Reporte ${this.testData.completeForm.title}`,
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', 'Fecha' , 'Puntaje', 'Estado'],
                  ...testsRows
                ]
              },
              margin:[0, 0, 0, 20],
              
            },
            {
              text:'GUÍA DE FORMULARIO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            interpretations,

          ]
        }
        pdfMake.createPdf(doc).download(`${this.testData.completeForm.title}_report.pdf`);
        
      }



      if (this.selectedType=="FORMULARIO"){
        scrollTo(1,0);
        let interpretations = [];
        let index = 0;
        for (let field of this.testData.formModel){
          let title = {
            text: `${index + 1} - ${field.text} ${this.getQuestionScore(index)}`,
            bold: true,
            alignment: 'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(title);
          let description = {
            text:this.getTextResponse(this.testData.formData[index]),
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(description);
          index++
        }


        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          pageMargins: [ 40, 70, 40, 60 ],
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          content:[
            {
              text: this.testData.completeForm.title,
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                  ['Puntaje de aprobación: ', this.testData.completeForm.aprovationScore],
                  ['Resultado: ', this.testData.formScore],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            interpretations,

          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.testData.completeForm.title}_report.pdf`);
        
      }


      if (this.selectedType=="16PF"){
        scrollTo(1,0);
        let interpretations = [];
        let answers = [];
        for (let i of this.pf16Array){
          let title = {
            text: i.title,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(title);
          let description = {
            text:i.desc,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(description);
        }
        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let obj = `Respuesta ${i}: ${a}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          pageMargins: [ 40, 70, 40, 60 ],
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          content:[
            {
              text: 'Test 16 PF',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.pfReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              text:`Factor de distorsión D:  ${this.report.score.D}` ,
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              image:await (await html2canvas(document.querySelector("#pfChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'PERFIL INTERPRETATIVO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            interpretations,
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      if (this.selectedType=="ZAVIC"){
        scrollTo(1,0);
        let interpretations = [];
        let interpretations1 = [];
        let answers = [];
        for (let i of this.zavicArray){
          let title = {
            text: i.title,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(title);
          let description = {
            text:i.desc,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(description);
        }
        for (let i of this.zavicArray1){
          let title = {
            text: i.title,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let description = {
            text:i.desc,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let obj = `Respuesta ${i}: A-${a[1]} B-${a[2]} C-${a[3]} D-${a[4]} `;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5&&aux.length>0){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            if (aux.length>0) answers.push(aux);
          }
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          pageMargins: [ 40, 70, 40, 60 ],

          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          content:[
            {
              text: 'Test Zavic',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.zavicReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              image:await (await html2canvas(document.querySelector("#zavicChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20],
            },
            {
              text:'PERFIL INTERPRETATIVO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              text:'VALORES',
              style:'header',
              margin: [0, 0, 0, 20]
            },
            interpretations,
            {
              text:'INTERESES',
              style:'header',
              margin: [0, 0, 0, 20]
            },
            interpretations1,
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      if (this.selectedType=="CLEAVER"){
        scrollTo(1,0);
        let answers = [];
        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let str="";
          for (let resp in a){
            if(a[resp]==1) str = str.concat(`${resp}= Más \n`);
          }
          for (let resp in a){
            if(a[resp]==2) str = str.concat(`${resp}= Menos`);
          }
          let obj = `Respuesta Nº${i} \n ${str}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5&&aux.length>0){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            if (aux.length>0) answers.push(aux);
          }
        }

        let invalidSection = [
          
        ]

        if (!this.isCleaverValid){
          invalidSection = [
            {
              image:(await html2canvas(document.querySelector("#cleaverInvalidChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:550,
              alignment:'center',
              margin: [0, 0, 0, 20],
            },
            {
              image:(await html2canvas(document.querySelector("#cleaverInvalidChart2"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:550,
              alignment:'center',
              margin: [0, 0, 0, 20],
            },
            {
              text:'1. Perfiles Aplanados (Percentil 40-60). No corresponden a la situación real. No tienen una buena riqueza de información. El evaluado podría no haber comprendido adecuadamente la prueba o algunas palabras. No hay información suficiente para poder interpretar de manera adecuada.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },

            {
              text:'2. Aplanamiento en T. Cuando se observa un aplanamiento en la escala T, se interpretarán M y L por separado.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },

            {
              text:'3. Aplanamiento en L. Un aplanamiento en la escala L puede indicar: Confusión debido al estilo de ser del evaluado. La persona se encuentra en una etapa de cambio personal o profesional.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
            {
              text:'4. Aplanamiento en M, T y L. Puede haber confusión o ambivalencia en las respuestas. Posible confusión de conceptos debido a la interpretación de las palabras. El evaluado no sabe cuál opción elegir.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
            {
              text:'5. Aplanamiento en M. No sabe cómo quisiera ser o cómo debe ser en determinadas situaciones.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
            {
              text:'6. Escalas por encima del Percentil 50 en M, L y/o T. Esto podría reflejar una angustia o un alto nivel de estrés en el evaluado.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
            {
              text:'7. Escalas por debajo del Percentil 50. El evaluado puede haber experimentado presión durante la prueba.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
          ]
        }

        let formAnswers = [];
        let index = 1;
        let aux2 = [];
        for (let a of this.selectedTest.cleaverHfResult){
          let str=`Número ${index} ${this.hrFormData[index - 1].factor}: ${a}`;
          
          if (index % 4 != 0) aux2.push(str);
          else{
            aux2.push(str);
            formAnswers.push(aux2);
            aux2 = [];
          }
          index++;
        }

        let humanFactorSection = []
        if (this.selectedTest.useCleaverHF){
          humanFactorSection = [
            {
              text:'FACTOR HUMANO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              text:this.hfHtml.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'Perfil solicitado',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              table:{
                headerRows:1,
                body:[
                  ["", "Puntaje crudo R", "Promedio A", "Desviación D (R - A)", "D% (X - D)", "Puntaje D% -50"],
                  ["D",this.hfR.d, (this.hfR.d + this.hfR.i + this.hfR.s + this.hfR.c) / 4, this.hfD.d, this.hfDP.d, this.hf.d],
                  ["I",this.hfR.i, (this.hfR.d + this.hfR.i + this.hfR.s + this.hfR.c) / 4, this.hfD.i, this.hfDP.i, this.hf.i],
                  ["S",this.hfR.s, (this.hfR.d + this.hfR.i + this.hfR.s + this.hfR.c) / 4, this.hfD.s, this.hfDP.s, this.hf.s],
                  ["C",this.hfR.c, (this.hfR.d + this.hfR.i + this.hfR.s + this.hfR.c) / 4, this.hfD.c, this.hfDP.c, this.hf.c],
                ]
              }
            },
            {
              image:(await html2canvas(document.querySelector("#cleaverChartHf"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:225,
              alignment:'center',
              margin: [0, 20, 0, 20],
            },
            {
              text: `Perfil solicitado: ${this.hfProfile}`,
              style:'header',
              margin: [0, 0, 0, 20]
            },
            {
              text: this.hfProfile == this.evaluatedHfProfile ? 'El perfil del evaluado coincide con el perfil solicitado' : 'El perfil del evaluado no coincide con el perfil solicitado',
              style:'header',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.hfProfileHtml.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'Escalas del perfil solicitado: Descripción del puesto',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
            },
            {
              table:{
                body:formAnswers
              }
            }
          ]
        }


        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],



          content:[
            {
              text: 'Test Cleaver',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'INTRODUCCIÓN',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              text:this.cleaverReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'VALIDEZ',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              text:'La sumatoria de los resultados de T debe estar entre -3 y +3. Si esto no ocurre los resultados no pueden considerarse válidos.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
            {
              text:'¿Qué hacer cuando es inválida?',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
            {
              text:'Se recomienda volver a aplicar la prueba, asegurándose de que la persona haya comprendido correctamente las instrucciones y el significado de todas las palabras incluidas. El sistema ofrece definiciones disponibles durante la evaluación, para que el evaluado pueda consultarlas en caso de duda.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
            {
              text:'Si después de 3 aplicaciones sigue resultando inválida, se sugiere usar otro instrumento de medición. La caducidad de esta prueba es de 6 meses a partir de la fecha de aplicación.',
              alignment:'justify',
              margin: [0, 0, 0, 10]
            },
            {
              text:this.isCleaverValid ? 'La prueba es válida' : 'No tomes en cuenta perfiles de este tipo. Recuérdale al candidato que debe disponer de tiempo y un ambiente tranquilo para pruebas.',
              alignment:'justify',
              bold:true,
              margin: [0, 0, 0, 10]
            },

            ...invalidSection,

            ...humanFactorSection,
          

            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              image:await (await html2canvas(document.querySelector("#cleaverChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:550,
              alignment:'center',
              margin: [0, 0, 0, 20],
            },
            {
              text:'RESULTADOS PRUEBA CLEAVER',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              table:{
                headerRows:1,
                body:[
                  ["Estado", "D", "I", "S", "C"],
                  ["M",this.cleaverOriginalScores.m.d, this.cleaverOriginalScores.m.i, this.cleaverOriginalScores.m.s, this.cleaverOriginalScores.m.c],
                  ["L",this.cleaverOriginalScores.l.d, this.cleaverOriginalScores.l.i, this.cleaverOriginalScores.l.s, this.cleaverOriginalScores.l.c],
                  ["TOT",this.cleaverOriginalScores.t.d, this.cleaverOriginalScores.t.i, this.cleaverOriginalScores.t.s, this.cleaverOriginalScores.t.c]
                ]
              }
            },
            {
              text:'TABLA DE EQUIVALENCIAS CLEAVER',
              style:'header',
              bold:true,
              margin: [0, 20, 0, 20]
            },
            {
              table:{
                headerRows:1,
                body:[
                  ["Estado", "D", "I", "S", "C"],
                  ["M",Math.round(this.cleaverScores.m.d), Math.round(this.cleaverScores.m.i), Math.round(this.cleaverScores.m.s), Math.round(this.cleaverScores.m.c)],
                  ["L",Math.round(this.cleaverScores.l.d), Math.round(this.cleaverScores.l.i), Math.round(this.cleaverScores.l.s), Math.round(this.cleaverScores.l.c)],
                  ["TOT",Math.round(this.cleaverScores.t.d), Math.round(this.cleaverScores.t.i), Math.round(this.cleaverScores.t.s), Math.round(this.cleaverScores.t.c)]
                ]
              }
            },
            {
              text:'PERFIL INTERPRETATIVO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              text:'Estado normal',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              text:this.normalHtml.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:"Estilo personal", italics:true, margin:[0,20,0,10]
            },
            {
              table:{
                body:[
                  ["D",this.cleaverNormal.personal.d],
                  ["I",this.cleaverNormal.personal.i],
                  ["S",this.cleaverNormal.personal.s],
                  ["C",this.cleaverNormal.personal.c],
                ]
              }
            },
            {
              text:"Conductas", italics:true, margin:[0,20,0,10]
            },
            {
              table:{
                body:[
                  [`${this.cleaverNormal.behavior.combination.toUpperCase()} - ${this.cleaverNormal.behavior.title}`,this.cleaverNormal.behavior.description],
                  [`${this.cleaverNormal.max.tag.toUpperCase()} - ${this.cleaverNormal.max.title}`,this.cleaverNormal.max.description],
                  [`${this.cleaverNormal.min.tag.toUpperCase()} - ${this.cleaverNormal.min.title}`,this.cleaverNormal.min.description],
 
                ]
              }
            },
            {
              text:'Estado motivado',
              style:'header',
              bold:true,
              margin: [0, 20, 0, 20]
            },
            {
              text:this.motivatedHtml.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:"Estilo personal", italics:true, margin:[0,20,0,10]
            },
            {
              table:{
                body:[
                  ["D",this.cleaverMotivated.personal.d],
                  ["I",this.cleaverMotivated.personal.i],
                  ["S",this.cleaverMotivated.personal.s],
                  ["C",this.cleaverMotivated.personal.c],
                ]
              }
            },
            {
              text:"Conductas", italics:true, margin:[0,20,0,10]
            },
            {
              table:{
                body:[
                  [`${this.cleaverMotivated.behavior.combination.toUpperCase()} - ${this.cleaverMotivated.behavior.title}`,this.cleaverMotivated.behavior.description],
                  [
                    `${this.cleaverMotivated.max.tag.toUpperCase()} - ${this.cleaverMotivated.max.title}`,
                    {
                      columns:[
                        'Desea: \n'+this.cleaverMotivated.max.wish,
                        "Necesita: \n"+ this.cleaverMotivated.max.require
                      ]
                    }
                  ],
                  [
                    `${this.cleaverMotivated.min.tag.toUpperCase()} - ${this.cleaverMotivated.min.title}`,
                    {
                      columns:[
                        'Desea: \n'+this.cleaverMotivated.min.wish,
                        "Necesita: \n"+ this.cleaverMotivated.min.require
                      ]
                    } 
                  ]
                ]
              }
            },
            {
              text:'Estado bajo presión',
              style:'header',
              bold:true,
              margin: [0, 20, 0, 20]
            },
            {
              text:this.stressHtml.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:"Estilo personal", italics:true, margin:[0,20,0,10]
            },
            {
              table:{
                body:[
                  ["D",this.cleaverPresion.personal.d],
                  ["I",this.cleaverPresion.personal.i],
                  ["S",this.cleaverPresion.personal.s],
                  ["C",this.cleaverPresion.personal.c],
                ]
              }
            },
            {
              text:"Conductas", italics:true, margin:[0,20,0,10]
            },
            {
              table:{
                body:[
                  [`${this.cleaverPresion.behavior.combination.toUpperCase()} - ${this.cleaverPresion.behavior.title}`,this.cleaverPresion.behavior.description],
                  [`${this.cleaverPresion.max.tag.toUpperCase()} - ${this.cleaverPresion.max.title}`,this.cleaverPresion.max.description],
                  [`${this.cleaverPresion.min.tag.toUpperCase()} - ${this.cleaverPresion.min.title}`,this.cleaverPresion.min.description],
 
                ]
              }
            },
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      if (this.selectedType=="ALL PORT"){
        scrollTo(1,0);
        let interpretations = [];
        let answers = [];
        let answers2 = [];
        for (let i of this.allPortArray){
          let title = {
            text: i.title,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(title);
          let description = {
            text:i.desc,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(description);
        }

        let i = 1;
        let aux = [];
        for (let r of this.answers1AllPort){
          let obj = {
            text:"",
            fontSize:10
          };
          if ((r[3]==0&&r[4]==0)&&r[1]==3){
            obj.text = `Respuesta Nº${i} \n Totalmente de acuerdo con A`;
          }
          if ((r[3]==0&&r[4]==0)&&r[1]==0){
            obj.text = `Respuesta Nº${i} \n Totalmente de acuerdo con B`;

          }
          if ((r[3]==0&&r[4]==0)&&r[1]==2){
            obj.text = `Respuesta Nº${i} \n Ligera preferencia por A`;

          }
          if ((r[3]==0&&r[4]==0)&&r[1]==1){
            obj.text = `Respuesta Nº${i} \n Ligera preferencia por B`;

          }
          
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          // if ((i-1)==this.answers1AllPort.length) {
          //   if (aux.length<5&&aux.length>0){
          //     let j = 5-aux.length;
          //     for(let k=0; k<j; k++){
          //       aux.push([]);
          //     }
          //   }
          //   if (aux.length>0) answers.push(aux);
          // }
        }

        for (let r of this.answers2AllPort){
          let obj = {
            text:`Respuesta Nº${i}\n A:${r[1]} - B:${r[2]} - C:${r[3]} - D:${r[3]}`,
            fontSize:10
          };         
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers2.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.answers2AllPort.length) {
            if (aux.length<5&&aux.length>0){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            if (aux.length>0) answers2.push(aux);
          }
        }

        let table = [];
        for (let v of this.allPortArray){
          let level;
          if(v.color=="red") level = "Bajo";
          if(v.color=="yellow") level = "Medio";
          if(v.color=="green") level = "Alto";
          let row = [v.title, v.value, level];
          table.push(row);
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],

          content:[
            {
              text: 'Test AllPort',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.allPortReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'AUTODESCRIPCIÓN Y METAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Es una persona que se considera como: ', this.report.form[1]],
                  ['Siente gran aprecio por: ', this.report.form[2]],
                  ['Lo que mas le disgusta: ', this.report.form[3]],
                  ['Tiene como metas personales: ', this.report.form[4]],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              image:await (await html2canvas(document.querySelector("#allPortChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20],
            },
            {
              text:'TABLA DE PERFIL',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:table
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'PERFIL INTERPRETATIVO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            interpretations,
            {
              text:'LISTADO DE RESPUESTASCUESTIONARIO 1',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            },
            {
              text:'LISTADO DE RESPUESTASCUESTIONARIO 2',
              style:'header',
              bold:true,
              margin: [0, 20, 0, 20],
            },
            {
              table:{
                body:answers2
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      if (this.selectedType=="KOSTIK"){
        scrollTo(1,0);
        let interpretations = [];
        let answers = [];
        interpretations.push({text:'FACTOR: Modo de vida', margin:[0,20,0,0], bold:true});
        let obj = {
          table:{
            body:[
              ['Dimensión', 'Puntaje', 'Interpretación']
            ]
          }
        }
        for (let i of this.modoDeVidaArray){
          let aux = [];
          aux.push(i.dimension);
          aux.push(i.score);
          aux.push(i.description);
          obj.table.body.push(aux);
        }
        interpretations.push(obj);

        interpretations.push({text:'FACTOR: Naturaleza social', margin:[0,20,0,0], bold:true});
        obj = {
          table:{
            body:[
              ['Dimensión', 'Puntaje', 'Interpretación']
            ]
          }
        }
        for (let i of this.naturalezaSocialArray){
          let aux = [];
          aux.push(i.dimension);
          aux.push(i.score);
          aux.push(i.description);
          obj.table.body.push(aux);
        }
        interpretations.push(obj);

        interpretations.push({text:'FACTOR: Adaptación al trabajo', margin:[0,20,0,0], bold:true});
        obj = {
          table:{
            body:[
              ['Dimensión', 'Puntaje', 'Interpretación']
            ]
          }
        }
        for (let i of this.adaptacionAlTrabajoArray){
          let aux = [];
          aux.push(i.dimension);
          aux.push(i.score);
          aux.push(i.description);
          obj.table.body.push(aux);
        }
        interpretations.push(obj);

        interpretations.push({text:'FACTOR: Naturaleza emocional', margin:[0,20,0,0], bold:true});
        obj = {
          table:{
            body:[
              ['Dimensión', 'Puntaje', 'Interpretación']
            ]
          }
        }
        for (let i of this.naturalezaEmocionalArray){
          let aux = [];
          aux.push(i.dimension);
          aux.push(i.score);
          aux.push(i.description);
          obj.table.body.push(aux);
        }
        interpretations.push(obj);

        interpretations.push({text:'FACTOR: Subordinación', margin:[0,20,0,0], bold:true});
        obj = {
          table:{
            body:[
              ['Dimensión', 'Puntaje', 'Interpretación']
            ]
          }
        }
        for (let i of this.subordinacionArray){
          let aux = [];
          aux.push(i.dimension);
          aux.push(i.score);
          aux.push(i.description);
          obj.table.body.push(aux);
        }
        interpretations.push(obj);

        interpretations.push({text:'FACTOR: Grado de energía', margin:[0,20,0,0], bold:true});
        obj = {
          table:{
            body:[
              ['Dimensión', 'Puntaje', 'Interpretación']
            ]
          }
        }
        for (let i of this.gradoDeEnergiaArray){
          let aux = [];
          aux.push(i.dimension);
          aux.push(i.score);
          aux.push(i.description);
          obj.table.body.push(aux);
        }
        interpretations.push(obj);

        interpretations.push({text:'FACTOR: Liderazgo', margin:[0,20,0,0], bold:true});
        obj = {
          table:{
            body:[
              ['Dimensión', 'Puntaje', 'Interpretación']
            ]
          }
        }
        for (let i of this.liderazgoArray){
          let aux = [];
          aux.push(i.dimension);
          aux.push(i.score);
          aux.push(i.description);
          obj.table.body.push(aux);
        }
        interpretations.push(obj);


        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let resp = a=='opcA'?'A':'B';
          let obj = `Respuesta Nº${i}:\n ${resp}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],

          content:[
            {
              text: 'Test Kostick',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.kostikReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO DE NECESIDADES',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              image:await (await html2canvas(document.querySelector("#kostickChart1"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO DE PAPELES O ROLES',
              style:'header',
              bold:true,
              margin: [0, 20, 0, 20],
            },
            {
              image:await (await html2canvas(document.querySelector("#kostickChart2"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO DE NECESIDADES Y ROLES',
              style:'header',
              bold:true,
              margin: [0, 20, 0, 20],
            },
            {
              image:await (await html2canvas(document.querySelector("#kostickChart3"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO DE LOS SIETE FACTORES',
              style:'header',
              bold:true,
              margin: [0, 20, 0, 20],
            },
            {
              image:await (await html2canvas(document.querySelector("#kostickChart4"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'INTERPRETACIÓN DE DIMENSIONES Y FACTORES',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            interpretations,
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      if (this.selectedType=="BARSIC"){
        scrollTo(1,0);
        let interpretations = [];
        let answers = [];
        interpretations.push({text:'Valores obtenidos', margin:[0,20,0,0], bold:true});
        let total = this.barsicScores.razonamientoNumerico+this.barsicScores.razonamientoLogico+this.barsicScores.comprensionDeVocabulario+this.barsicScores.razonamientoVerbal+this.barsicScores.informacion;
        let obj = {
          table:{
            body:[
              ['Serie', 'Aciertos'],
              ['Información', this.barsicScores.informacion],
              ['Razonamiento verbal', this.barsicScores.razonamientoVerbal],
              ['Comprensión de vocabulario', this.barsicScores.comprensionDeVocabulario],
              ['Razonamiento lógico', this.barsicScores.razonamientoLogico],
              ['Razonamiento numérico', this.barsicScores.razonamientoNumerico],
              [{text:'Total', bold:true}, {text:`${total} de 60`, bold:true}],
            ]
          }
          
        }
        interpretations.push(obj);
        interpretations.push({text:`Escolaridad: ${this.report.scholarship.toUpperCase()} - Rango: ${this.barsicRange}`, margin:[0,20,0,0]});
        interpretations.push({
          text:'PERFIL INTERPRETATIVO',
          style:'header',
          bold:true,
          margin: [0, 20, 0, 20],
          pageBreak:'before'
        })
        for (let i of this.barsicArray){
          let title = {
            text: i.title,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(title);
          let description = {
            text:i.desc,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations.push(description);
        }

        let i = 1;
        let aux = [];
        for (let a of this.report.answers){

          let obj = `Respuesta Nº${i}:\n ${a}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],

          content:[
            {
              text: 'Test Barsit',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.barsicReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              image:await (await html2canvas(document.querySelector("#barsicChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20]
            },
            interpretations,
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      if (this.selectedType=="IPV"){
        scrollTo(1,0);
        let interpretations = [];
        let interpretations1 = [];
        let answers = [];
        for (let i of this.ipvArray){
          let title = {
            text: i.title,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let description = {
            text:i.desc,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        let obj = {
          table:{
            body:[
              ['Descripción', 'Escala', 'PN', 'PE', 'Calificación'],
              ['Disposición general a la venta', "DGV", this.report.directScore.DGV, this.report.naturalScore.DGV, this.report.naturalScore.DGV<5?'Bajo':this.report.naturalScore.DGV>6?'Alto':'Promedio'],
              ['Receptividad', 'R', this.report.directScore.R, this.report.naturalScore.R, this.report.naturalScore.R<5?'Bajo':this.report.naturalScore.R>6?'Alto':'Promedio'],
              ['Agresividad', 'A', this.report.directScore.A, this.report.naturalScore.A, this.report.naturalScore.A<5?'Bajo':this.report.naturalScore.A>6?'Alto':'Promedio'],
              ['Comprensión', 'I', this.report.directScore.I, this.report.naturalScore.I, this.report.naturalScore.I<5?'Bajo':this.report.naturalScore.I>6?'Alto':'Promedio'],
              ['Adaptabilidad', 'II', this.report.directScore.II, this.report.naturalScore.II, this.report.naturalScore.II<5?'Bajo':this.report.naturalScore.II>6?'Alto':'Promedio'],
              ['Control de sí mismo', 'III', this.report.directScore.III, this.report.naturalScore.III, this.report.naturalScore.III<5?'Bajo':this.report.naturalScore.III>6?'Alto':'Promedio'],
              ['Tolerancia a la frustración', 'IV', this.report.directScore.IV, this.report.naturalScore.IV, this.report.naturalScore.IV<5?'Bajo':this.report.naturalScore.IV>6?'Alto':'Promedio'],
              ['Combatividad', 'V', this.report.directScore.V, this.report.naturalScore.V, this.report.naturalScore.V<5?'Bajo':this.report.naturalScore.V>6?'Alto':'Promedio'],
              ['Dominio', 'VI', this.report.directScore.VI, this.report.naturalScore.VI, this.report.naturalScore.VI<5?'Bajo':this.report.naturalScore.VI>6?'Alto':'Promedio'],
              ['Seguridad', 'VII', this.report.directScore.VII, this.report.naturalScore.VII, this.report.naturalScore.VII<5?'Bajo':this.report.naturalScore.VII>6?'Alto':'Promedio'],
              ['Actividad', 'VIII', this.report.directScore.VIII, this.report.naturalScore.VIII, this.report.naturalScore.VIII<5?'Bajo':this.report.naturalScore.VIII>6?'Alto':'Promedio'],
              ['Sociabilidad', 'IX', this.report.directScore.IX, this.report.naturalScore.IX, this.report.naturalScore.IX<5?'Bajo':this.report.naturalScore.IX>6?'Alto':'Promedio'],
            ]
          }
        }
         interpretations.push(obj);

        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let resp = a;
          let obj = `Respuesta Nº${i}:\n ${resp}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageMargins: [ 40, 70, 40, 60 ],

          pageSize:'A4',
          content:[
            {
              text: 'Test IPV',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.ipvReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              image:await (await html2canvas(document.querySelector("#ipvChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'TABLA INTERPRETATIVA',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            interpretations,
            {
              text:'PERFIL INTERPRETATIVO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            interpretations1,
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      if (this.selectedType=="TERMAN"){
        scrollTo(1,0);

        let interpretations1 = [];
        let answers = [];
        for (let i of this.termanDescriptionsArray){
          let title = {
            text: i.title,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let description = {
            text:i.desc,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        let rows = [['Serie', 'Categoría', 'Puntuación', 'Rango']];
        for (let r of this.termanArray){
          let obj = [];
          obj[0] = r.serie; 
          obj[1] = r.category; 
          obj[2] = r.score; 
          obj[3] = r.rank;
          rows.push(obj);
        }
        let interpretations = [{
          table:{
            body:rows
          }
        }];
        let i = 1;
        let aux = [];
        for (let a of this.termanAnswers){
          let resp = a;
          let obj = `Respuesta Nº${i}:\n ${resp}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.termanAnswers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],

          content:[
            {
              text: 'Test Terman - Merril',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.termanReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            `Puntos totales: ${this.termanScore}`,
            `Coeficiente intelectual: ${this.termanIq}`,
            `Rango: ${this.termanRank}`,
            `Capacidad de aprendizaje: ${this.termanCa}`,
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              image:await (await html2canvas(document.querySelector("#termanChart"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'Perfil',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            interpretations,
            {
              text:'PERFIL INTERPRETATIVO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            interpretations1,
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }


      if (this.selectedType=="MMPI2"){ //MMPI2
        scrollTo(1,0);
        let answers = [];
        
        let interpretations1 = [];
        let validez = this.filterScales(this.mmpi2Array, 'Validez');
        let clinicas = this.filterScales(this.mmpi2Array, 'Clínicas');
        let contenido = this.filterScales(this.mmpi2Array, 'Contenido');
        let lingoesD = this.filterScales(this.mmpi2Array, 'Lingoes', 'D');
        let lingoesHy = this.filterScales(this.mmpi2Array, 'Lingoes', 'HY');
        let lingoesPd = this.filterScales(this.mmpi2Array, 'Lingoes', 'PD');
        let lingoesPa = this.filterScales(this.mmpi2Array, 'Lingoes', 'PA');
        let lingoesSc = this.filterScales(this.mmpi2Array, 'Lingoes', 'SC');
        let lingoesMa = this.filterScales(this.mmpi2Array, 'Lingoes', 'MA');
        let lingoesSi = this.filterScales(this.mmpi2Array, 'Lingoes', 'SI');
        let cg = this.filterScales(this.mmpi2Array, 'Suplementarias', 'cg');
        let me = this.filterScales(this.mmpi2Array, 'Suplementarias', 'me');
        let dc = this.filterScales(this.mmpi2Array, 'Suplementarias', 'dc');
        let rg = this.filterScales(this.mmpi2Array, 'Suplementarias', 'rg');

        interpretations1.push({
          text: "ESCALAS DE VALIDEZ",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of validez){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        interpretations1.push({
          text: "ESCALAS CLÍNICAS",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of clinicas){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        if (this.selectedTest.extra!='Abreviado'){
          interpretations1.push({
            text: "ESCALAS DE CONTENIDO",
            bold: true,
            margin: [0, 0, 0, 20]
          })
          for (let i of contenido){
            let title = {
              text: i.title,
              bold: true,
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(title);
            let text = i.desc.replace(/<[^>]*>/g, '');
            text = text.replace('&nbsp;', " ");
            let description = {
              text:text,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(description);
          }

          interpretations1.push({
            text: "ESCALAS SUPLEMENTARIAS",
            bold: true,
            margin: [0, 0, 0, 20]
          })
          for (let i of cg){
            let title = {
              text: i.title,
              bold: true,
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(title);
            let text = i.desc.replace(/<[^>]*>/g, '');
            text = text.replace('&nbsp;', " ");
            let description = {
              text:text,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(description);
          }
          for (let i of me){
            let title = {
              text: i.title,
              bold: true,
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(title);
            let text = i.desc.replace(/<[^>]*>/g, '');
            text = text.replace('&nbsp;', " ");
            let description = {
              text:text,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(description);
          }
          for (let i of dc){
            let title = {
              text: i.title,
              bold: true,
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(title);
            let text = i.desc.replace(/<[^>]*>/g, '');
            text = text.replace('&nbsp;', " ");
            let description = {
              text:text,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(description);
          }
          for (let i of rg){
            let title = {
              text: i.title,
              bold: true,
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(title);
            let text = i.desc.replace(/<[^>]*>/g, '');
            text = text.replace('&nbsp;', " ");
            let description = {
              text:text,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(description);
          }

        }

        interpretations1.push({
          text: "SUBESCALAS CLÍNICAS DE HARRIS-LINGOES",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of lingoesD){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesHy){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesPd){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesPa){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesSc){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesMa){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesSi){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let resp = a;
          let obj = `Nº${i}:\n ${resp==null?'No sé':resp?'Verdadero':'Falso'}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let answers2 = [];
        i = 1;
        aux = [];
        for (let a of this.mmpi2NullAnswers){
          let resp = a;
          let obj = `Respuesta Nº${i}:\n ${this.mmpi2Questions[i].text}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers2.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.mmpi2NullAnswers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers2.push(aux);
          }
        }

        let validacion = [];
        if (this.selectedTest.extra=='Abreviado'){
          validacion = [
            `Sin responder: ${this.mmpi2Results['?'].value}`,
            `Incoherencia: ${this.mmpi2Results['F'].value}`,
            `Mentira: ${this.mmpi2Results['L'].value}`,
            `Correción: ${this.mmpi2Results['K'].value}`,
          ]
        }else{
          validacion = [
            `Sin responder: ${this.mmpi2Results['?'].value}`,
            `Incoherencia: ${this.mmpi2Results['F'].value}`,
            `Incoherencia posterior: ${this.mmpi2Results['FB'].value}`,
            `Mentira: ${this.mmpi2Results['L'].value}`,
            `Correción: ${this.mmpi2Results['K'].value}`,
          ]
        }
        let charts = [];
        if (this.selectedTest.extra=='Abreviado'){
          let obj = {
            image:(await html2canvas(document.querySelector("#pfChart1"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          }
          charts.push(obj);
        }else{
          let obj = {
            image:(await html2canvas(document.querySelector("#pfChart1"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          }
          charts.push('ESCALAS BÁSICAS (VALIDEZ + CLÍNICAS)');
          charts.push(obj);
          obj = {
            image:(await html2canvas(document.querySelector("#pfChart2"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          };
          charts.push({
            text:'ESCALAS DE CONTENIDO',
            pageBreak:'before'
        });
          charts.push(obj);
          obj = {
            image:(await html2canvas(document.querySelector("#pfChart3"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20],
          };
          charts.push({
            text:'ESCALAS SUPLEMENTARIAS',
            pageBreak:'before'
          });
          charts.push(obj);
          obj = {
            image:await (await html2canvas(document.querySelector("#pfChart4"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          };
          charts.push({
            text:'SUBESCALAS CLÍNICAS DE HARRIS-LINGOES',
            pageBreak:'before'
        });
          charts.push(obj);
        }
        let interpretations = [];
        validez = this.filterScales(this.mmpi2Results, 'Validez');
        clinicas = this.filterScales(this.mmpi2Results, 'Clínicas');
        lingoesD = this.filterScales(this.mmpi2Results, 'Lingoes', 'D');
        lingoesHy = this.filterScales(this.mmpi2Results, 'Lingoes', 'HY');
        lingoesPd = this.filterScales(this.mmpi2Results, 'Lingoes', 'PD');
        lingoesPa = this.filterScales(this.mmpi2Results, 'Lingoes', 'PA');
        lingoesSc = this.filterScales(this.mmpi2Results, 'Lingoes', 'SC');
        lingoesMa = this.filterScales(this.mmpi2Results, 'Lingoes', 'MA');
        lingoesSi = this.filterScales(this.mmpi2Results, 'Lingoes', 'SI');
        let obj = {
          table:{
            body:[
              ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
            ]
          }
        }
        interpretations.push({text:'ESCALAS DE VALIDEZ', margin: [0, 20, 0, 10]});
        validez.map(
          x=>{
            let aux=[];
            aux.push(x.scale);
            aux.push(x.title);
            aux.push(x.pd);
            aux.push(x.value);
            obj.table.body.push(aux);
          }
        )
        interpretations.push(obj)
        obj = {
          table:{
            body:[
              ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
            ]
          }
        }
        interpretations.push({text:'ESCALAS CLINICAS', margin: [0, 20, 0, 10]});
        clinicas.map(
          x=>{
            let aux=[];
            aux.push(x.scale);
            aux.push(x.title);
            aux.push(x.pd);
            aux.push(x.value);
            obj.table.body.push(aux);
          }
        )
        interpretations.push(obj);

        
        if (this.selectedTest.extra!='Abreviado'){

          let contenido = this.filterScales(this.mmpi2Results, 'Contenido');
          cg = this.filterScales(this.mmpi2Results, 'Suplementarias', 'cg');
          me = this.filterScales(this.mmpi2Results, 'Suplementarias', 'me');
          dc = this.filterScales(this.mmpi2Results, 'Suplementarias', 'dc');
          rg = this.filterScales(this.mmpi2Results, 'Suplementarias', 'rg');
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'ESCALAS DE CONTENIDO', margin: [0, 20, 0, 10]});
          contenido.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);

          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'ESCALAS SUPLEMENTARIAS - Características generales de la personalidad', margin: [0, 20, 0, 10]});
          cg.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);

          
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'ESCALAS SUPLEMENTARIAS - Malestar emocional generalizado', margin: [0, 20, 0, 10]});
          me.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);

          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'ESCALAS SUPLEMENTARIAS - Descontrol comportamental', margin: [0, 20, 0, 10]});
          dc.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);

          
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'ESCALAS SUPLEMENTARIAS - Rol de género', margin: [0, 20, 0, 10]});
          rg.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES  - D',margin: [0, 20, 0, 10]});
          lingoesD.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Hy',margin: [0, 20, 0, 10]});
          lingoesHy.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Pd',margin: [0, 20, 0, 10]});
          lingoesPd.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Pa',margin: [0, 20, 0, 10]});
          lingoesPa.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Sc',margin: [0, 20, 0, 10]});
          lingoesSc.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Ma',margin: [0, 20, 0, 10]});
          lingoesMa.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Si',margin: [0, 20, 0, 10]});
          lingoesSi.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
        }else{
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - D',margin: [0, 20, 0, 10]});
          lingoesD.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Hy',margin: [0, 20, 0, 10]});
          lingoesHy.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Pd',margin: [0, 20, 0, 10]});
          lingoesPd.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Pa',margin: [0, 20, 0, 10]});
          lingoesPa.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Sc',margin: [0, 20, 0, 10]});
          lingoesSc.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Ma',margin: [0, 20, 0, 10]});
          lingoesMa.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Si',margin: [0, 20, 0, 10]});
          lingoesSi.map(
            x=>{
              let aux=[];
              aux.push(x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
        }
        let combinationText = this.mmpi2Combination.description.replace(/<[^>]*>/g, '');
        combinationText = combinationText.replace(/&nbsp;/g, ' ');
        this.percentCompleted = 50;
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],

          content:[
            {
              text: 'Test MMPI 2',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.mmpi2Report.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'VALIDACIÓN',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
            },
            validacion,
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            charts
            ,
            {text:'',pageBreak:'after'}
            ,
            interpretations
            ,
            {
              text:'INTERPRETACIÓN TEXTUAL',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            interpretations1,
            {
              text:'TRAZADO DE PERFIL',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              text: `Código: ${this.mmpi2Combination.code} - Perfil ${this.mmpi2Combination.definition}`,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:combinationText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              },
              alignment: 'center',
            },
            {
              text:'LISTADO DE ÍTEMS SIN RESPONDER',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            answers2.length>0?
            {
              table:{
                body:answers2
              },
              alignment: 'center',
            }:{}
          ]
        }
        this.percentCompleted = 100;
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
      }

      if (this.selectedType=="MMPIA"){ //MMPIA
        scrollTo(1,0);
        let answers = [];
        
        let interpretations1 = [];
        let validez = this.filterScalesMMpia(this.mmpiaArray, 'Validez');
        let clinicas = this.filterScalesMMpia(this.mmpiaArray, 'Clínicas');
        let contenido = this.filterScalesMMpia(this.mmpiaArray, 'Contenido');
        let lingoesD = this.filterScalesMMpia(this.mmpiaArray, 'Lingoes', 'D');
        let lingoesHy = this.filterScalesMMpia(this.mmpiaArray, 'Lingoes', 'HI');
        let lingoesPd = this.filterScalesMMpia(this.mmpiaArray, 'Lingoes', 'Dp');
        let lingoesPa = this.filterScalesMMpia(this.mmpiaArray, 'Lingoes', 'PA');
        let lingoesSc = this.filterScalesMMpia(this.mmpiaArray, 'Lingoes', 'Es');
        let lingoesMa = this.filterScalesMMpia(this.mmpiaArray, 'Lingoes', 'MA');
        let lingoesSi = this.filterScalesMMpia(this.mmpiaArray, 'Lingoes', 'Is');
        let cg = this.filterScalesMMpia(this.mmpiaArray, 'Suplementarias');


        interpretations1.push({
          text: "ESCALAS DE VALIDEZ",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of validez){
          let title = {
            text: "A-"+i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        interpretations1.push({
          text: "ESCALAS CLÍNICAS",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of clinicas){
          let title = {
            text:"A-"+ i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        if (this.selectedTest.extra!='Abreviado'){
          interpretations1.push({
            text: "ESCALAS DE CONTENIDO",
            bold: true,
            margin: [0, 0, 0, 20]
          })
          for (let i of contenido){
            let title = {
              text:"A-"+ i.title,
              bold: true,
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(title);
            let text = i.desc.replace(/<[^>]*>/g, '');
            text = text.replace('&nbsp;', " ");
            let description = {
              text:text,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(description);
          }

          interpretations1.push({
            text: "ESCALAS SUPLEMENTARIAS",
            bold: true,
            margin: [0, 0, 0, 20]
          })
          for (let i of cg){
            let title = {
              text:"A-"+ i.title,
              bold: true,
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(title);
            let text = i.desc.replace(/<[^>]*>/g, '');
            text = text.replace('&nbsp;', " ");
            let description = {
              text:text,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            }
            interpretations1.push(description);
          }

        }

        interpretations1.push({
          text: "SUBESCALAS CLÍNICAS DE HARRIS-LINGOES",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of lingoesD){
          let title = {
            text:"A-"+ i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesHy){
          let title = {
            text:"A-"+ i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesPd){
          let title = {
            text:"A-"+ i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesPa){
          let title = {
            text:"A-"+ i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesSc){
          let title = {
            text:"A-"+ i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesMa){
          let title = {
            text:"A-"+ i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }
        for (let i of lingoesSi){
          let title = {
            text:"A-"+ i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let resp = a;
          let obj = `Nº${i}:\n ${resp==null?'No sé':resp?'Verdadero':'Falso'}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let answers2 = [];
        i = 1;
        aux = [];
        if (this.mmpiaNullAnswers.length>0) for (let a of this.mmpiaNullAnswers){
          let resp = a;
          let obj = `Respuesta Nº${i}:\n ${this.mmpiaQuestions[i].text}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers2.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.mmpiaNullAnswers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers2.push(aux);
          }
        }
        let charts = [];
        if (this.selectedTest.extra=='Abreviado'){
          let obj = {
            image:(await html2canvas(document.querySelector("#pfChart1"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          }
          charts.push(obj);
        }else{
          let obj = {
            image:(await html2canvas(document.querySelector("#pfChart1"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          }
          charts.push('ESCALAS BÁSICAS (VALIDEZ + CLÍNICAS)');
          charts.push(obj);
          obj = {
            image:(await html2canvas(document.querySelector("#pfChart2"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          };
          charts.push({
            text:'ESCALAS DE CONTENIDO',
            pageBreak:'before'
        });
          charts.push(obj);
          obj = {
            image:(await html2canvas(document.querySelector("#pfChart3"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20],
          };
          charts.push({
            text:'ESCALAS SUPLEMENTARIAS',
            pageBreak:'before'
          });
          charts.push(obj);
          obj = {
            image:await (await html2canvas(document.querySelector("#pfChart4"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
            width:500,
            alignment:'center',
            margin: [0, 0, 0, 20]
          };
          charts.push({
            text:'SUBESCALAS CLÍNICAS DE HARRIS-LINGOES',
            pageBreak:'before'
        });
          charts.push(obj);
        }
        let interpretations = [];
        validez = this.filterScalesMMpia(this.mmpiaResults, 'Validez');
        clinicas = this.filterScalesMMpia(this.mmpiaResults, 'Clínicas');
        lingoesD = this.filterScalesMMpia(this.mmpiaResults, 'Lingoes', 'D');
        lingoesHy = this.filterScalesMMpia(this.mmpiaResults, 'Lingoes', 'HI');
        lingoesPd = this.filterScalesMMpia(this.mmpiaResults, 'Lingoes', 'Dp');
        lingoesPa = this.filterScalesMMpia(this.mmpiaResults, 'Lingoes', 'PA');
        lingoesSc = this.filterScalesMMpia(this.mmpiaResults, 'Lingoes', 'Es');
        lingoesMa = this.filterScalesMMpia(this.mmpiaResults, 'Lingoes', 'MA');
        lingoesSi = this.filterScalesMMpia(this.mmpiaResults, 'Lingoes', 'Is');

        let obj = {
          table:{
            body:[
              ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
            ]
          }
        }
        interpretations.push({text:'ESCALAS DE VALIDEZ', margin: [0, 20, 0, 10]});
        validez.map(
          x=>{
            let aux=[];
            aux.push("A-"+x.scale);
            aux.push(x.title);
            aux.push(x.pd);
            aux.push(x.value);
            obj.table.body.push(aux);
          }
        )
        interpretations.push(obj)
        obj = {
          table:{
            body:[
              ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
            ]
          }
        }
        interpretations.push({text:'ESCALAS CLINICAS', margin: [0, 20, 0, 10]});
        clinicas.map(
          x=>{
            let aux=[];
            aux.push("A-"+x.scale);
            aux.push(x.title);
            aux.push(x.pd);
            aux.push(x.value);
            obj.table.body.push(aux);
          }
        )
        interpretations.push(obj);

        
        if (this.selectedTest.extra!='Abreviado'){

          let contenido = this.filterScalesMMpia(this.mmpiaResults, 'Contenido');
          cg = this.filterScalesMMpia(this.mmpiaResults, 'Suplementarias');

          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'ESCALAS DE CONTENIDO', margin: [0, 20, 0, 10]});
          contenido.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);

          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'ESCALAS SUPLEMENTARIAS', margin: [0, 20, 0, 10]});
          cg.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);

          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES  - D',margin: [0, 20, 0, 10]});
          lingoesD.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Hi',margin: [0, 20, 0, 10]});
          lingoesHy.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Dp',margin: [0, 20, 0, 10]});
          lingoesPd.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Pa',margin: [0, 20, 0, 10]});
          lingoesPa.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Es',margin: [0, 20, 0, 10]});
          lingoesSc.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Ma',margin: [0, 20, 0, 10]});
          lingoesMa.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Is',margin: [0, 20, 0, 10]});
          lingoesSi.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
        }else{
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - D',margin: [0, 20, 0, 10]});
          lingoesD.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Hi',margin: [0, 20, 0, 10]});
          lingoesHy.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Dp',margin: [0, 20, 0, 10]});
          lingoesPd.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Pa',margin: [0, 20, 0, 10]});
          lingoesPa.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Es',margin: [0, 20, 0, 10]});
          lingoesSc.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Ma',margin: [0, 20, 0, 10]});
          lingoesMa.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
          obj = {
            table:{
              body:[
                ['Escala', 'Título', 'Puntaje directo', 'Puntaje T']
              ]
            }
          }
          interpretations.push({text:'SUBESCALAS CLINICAS DE HARRIS-LINGOES - Is',margin: [0, 20, 0, 10]});
          lingoesSi.map(
            x=>{
              let aux=[];
              aux.push("A-"+x.scale);
              aux.push(x.title);
              aux.push(x.pd);
              aux.push(x.value);
              obj.table.body.push(aux);
            }
          )
          interpretations.push(obj);
        }
        let combinationText = this.mmpiaCombination.description.replace(/<[^>]*>/g, '');
        combinationText = combinationText.replace(/&nbsp;/g, ' ');
        this.percentCompleted = 50;
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],

          content:[
            {
              text: 'Test MMPI-A',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:this.mmpiaReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20],
            },
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            charts
            ,
            {text:'',pageBreak:'after'}
            ,
            interpretations
            ,
            {
              text:'INTERPRETACIÓN TEXTUAL',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            interpretations1,
            {
              text:'TRAZADO DE PERFIL',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              text: `Código: ${this.mmpiaCombination.code} - Perfil ${this.mmpiaCombination.definition}`,
              bold: true,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:combinationText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              },
              alignment: 'center',
            },
            {
              text:'LISTADO DE ÍTEMS SIN RESPONDER',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            answers2.length>0?
            {
              table:{
                body:answers2
              },
              alignment: 'center',
            }:{},

          ]
        }
        this.percentCompleted = 100;
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
      }

      if (this.selectedType=="MIPS"){ //MIPS
        scrollTo(1,0);

        let interpretations1 = [];
        let answers = [];

        interpretations1.push({
          text: "ESCALAS DE VALIDEZ",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of this.mipsValidezArray){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        interpretations1.push({
          text: "METAS MOTIVACIONALES",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of this.mipsMotivacionalesArray){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        interpretations1.push({
          text: "MODOS COGNITIVOS",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of this.mipsCognitivosArray){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        interpretations1.push({
          text: "CONDUCTAS INTERPERSONALES",
          bold: true,
          margin: [0, 0, 0, 20]
        })
        for (let i of this.mipsInterpersonalesArray){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace('&nbsp;', " ");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        let interpretations = [];
        
        let obj = {
          table:{
            body:[
              ['Título', 'Aproximación al rasgo','Puntaje directo', 'Prevalencia de puntaje']
            ]
          }
        }
        interpretations.push({text:'METAS MOTIVACIONALES', margin: [0, 20, 0, 10]});
        this.mipsMotivacionalesArray.map(
          x=>{
            let aux=[];
            aux.push(x.scale);
            aux.push(((x.itemsCorrect/x.itemsCount)*100).toFixed(2)+'%');
            aux.push(x.pd);
            aux.push(x.pp);
            obj.table.body.push(aux);
          }
        )
        interpretations.push(obj)
        obj = {
          table:{
            body:[
              ['Título','Aproximación al rasgo', 'Puntaje directo',  'Prevalencia de puntaje']
            ]
          }
        }
        interpretations.push({text:'MODOS COGNITIVOS', margin: [0, 20, 0, 10]});
        this.mipsCognitivosArray.map(
          x=>{
            let aux=[];
            aux.push(x.scale);
            aux.push(((x.itemsCorrect/x.itemsCount)*100).toFixed(2)+'%');
            aux.push(x.pd);
            aux.push(x.pp);
            obj.table.body.push(aux);
          }
        )
        interpretations.push(obj)
        obj = {
          table:{
            body:[
              ['Título','Aproximación al rasgo', 'Puntaje directo',  'Prevalencia de puntaje']
            ]
          }
        }
        interpretations.push({text:'CONDUCTAS INTERPERSONALES', margin: [0, 20, 0, 10]});
        this.mipsInterpersonalesArray.map(
          x=>{
            let aux=[];
            aux.push(x.scale);
            aux.push(((x.itemsCorrect/x.itemsCount)*100).toFixed(2)+'%');
            aux.push(x.pd);
            aux.push(x.pp);
            obj.table.body.push(aux);
          }
        )
        interpretations.push(obj)
        obj = {
          table:{
            body:[
              ['Título','Aproximación al rasgo', 'Puntaje directo',  'Prevalencia de puntaje']
            ]
          }
        }
        interpretations.push({text:'VALIDEZ', margin: [0, 20, 0, 10]});
        this.mipsValidezArray.map(
          x=>{
            let aux=[];
            aux.push(x.scale);
            aux.push(((x.itemsCorrect/x.itemsCount)*100).toFixed(2)+'%');
            aux.push(x.pd);
            aux.push(x.pp);
            obj.table.body.push(aux);
          }
        )
        interpretations.push(obj)
        interpretations.push({text:'INDICE DE AJUSTE: '+this.mipsAjuste, margin: [0, 20, 0, 10]});

        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let resp = a;
          let obj = `Respuesta Nº${i}:\n ${resp?'Verdadero':'Falso'}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          pageMargins: [ 40, 70, 40, 60 ],
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
            margin: 8
          },
          pageSize:'A4',
          content:[
            {
              text: 'Test MIPS',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.mipsReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'TABLA DE PUNTAJES',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            interpretations,
            {
              text:'PERFIL GRÁFICO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
            },
            {
              image:await (await html2canvas(document.querySelector("#contentToExport2"), {allowTaint:true,scale:3, useCORS:true, imageTimeout:0})).toDataURL(),
              width:500,
              alignment:'center',
              margin: [0, 0, 0, 20],
              pageBreak:'after'
            },
            {
              text:'INTEPRETACIÓN TEXTUAL',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            interpretations1,
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      if (this.selectedType=="BIS11"){ 
        scrollTo(1,0);

        let interpretations1 = [];
        let answers = [];

        interpretations1.push({
          text: "INTERPRETACIÓN DE SUBESCALAS",
          bold: true,
          margin: [0, 20, 0, 20]
        })
        for (let i of this.bis11Array){
          let title = {
            text: i.title,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          if (i.title.indexOf('Puntuación')>0){
            interpretations1.push({
              text: "PERFIL INTERPRETATIVO",
              bold: true,
              margin: [0, 0, 0, 20]
            })
          }
          interpretations1.push(title);
          let text = i.desc.replace(/<[^>]*>/g, '');
          text = text.replace(/&nbsp;/g, "");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        let interpretations = [];
        
        let obj = {
          table:{
            body:[
              ['IMPULSIVIDAD NO PLANEADA', this.bis11Results['No planificada']],
              ['IMPULSIVIDAD MOTORA', this.bis11Results['Motora']],
              ['IMPULSIVIDAD COGNITIVA', this.bis11Results['Cognitiva']],
              ['TOTAL', this.bis11Results['Puntuación total']],
            ]
          }
        }
        interpretations.push(obj)
        
        let i = 1;
        let aux = [];

        answers.push({text:'Raramente o nunca', margin: [0, 20, 0, 10], bold:true });
        for (let a of this.bis11NuncaArray){
          let obj = `Respuesta Nº${String(a.number)}:\n ${a.question}`;
          answers.push({text:obj, margin: [0, 0, 0, 10]});
        }
        answers.push({text:'Ocasionalmente', margin: [0, 20, 0, 10], bold:true });

        for (let a of this.bis11OcasionalmenteArray){
          let obj = `Respuesta Nº${a.number}:\n ${a.question}`;
          answers.push({text:obj, margin: [0, 0, 0, 10]});
        }
        answers.push({text:'A menudo', margin: [0, 20, 0, 10], bold:true });

        for (let a of this.bis11AMenudoArray){
          let resp = a;
          let obj = `Respuesta Nº${a.number}:\n ${a.question}`;
          answers.push({text:obj, margin: [0, 0, 0, 10]});
        }
        answers.push({text:'Siempre o casi siempre', margin: [0, 20, 0, 10], bold:true });

        for (let a of this.bis11SiempreArray){
          let resp = a;
          let obj = `Respuesta Nº${a.number}:\n ${a.question}`;
          answers.push({text:obj, margin: [0, 0, 0, 10]});
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          styles: {
            header: {
              margin: [0, 0, 0, 80]
            }
          },
          content:[
            {
              text: 'Test BIS-11',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.bis11Report.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'TABLA DE PUNTAJES',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            interpretations,

            interpretations1,
            {
              text:'LISTADO DE RESPUESTAS AGRUPADAS SEGÚN GRADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            answers
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`)

        
      }

      if (this.selectedType=="CHASIDE"){ 
        scrollTo(1,0);

        let interpretations1 = [];
        let answers = [];

        interpretations1.push({
          text: "PERFIL VOCACIONAL - OCUPACIONAL",
          bold: true,
          margin: [0, 20, 0, 20]
        })
        interpretations1.push({
          text: "-A cada área, formada por un grupo de carreras afines, corresponde una letra.",
        })
        interpretations1.push({
          text: "-Considere los tres mayores puntajes obtenidos.",
        })
        interpretations1.push({
          text: "-Busca en los cuadros las áreas con los intereses y las aptitudes más representativas de cada una.",
          margin: [0, 0, 0, 20]
        })
        for (let i of this.chasideArray){
          let title = {
            text: `${i.interpretation.scale} - ${i.interpretation.title}`,
            bold: true,
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(title);
          let text = i.interpretation.text.replace(/<[^>]*>/g, '');
          text = text.replace(/&nbsp;/g, "");
          let description = {
            text:text,
            alignment:'justify',
            margin: [0, 0, 0, 20]
          }
          interpretations1.push(description);
        }

        let interpretations = [];

        let obj = {
          table:{
            body:[
              ['ACTIVIDADES PROFESIONALES', 'PUNTUACIÓN INTERESES', 'PUNTUACIÓN APTITUDES'],
              ['C - ADMINISTRATIVAS Y CONTABLES', this.chasideScores.Intereses.C, this.chasideScores.Aptitudes.C],
              ['H - HUMANÍSTICAS, CIENCIAS JURÍDICAS, CIENCIAS SOCIALES', this.chasideScores.Intereses.H, this.chasideScores.Aptitudes.H],
              ['A - ARTÍSTICAS', this.chasideScores.Intereses.A, this.chasideScores.Aptitudes.A],
              ['S - CIENCIAS DE LA SALUD', this.chasideScores.Intereses.S, this.chasideScores.Aptitudes.S],
              ['I - INGENIERIAS, CARRERAS TÉCNICAS Y COMPUTACIÓN', this.chasideScores.Intereses.I, this.chasideScores.Aptitudes.I],
              ['D - DEFENSA Y SEGURIDAD', this.chasideScores.Intereses.D, this.chasideScores.Aptitudes.D],
              ['E - CIENCIAS AGRARIAS, DE LA NATURALEZA, ZOOLÓGICAS Y BIOLÓGICAS', this.chasideScores.Intereses.E, this.chasideScores.Aptitudes.E],
            ]
          }
        }
        interpretations.push(obj)

        let i = 1;
        let aux = [];

        for (let a of this.report.answers){
          let resp = a;
          let obj = `Respuesta Nº${i}:\n ${resp?'Si':'No'}`;
          if (i%5!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<5){
              let j = 5-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }

        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],

          content:[
            {
              text: 'Test BIS-11',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.chasideReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },
            {
              text:'TABLA DE VALORES',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            interpretations,

            interpretations1,
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }
        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`)

        
      }

      if (this.selectedType=="DOMINO"){
        scrollTo(1,0);
        // let interpretations = [];
        let answers = [];
        // for (let i of this.pf16Array){
        //   let title = {
        //     text: i.title,
        //     bold: true,
        //     alignment: 'center',
        //     margin: [0, 0, 0, 20]
        //   }
        //   interpretations.push(title);
        //   let description = {
        //     text:i.desc,
        //     alignment:'justify',
        //     margin: [0, 0, 0, 20]
        //   }
        //   interpretations.push(description);
        // }
        let i = 1;
        let aux = [];
        for (let a of this.report.answers){
          let obj = `Respuesta ${i}: ${a[0]} - ${a[1]}`;
          if (i%4!=0) aux.push(obj);
          else{
            aux.push(obj);
            answers.push(aux);
            aux = [];
          }
          i++;
          if ((i-1)==this.report.answers.length) {
            if (aux.length<4){
              let j = 4-aux.length;
              for(let k=0; k<j; k++){
                aux.push([]);
              }
            }
            answers.push(aux);
          }
        }
        let doc = {
          info:{
            title:`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`
          },
          footer: function (currentPage, pageCount) {
            return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
          },
          header:{
            columns:[
              {},
              {image:await this.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
            ],
          },
          pageSize:'A4',
          pageMargins: [ 40, 70, 40, 60 ],

          content:[
            {
              text: 'Test Dominó',
              bold: true,
              fontSize: 20,
              alignment: 'center',
              margin: [0, 0, 0, 20]
            },
            {
              text:this.dominoReport.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'DATOS PERSONALES DEL EVALUADO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 10]
            },
            {
              table:{
                body:[
                  ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
                  ['Sexo: ', this.evaluated.sex],
                  ['Edad: ', this.age],
                  ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
                  ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
                  ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
                  ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
                ]
              },
              margin:[0, 0, 0, 20]
            },

            {
              text:'PERFIL INTERPRETATIVO',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              text:`Puntaje directo: ${this.directScore}`,
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              text:`Percentil: ${this.directScore}`,
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              text:`Tiempo empleado: ${Math.trunc(this.testTime / (1000 * 60))} minutos`,
              bold:true,
              margin: [0, 0, 0, 20]
            },
            {
              text:this.dominoFactor.nativeElement.innerText,
              alignment:'justify',
              margin: [0, 0, 0, 20]
            },
            {
              text:'LISTADO DE RESPUESTAS',
              style:'header',
              bold:true,
              margin: [0, 0, 0, 20],
              pageBreak:'before'
            },
            {
              table:{
                body:answers
              }
            }
          ]
        }

        pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.selectedType}_report.pdf`);
        
      }

      setTimeout(()=>{
        this.isExporting = false;
        $('#exportingModal').modal('hide');
      },2000)

    }else{
      Swal.fire("El documento aún no está listo")
    }
   }

  back(){
    window.location.reload();
  }

  handleEdit(email){

    this.userService.getUserByEmail(email).subscribe(
      resp=>{
        this.editingUser = resp;
        this.password = this.editingUser.password;
        this.editingUser.birthDate = formatDate(this.editingUser.birthDate, 'yyyy-MM-dd', 'en');
      },
      err=>console.log(err)
    )

  }

  update(){

    Swal.fire({
      icon: 'question',
      text: '¿Está seguro que desea actualizar los datos del usuario? Se actualizarán los datos de todas las pruebas realizadas por este usuario.',
      showCancelButton: true,
      confirmButtonText: 'Si, actualizar',
      cancelButtonText: 'No, cancelar',
    }).then( async result => {
      if (result.isConfirmed) {
        this.userService.updateUser(this.editingUser).subscribe(
          resp=>{
    
          },
          err=>console.log(err)
        )
        let tests = await this.testService.getEvaluatedTests(this.editingUser.email).toPromise()
        for (let test of tests){
          test.evaluatedName = this.editingUser.name + " " + this.editingUser.surname;
          await this.testService.updateTest(test, false).toPromise()
        }
        location.reload()
      }
    })

    
  }

  updatePassword(){

    this.userService.updateUser({email:this.editingUser.email, password: this.password}).subscribe(
      resp=>{
        var data = {
          email:this.editingUser.email,
          password:this.password
        }
        this.emailService.changePassword(data).subscribe();
        Swal.fire("Contraseña actualizada");

        this.password = "";
      },
      err=>console.log(err)
    )
    
  }

  scrollTop(){
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  async setCustomColors(){

    setTimeout(() => {


      if (!this.domainService.uid) return
      let color = this.domainService.customColor;
      let titles = document.querySelectorAll('.custom-title')
      titles.forEach(
        (t:HTMLElement) => {
          t.setAttribute('style', 'color:'+color+' !important; border-color:'+color+' !important');
        }
      )
  
      let hero = document.querySelectorAll('.test-title')
      hero.forEach(
        (t:HTMLElement) => {
          t.setAttribute('style', 'background-color:'+color+' !important');
        }
      )
  
      let icons = document.querySelectorAll('.custom-title img')
      icons.forEach(
        (i:HTMLElement) => {
          i.setAttribute('style', 'filter: sepia(0%)  !important');
        }
      )
  
      let textPrimaries = document.querySelectorAll('.text-primary')
      textPrimaries.forEach(
        (i:HTMLElement) => { 
          i.setAttribute('style', 'color:'+color+' !important');
        }
      )
  
      let questionNumber = document.querySelectorAll('.question-number')
      questionNumber.forEach(
        (i:HTMLElement) => {
          i.setAttribute('style', 'background-color:'+color+' !important');
        }
      )
  
      let questionContainer = document.querySelectorAll('.question-container')
      questionContainer.forEach(
        (i:HTMLElement) => {
          i.setAttribute('style', 'border-color:'+color+' !important');
        }
      )

      let buttons = document.querySelectorAll('.btn-primary')
      buttons.forEach(
        (i:HTMLElement) => {
          i.setAttribute('style', 'background-color:'+color+' !important');
        }
      )


    }, 100)

  }

  handleOpenHf(test: any){
    if (!test.useCleaverHF){
      return Swal.fire({
        icon: 'question',
        text: '¿Desea utilizar el perfil de factores humanos? Esta acción consumirá 1 crédito de su cuenta.',
        showCancelButton: true,
        confirmButtonText: 'Si, utilizar',
        cancelButtonText: 'No, cancelar',
      }).then( result => {
        if (result.isConfirmed) {
          if (this.user.remainingTests <= 0){
            return Swal.fire({
              icon: 'error',
              text: 'No tiene créditos suficientes para utilizar el perfil de factores humanos. Por favor, recargue su cuenta.',
              confirmButtonText: 'Aceptar',
            })
          }
          test.useCleaverHF = true;
          this.testService.updateTest(test).subscribe(
            resp => {
              let newCredits = this.user.remainingTests - 1;
              this.userService.updateUser({email:this.user.email, remainingTests:newCredits}).subscribe(
                resp => {
                  location.reload();
                }
              )
            }
          )
        }
      })
    }
    this.selectedHfTest = test
    $('#hfModal').modal('show');

  }

  setHumanFactorProfile(discValues: DiscModel){
    const key = `${discValues.d >= 50 ? 1 : 0}${discValues.i >= 50 ? 1 : 0}${discValues.s >= 50 ? 1 : 0}${discValues.c >= 50 ? 1 : 0}`;
    switch (key) {
      case '1000':
        return 'Desarrollador'; // D↑ I↑ S↓ C↓
      case '1100':
        return discValues.d > discValues.i ? 'Administrador' : 'Negociador' // D↑ I↓ S↓ C↓
      case '0011':
        return discValues.s < discValues.c ? 'Meticuloso' : 'Especialista';        // D↑ I↓ S↑ C↓
      case '1010':
        return 'Investigador';  // D↓ I↓ S↓ C↑
      case '0101':
        return 'Promotor';      // D↓ I↑ S↑ C↑
      case '1001':
        return 'Creativo';       // D↑ I↓ S↓ C↑
      default:
        return 'Perfil no identificado';
    }
    
  }

  setCleaverDiscHumanValues(values: number[]){
    let discRawValues = {
      d: 0,
      i: 0,
      s: 0,
      c: 0
    }
    let modelData = FORM_DATA;
    values.forEach(
      (value: number, index: number) => {
        switch (modelData[index].factor) {
          case 'D':
            discRawValues.d = value;
            break;
          case 'I':
            discRawValues.i = value;
            break;
          case 'S':
            discRawValues.s = value;
            break;
          case 'C':
            discRawValues.c = value;
            break;
          default:
            break;
        }
      }
    )
    let average = (discRawValues.d + discRawValues.i + discRawValues.s + discRawValues.c) / 4;
    let discDvalues = {
      d:(discRawValues.d - average),
      i:(discRawValues.i - average),
      s:(discRawValues.s - average),
      c:(discRawValues.c - average)
    }

    let discDPValues = {
      d: discDvalues.d * 5,
      i: discDvalues.i * 5,
      s: discDvalues.s * 5,
      c: discDvalues.c * 5
    }

    let discValues = {
      d: Math.round(discDPValues.d + 50),
      i: Math.round(discDPValues.i + 50),
      s: Math.round(discDPValues.s + 50),
      c: Math.round(discDPValues.c + 50)
    }

    this.cleaverHfData[0].data = [discValues.d, discValues.i, discValues.s, discValues.c];

    return [discRawValues, discDvalues, discDPValues, discValues];


  }

  viewTest(test, showPdf = false){
    if (test.isCustomTest){
      return this.router.navigate(['/dashboard/custom-test-report', test._id], {queryParams:{showPdf:showPdf}})
    }
    this.documentReady = false
    if (showPdf){
      $('#exportingModal').modal('show');
      this.isExporting = true;
    }
    setTimeout(()=>{
      $('#exportingModal').modal('hide');
      this.documentReady = true;
      if (showPdf) this.generatePdf();
    },3000)
    this.scrollTop();
    this.selectedTest = test;
    this.selectedType = this.selectedType != 'FORMULARIOREPORT' ? test.type : 'FORMULARIOREPORT';

    this.userService.getUserByEmail(test.evaluated).subscribe(
      resp=>{
        this.evaluated = resp;
        if(this.selectedTest.type=='MMPI2') this.mmpi2Service.getScalesT({sex:this.evaluated.sex=='Masculino'?'M':'F', baremo:this.selectedTest.baremo}).subscribe(
          resp=>{
            this.mmpi2Baremos = resp;
          },
          err=>console.log(err)
        )
        var fechaInicio = new Date(resp.birthDate).getTime();
        var fechaFin    = new Date(Date.now()).getTime();

        var diff = fechaFin - fechaInicio;

        this.age = Math.round(diff/(1000*60*60*24*365));
      },
      err=>console.log(err)
    )

    if (this.selectedType=="FORMULARIOREPORT"){

      this.testData = test;

      this.documentReady = false
      if (showPdf){
        $('#exportingModal').modal('show');
        this.isExporting = true;
      }
      setTimeout(()=>{
        $('#exportingModal').modal('hide');
        this.documentReady = true;
        if (showPdf) this.generatePdf();
      },3000)
      this.scrollTop();
      this.selectedTest = test;
  
      this.userService.getUserByEmail(test.evaluated).subscribe(
        resp=>{
          this.evaluated = resp;
          this.setCustomColors()

          var fechaInicio = new Date(resp.birthDate).getTime();
          var fechaFin    = new Date(Date.now()).getTime();
  
          var diff = fechaFin - fechaInicio;
  
          this.age = Math.round(diff/(1000*60*60*24*365));
        },
        err=>console.log(err)
      )
      return
    }


    if(this.selectedType=='16PF'){
      setTimeout(()=>{
        this.pfReport.nativeElement.innerHTML = this.description.pf16ReportText;
      }, 500)
      var factors=[];
      this.Pf16Service.getFactors().subscribe(
        resp=>{
          factors=resp;

          this.Pf16Service.getReport(test.reportId).subscribe(
            resp=>{
              console.log(resp)
              this.setCustomColors()

              this.report = resp;
              var scores = resp.scoreConverted;
              var colors=[];
              var cont=0;
              for (let s in scores){
                this.barChartLabels.push(`Factor ${s}`)
                this.barChartData[0].data.push(scores[s]);
                if(scores[s]<=5) {
                  if(scores[s]==5){
                    colors.push('#4c9f00');
                  }else{
                    colors.push('#f7b11e');

                  }

                  this.pf16Array.push({title:`Factor ${s}`, desc:factors[cont].lowDesc, high: false})

                }else {
                  if(scores[s]==6){
                    colors.push('#4c9f00');
                  }else{
                    colors.push('#f7b11e');
                  }

                  this.pf16Array.push({title:`Factor ${s}`, desc:factors[cont].highDesc, high: true})
                }
                cont++;
              }
              this.barChartData[0].backgroundColor=colors;
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }

    if(this.selectedType=='ALL PORT'){

      var factors=[];
      setTimeout(()=>{
        this.allPortReport.nativeElement.innerHTML = this.description.allPortReportText;
      }, 700)
      this.allPortService.getFactors().subscribe(
        resp=>{
          factors=resp;
          this.allPortService.getReport(test.reportId).subscribe(
            resp=>{
              this.report = resp;
              var scores = resp.score;
              this.report.answers.map(ans=>{
                if (ans[3]==0&&ans[4]==0){
                  this.answers1AllPort.push(ans)
                }else this.answers2AllPort.push(ans)
              })
              this.allPortService.getRanks().subscribe(
                resp=>{
                  this.setCustomColors()

                  var ranks = resp[0];
                  var colors=[];
                  var cont=0;
                  for (let s in scores){
                    this.barChartLabels.push(`Valor ${s}`)
                    this.barChartData[0].data.push(scores[s]);
                    var factor;

                    factors.map(
                      x=>{
                        if (x.name == s) factor = x;
                      }
                    )
                    if(scores[s]<=ranks[s].lowh) {
                      colors.push('#f26d24');
                      this.allPortArray.push({title:`Valor ${s}`, desc:factor.lowDesc, color:'red', value:scores[s]})
    
                    }
                    if(scores[s]<=ranks[s].midh&&scores[s]>ranks[s].lowh) {
                      colors.push('#fdeb48');
                      this.allPortArray.push({title:`Valor ${s}`, desc:factor.midDesc, color:'yellow', value:scores[s]})
                    }
                    if(scores[s]>ranks[s].highl) {
                      colors.push('#4c9f00');
                      this.allPortArray.push({title:`Valor ${s}`, desc:factor.highDesc, color:'green', value:scores[s]})
                    }
                    
                    cont++;
                  }
                  this.barChartData[0].backgroundColor=colors;

                },
                err=>console.log(err)
              )
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }


    if(this.selectedType=='BARSIC'){
      var factors=[];
      setTimeout(()=>{
        this.barsicReport.nativeElement.innerHTML = this.description.barsicReportText;
      }, 500)
      this.barsicService.getFactors().subscribe(
        resp=>{
          factors=resp;
          this.barsicService.getReport(test.reportId).subscribe(
            resp=>{
              this.report = resp;
              var scores = resp.score;
       
              var totalScore = scores.informacion + scores.razonamientoVerbal + scores.comprensionDeVocabulario + scores.razonamientoLogico + scores.razonamientoNumerico;

              if(this.report.scholarship=='secundaria'){
                this.barsicService.getSecondaryRanks().subscribe(
                  resp=>{
                    if (totalScore<=resp[0].vlowh) this.barsicRange = "Muy inferior";
                    if (totalScore<=resp[0].lowh&&totalScore>resp[0].vlowh) this.barsicRange = "Inferior";
                    if (totalScore<=resp[0].midh&&totalScore>resp[0].lowh) this.barsicRange = "Mediano";
                    if (totalScore<=resp[0].highh&&totalScore>resp[0].midh) this.barsicRange = "Superior";
                    if (totalScore<=resp[0].vhighh&&totalScore>resp[0].highh) this.barsicRange = "Excelente";
    

                  },
                  err=>{
                    console.log(err)
                  }
                )
              }else{
                this.barsicService.getPrimaryRanks().subscribe(
                  resp=>{
                    if (totalScore<=resp[0].vlowh) this.barsicRange = "Muy inferior";
                    if (totalScore<=resp[0].lowh&&totalScore>resp[0].vlowh) this.barsicRange = "Inferior";
                    if (totalScore<=resp[0].midh&&totalScore>resp[0].lowh) this.barsicRange = "Mediano";
                    if (totalScore<=resp[0].highh&&totalScore>resp[0].midh) this.barsicRange = "Superior";
                    if (totalScore<=resp[0].vhighh&&totalScore>resp[0].highh) this.barsicRange = "Excelente";


                  },
                  err=>console.log(err)
                )
              }
              this.barsicScores = resp.score;
              this.barsicService.getRanks().subscribe(
                resp=>{

                  this.setCustomColors()
                  var ranks = resp[0];
                  var colors=[];
                  var cont=0;
                  for (let s in scores){

                    var text;


                    this.barChartData[0].data.push(Math.round(scores[s]*100/12));
                    var factor;

                    factors.map(
                      x=>{
                        if (x.name == s) factor = x;
                      }
                    )

                    if(scores[s]*100/12<=ranks.vlowh) {
                      if (s=="informacion") {
                        text = `Información`
                        this.barChartLabels.push(`Información`)
                      }
                      if (s=="razonamientoVerbal") {
                        text = `Razonamiento verbal`
                        this.barChartLabels.push(`Razonamiento verbal`)
                    }
                      if (s=="comprensionDeVocabulario") {
                        text = "Comprensión de vocabulario"
                        this.barChartLabels.push(`Comprensión de vocabulario`)
                    }
                      if (s=="razonamientoLogico") {
                        text = "Razonamiento lógico"
                        this.barChartLabels.push(`Razonamiento lógico`)
                    }
                      if (s=="razonamientoNumerico") {
                        text = "Razonamiento numerico"
                        this.barChartLabels.push(`Razonamiento numerico`)
                    }
                      colors.push('#fdeb48');
                      this.barsicArray.push({title:text, desc:factor.veryLowDesc, level:2})
                    }

                    if(scores[s]*100/12<=ranks.lowh&&scores[s]*100/12>ranks.vlowh) {
                      if (s=="informacion") {
                        text = `Información`
                        this.barChartLabels.push(`Información`)
                      }
                      if (s=="razonamientoVerbal") {
                        text = `Razonamiento verbal`
                        this.barChartLabels.push(`Razonamiento verbal`)
                    }
                      if (s=="comprensionDeVocabulario") {
                        text = "Comprensión de vocabulario"
                        this.barChartLabels.push(`Comprensión de vocabulario`)
                    }
                      if (s=="razonamientoLogico") {
                        text = "Razonamiento lógico"
                        this.barChartLabels.push(`Razonamiento lógico`)
                    }
                      if (s=="razonamientoNumerico") {
                        text = "Razonamiento numerico"
                        this.barChartLabels.push(`Razonamiento numerico`)
                    }
                      colors.push('#fdeb48');
                      this.barsicArray.push({title:text, desc:factor.lowDesc, level:3})
                    }
                    if(scores[s]*100/12<=ranks.midh&&scores[s]*100/12>ranks.lowh) {
                      if (s=="informacion") {
                        text = `Información`
                        this.barChartLabels.push(`Información`)
                      }
                      if (s=="razonamientoVerbal") {
                        text = `Razonamiento verbal`
                        this.barChartLabels.push(`Razonamiento verbal`)
                    }
                      if (s=="comprensionDeVocabulario") {
                        text = "Comprensión de vocabulario"
                        this.barChartLabels.push(`Comprensión de vocabulario`)
                    }
                      if (s=="razonamientoLogico") {
                        text = "Razonamiento lógico"
                        this.barChartLabels.push(`Razonamiento lógico`)
                    }
                      if (s=="razonamientoNumerico") {
                        text = "Razonamiento numerico"
                        this.barChartLabels.push(`Razonamiento numerico`)
                    }
                      colors.push('#fdeb48');
                      this.barsicArray.push({title:text, desc:factor.midDesc, level:4})
                    }
                    if(scores[s]*100/12<=ranks.highh&&scores[s]*100/12>ranks.midh) {
                      if (s=="informacion") {
                        text = `Información`
                        this.barChartLabels.push(`Información`)
                      }
                      if (s=="razonamientoVerbal") {
                        text = `Razonamiento verbal`
                        this.barChartLabels.push(`Razonamiento verbal`)
                    }
                      if (s=="comprensionDeVocabulario") {
                        text = "Comprensión de vocabulario"
                        this.barChartLabels.push(`Comprensión de vocabulario`)
                    }
                      if (s=="razonamientoLogico") {
                        text = "Razonamiento lógico"
                        this.barChartLabels.push(`Razonamiento lógico`)
                    }
                      if (s=="razonamientoNumerico") {
                        text = "Razonamiento numerico"
                        this.barChartLabels.push(`Razonamiento numerico`)
                    }
                      colors.push('#fdeb48');
                      this.barsicArray.push({title:text, desc:factor.highDesc, level:5})
                    }              
                    if(scores[s]*100/12>ranks.highh) {
                      if (s=="informacion") {
                        text = `Información`
                        this.barChartLabels.push(`Información`)
                      }
                      if (s=="razonamientoVerbal") {
                        text = `Razonamiento verbal`
                        this.barChartLabels.push(`Razonamiento verbal`)
                    }
                      if (s=="comprensionDeVocabulario") {
                        text = "Comprensión de vocabulario"
                        this.barChartLabels.push(`Comprensión de vocabulario`)
                    }
                      if (s=="razonamientoLogico") {
                        text = "Razonamiento lógico"
                        this.barChartLabels.push(`Razonamiento lógico`)
                    }
                      if (s=="razonamientoNumerico") {
                        text = "Razonamiento numerico"
                        this.barChartLabels.push(`Razonamiento numerico`)
                    }
                      colors.push('#4c9f00');
                      this.barsicArray.push({title:text, desc:factor.veryHighDesc, level:6})
                    }
                    
                    cont++;
                  }
                  this.barChartData[0].backgroundColor=colors;

                },
                err=>console.log(err)
              )

            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }

    if(this.selectedType=='CLEAVER'){
      var factors=[];
      setTimeout(()=>{
        this.cleaverReport.nativeElement.innerHTML = this.description.cleaverReportText;
        this.normalHtml.nativeElement.innerHTML = this.description.cleaverNormal;
        this.motivatedHtml.nativeElement.innerHTML = this.description.cleaverMotivated;
        this.stressHtml.nativeElement.innerHTML = this.description.cleaverStress;
        this.hfHtml.nativeElement.innerHTML = this.description.cleaverHf;
      }, 1000)

      if (test.useCleaverHF){
        let response = this.setCleaverDiscHumanValues(test.cleaverHfResult)
        this.hfR = response[0];
        this.hfD = response[1];
        this.hfDP = response[2];
        this.hf = response[3];
        this.hfProfile = this.setHumanFactorProfile(this.hf);
        this.cleaverService.getHumanFactors({}).subscribe(
          resp => {
            let profile = resp.find(x => x.factor == this.hfProfile);
            if (profile){
              this.hfProfileHtml.nativeElement.innerHTML = profile.description;
            }
          }
        )

      }
      this.cleaverService.getFactors().subscribe(
        resp=>{
          // console.log(resp)
          factors=resp;

          this.cleaverService.getReport(test.reportId).subscribe(
            resp=>{
              this.setCustomColors()
              this.report = resp;
              this.cleaverScores = resp.score;
              this.cleaverOriginalScores = resp.originalScore;
              this.isCleaverValid = true;
              let totalT = this.cleaverScores.t.d + this.cleaverScores.t.i + this.cleaverScores.t.s + this.cleaverScores.t.c;
              if (totalT < -3 || totalT > 3){
                this.isCleaverValid = false;

              }
              var array=[];
              for (let type in this.cleaverScores.m){
                if(type!='vacio'){
                  array.push(Math.round(this.cleaverScores.m[type]));
                }
              }
              this.lineChartData.push({
                data:array, label: 'Motivación', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb'
              })
              array=[];
              for (let type in this.cleaverScores.l){
                if(type!='vacio'){
                  array.push(Math.round(this.cleaverScores.l[type]));
                  
                }
              }
              this.lineChartData2.push({
                data:array, label: 'Presión', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb'
              })
              array=[];
              for (let type in this.cleaverScores.t){
                if(type!='vacio'){
                  array.push(Math.round(this.cleaverScores.t[type]));
                  
                }
              }
              this.lineChartData3.push({
                data:array, label: 'Normal', backgroundColor:'transparent', borderColor:'#009efb', pointBackgroundColor:'#009efb'
              })
              array=[];
              this.barChartLabels=['D','I','S','C'];
              this.barChartLabels2=['D','I','S','C'];
              this.barChartLabels3=['D','I','S','C'];

              if (test.useCleaverHF){
                let userDisc: DiscModel = {
                  d: this.lineChartData3[0].data[0] as number,
                  i: this.lineChartData3[0].data[1] as number,
                  s: this.lineChartData3[0].data[2] as number,
                  c: this.lineChartData3[0].data[3] as number
                }
                this.evaluatedHfProfile = this.setHumanFactorProfile(userDisc);
              }

              //NORMAL//
              var selectedFactor;
              factors.map(x=>{
                if (x.type == 'normal'){
                  selectedFactor = x;
                }
              })
    
              var personal={
                d:"",
                i:"",
                s:"",
                c:""
              };
    
              selectedFactor.personal.map(
                x=>{
                  if(this.cleaverScores.t.d>x.low&&this.cleaverScores.t.d<x.high+1){
                    personal.d = x.d;
                  }
                  if(this.cleaverScores.t.i>x.low&&this.cleaverScores.t.i<x.high+1){
                    personal.i = x.i;
                  }
                  if(this.cleaverScores.t.s>x.low&&this.cleaverScores.t.s<x.high+1){
                    personal.s = x.s;
                  }
                  if(this.cleaverScores.t.c>x.low&&this.cleaverScores.t.c<x.high+1){
                    personal.c = x.c;
                  }
                }
              )

              var max=0;
              var maxVal;
              var min=100;
              var minVal;

              for (let x in this.cleaverScores.t){

                if(this.cleaverScores.t[x]>=max){
                  max = this.cleaverScores.t[x];
                  maxVal = x;
                }
                if(this.cleaverScores.t[x]<=min){
                  min = this.cleaverScores.t[x];
                  minVal = x;
                }

              }
              var combination = `${maxVal}/${minVal}`;
              maxVal=`${maxVal}+`;
              minVal=`${minVal}-`;
              var conducta; //{combiantion, title, description}
              var alto;
              var bajo;
              selectedFactor.behaviors.map(
                x=>{
                  if(x.combination == combination){
                    conducta = x;
                  }
                }
              )
              selectedFactor.maxMin.map(
                x=>{

                  if(maxVal == x.tag){
                    alto = x;
                  }
                  if(minVal == x.tag){
                    bajo = x;
                  }
                }
              )

              this.cleaverNormal={
                personal:personal,
                behavior:conducta,
                max:alto,
                min:bajo
              }

              //END NORMAL//


              //MOTIVATED//

              selectedFactor="";
              factors.map(x=>{
                if (x.type == 'motivated'){
                  selectedFactor = x;
                }
              })
    
              personal={
                d:"",
                i:"",
                s:"",
                c:""
              };
    
              selectedFactor.personal.map(
                x=>{
                  if(this.cleaverScores.m.d>x.low&&this.cleaverScores.m.d<x.high+1){
                    personal.d = x.d;
                  }
                  if(this.cleaverScores.m.i>x.low&&this.cleaverScores.m.i<x.high+1){
                    personal.i = x.i;
                  }
                  if(this.cleaverScores.m.s>x.low&&this.cleaverScores.m.s<x.high+1){
                    personal.s = x.s;
                  }
                  if(this.cleaverScores.m.c>x.low&&this.cleaverScores.m.c<x.high+1){
                    personal.c = x.c;
                  }
                }
              )

              max=0;
              maxVal="";
              min=100;
              minVal="";

              for (let x in this.cleaverScores.m){
                if(x!='vacio'){

                  if(this.cleaverScores.m[x]>=max){
                    max = this.cleaverScores.m[x];
                    maxVal = x;
                  }
                  if(this.cleaverScores.m[x]<=min){
                    min = this.cleaverScores.m[x];
                    minVal = x;
                  }
                }

              }
              combination = `${maxVal}/${minVal}`;
              maxVal=`${maxVal}+`;
              minVal=`${minVal}-`;
              conducta; //{combiantion, title, description}
              alto;
              bajo;
              selectedFactor.behaviors.map(
                x=>{
                  if(x.combination == combination){
                    conducta = x;
                  }
                }
              )
              selectedFactor.maxMin.map(
                x=>{
                  if(maxVal == x.tag){
                    alto = x;
                  }
                  if(minVal == x.tag){
                    bajo = x;
                  }
                }
              )

              this.cleaverMotivated={
                personal:personal,
                behavior:conducta,
                max:alto,
                min:bajo
              }

              var aux = this.cleaverMotivated.max.wish.split(/(\d+.-)/);
              aux.map(
                x=>{
                  if (x.indexOf('.-')==-1&&x!="") this.cleaverMaxWishText.push(x);
                }
              )

              var aux = this.cleaverMotivated.max.require.split(/(\d+.-)/);
              aux.map(
                x=>{
                  if (x.indexOf('.-')==-1&&x!="") this.cleaverMaxRequireText.push(x);
                }
              )

              var aux = this.cleaverMotivated.min.wish.split(/(\d+.-)/);
              aux.map(
                x=>{
                  if (x.indexOf('.-')==-1&&x!="") this.cleaverMinWishText.push(x);
                }
              )

              var aux = this.cleaverMotivated.min.require.split(/(\d+.-)/);
              aux.map(
                x=>{
                  if (x.indexOf('.-')==-1&&x!="") this.cleaverMinRequireText.push(x);
                }
              )




              //END NORMAL//

              //PRESION//

              selectedFactor="";
              factors.map(x=>{
                if (x.type == 'stress'){
                  selectedFactor = x;
                }
              })
    
              personal={
                d:"",
                i:"",
                s:"",
                c:""
              };
       
              selectedFactor.personal.map(
                x=>{
                  if(this.cleaverScores.l.d>=x.low&&this.cleaverScores.l.d<x.high+1){
                    personal.d = x.d;
                  }
                  if(this.cleaverScores.l.i>=x.low&&this.cleaverScores.l.i<x.high+1){
                    personal.i = x.i;
                  }
                  if(this.cleaverScores.l.s>=x.low&&this.cleaverScores.l.s<x.high+1){
                    personal.s = x.s;
                  }
                  if(this.cleaverScores.l.c>=x.low&&this.cleaverScores.l.c<x.high+1){
                    personal.c = x.c;
                  }
                }
              )

              max=0;
              maxVal="";
              min=100;
              minVal="";

              for (let x in this.cleaverScores.l){
                if(x!='vacio'){
                  if(this.cleaverScores.l[x]>=max){
                    max = this.cleaverScores.l[x];
                    maxVal = x;
                  }
                  if(this.cleaverScores.l[x]<=min){
                    min = this.cleaverScores.l[x];
                    minVal = x;
                  }

                }

              }
              combination = `${maxVal}/${minVal}`;

              maxVal=`${maxVal}+`;
              minVal=`${minVal}-`;
              var conducta; //{combiantion, title, description}
              var alto;
              var bajo;
              selectedFactor.behaviors.map(
                x=>{
                  if(x.combination == combination){
                    conducta = x;
                  }
                }
              )
              selectedFactor.maxMin.map(
                x=>{
                  if(maxVal == x.tag){
                    alto = x;
                  }
                  if(minVal == x.tag){
                    bajo = x;
                  }
                }
              )

              this.cleaverPresion={
                personal:personal,
                behavior:conducta,
                max:alto,
                min:bajo
              }

              var aux = this.cleaverPresion.max.description.split(/(\d+.-)/);
              aux.map(
                x=>{
                  if (x.indexOf('.-')==-1&&x!="") this.cleaverPresionMaxText.push(x);
                }
              )

              var aux = this.cleaverPresion.min.description.split(/(\d+.-)/);
              aux.map(
                x=>{
                  if (x.indexOf('.-')==-1&&x!="") this.cleaverPresionMinText.push(x);
                }
              )

              //END PRESION//


            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }


    if(this.selectedType=='IPV'){
      setTimeout(()=>{
        this.ipvReport.nativeElement.innerHTML = this.description?.ipvReportText;
      }, 500)
      var factors=[];
      this.ipvService.getFactors().subscribe(
        resp=>{
          factors=resp;
          
          this.ipvService.getReport(test.reportId).subscribe(
            resp=>{
              this.setCustomColors()
              this.report = resp;
              var scores = resp.naturalScore;
       
              var colors=[];
              var cont=0;

              for (let s in scores){
        
                this.barChartLabels.push(`${s}`)
                this.barChartData[0].data.push(scores[s]);
                if(s=='DGV') {
            
                    colors.push('#4c9f00');

                  //this.pf16Array.push({title:`Factor ${s}`, desc:factors[cont].lowDesc})

                }else {
                
                    colors.push('#4c9f00');
      

                }
                if (scores[s]<=2){
                  this.ipvArray.push({title:`${s} - Muy Bajo`, desc:factors[cont].veryLowDesc});
                }
                if (scores[s]>2&&scores[s]<=4){
                  this.ipvArray.push({title:`${s} - Bajo`, desc:factors[cont].lowDesc});
                }
                if (scores[s]>4&&scores[s]<=6){
                  this.ipvArray.push({title:`${s} - Promedio`, desc:factors[cont].midDesc});
                }
                if (scores[s]>6&&scores[s]<=8){
                  this.ipvArray.push({title:`${s} - Alto`, desc:factors[cont].highDesc});
                }
                if (scores[s]>8){
                  this.ipvArray.push({title:`${s} - Muy Alto`, desc:factors[cont].veryHighDesc});
                }
                cont++;
              }

              let arrayOrder = ['DGV', 'R', 'A', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];
              let newArrayLabels = [];
              let newArrayPoints = [];
              let originalIndex = 0;
              for (let s of this.barChartLabels){
                let index = arrayOrder.indexOf(s.toString());
                newArrayLabels[index] = s;
                newArrayPoints[index] = this.barChartData[0].data[originalIndex];
                originalIndex++;
              }
              this.barChartLabels = newArrayLabels;
              this.barChartData[0].data = newArrayPoints;

              this.ipvArray.splice(1, 0, this.ipvArray[11]);
              this.ipvArray.splice(2, 0, this.ipvArray[11]);
              this.ipvArray.pop();
              this.ipvArray.pop();
              this.barChartData[0].backgroundColor=colors;
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }

    if(this.selectedType=='KOSTIK'){
      setTimeout(()=>{
        this.kostikReport.nativeElement.innerHTML = this.description.kostikReportText;
      }, 500)
      var factors=[];
      this.kostikService.getFactors().subscribe(
        resp=>{
          factors=resp;
          this.kostikService.getRanks().subscribe(
            resp=>{
              var interpretations = resp;
              this.kostikService.getReport(test.reportId).subscribe(
                resp=>{
                  this.setCustomColors()
                  this.report = resp;
                  //console.log(this.report)
                  var scores = resp.score;
                  var colors=[];
                  var colors2=[];
                  var cont=0;
                  for (let s in scores){
                    interpretations.map(
                      x=>{
                        if(x.dimension.indexOf(`(${s.toUpperCase()})`)>=0){
                          if(scores[s]<=4) {
                            let aux={
                              rank:"BAJO",
                              factor:x.factor,
                              dimension:x.dimension,
                              positive:x.lowPositive,
                              negative:x.lowNegative
                            }

                            this.kostikInterpretationArray.push(aux);
                          }
                          if(scores[s]>4&&scores[s]<=6) {
                            let aux={
                              dimension:x.dimension,
                              rank:"MEDIO",
                              factor:x.factor,
                              positive:x.midPositive,
                              negative:x.midNegative
                            }
                            this.kostikInterpretationArray.push(aux);
                          }
                          if(scores[s]>6) {
                            let aux={
                              dimension:x.dimension,
                              rank:"ALTO",
                              factor:x.factor,
                              positive:x.highPositive,
                              negative:x.highNegative
                            }
                            this.kostikInterpretationArray.push(aux);
                          }
                        }
                        
                      }
                    )
                    if(s=='n'||s=='a'||s=='p'||s=='x'||s=='b'||s=='o'||s=='z'||s=='k'||s=='f'||s=='w') {
                      
                        if(s=='n'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Terminar una tarea`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
    
                          factors.map(
                            x=>{
           
                              if(x.dimension.indexOf('(N)')>=0&&x.score==scores[s]){
                                this.gradoDeEnergiaArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='a'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Logro`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(A)')>=0&&x.score==scores[s]){
                                this.gradoDeEnergiaArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='p'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Controlar a otros`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(P)')>=0&&x.score==scores[s]){
                                this.liderazgoArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='x'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Ser tomado en cuenta`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(X)')>=0&&x.score==scores[s]){
                                this.naturalezaSocialArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='b'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Pertenecer al grupo`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(B)')>=0&&x.score==scores[s]){
                                this.naturalezaSocialArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='o'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Acercamiento y afecto`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(O)')>=0&&x.score==scores[s]){
                                this.naturalezaSocialArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='z'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Cambio / no modificar`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(Z)')>=0&&x.score==scores[s]){
                                this.naturalezaEmocionalArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='k'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Ser agresivo / a la defensiva`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(K)')>=0&&x.score==scores[s]){
                                this.naturalezaEmocionalArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='f'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Apoyo del supervisor`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)                      
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(F)')>=0&&x.score==scores[s]){
                                this.subordinacionArray.push(x);
                              }
                            }
                          )
                        }
                        if(s=='w'){
                          this.barChartLabels.push(`${s.toUpperCase()} - Necesidad de reglas y supervisor`)
                          this.radarChartLabels.push(`${s.toUpperCase()} `)
                          factors.map(
                            x=>{
                              if(x.dimension.indexOf('(W)')>=0&&x.score==scores[s]){
                                this.subordinacionArray.push(x);
                              }
                            }
                          )
                        }
    
                        this.lineChartDataKostik[0].data.push(scores[s]);
                        this.radarChartData[0].data.push(scores[s]);
                        colors.push('#4c9f00');
    
                      //this.pf16Array.push({title:`Factor ${s}`, desc:factors[cont].lowDesc})
    
                    }else {
                    
                      if(s=='g'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Actividad intensa`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(G)')>=0&&x.score==scores[s]){
                              this.gradoDeEnergiaArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='l'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Liderazgo`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(L)')>=0&&x.score==scores[s]){
                              this.liderazgoArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='i'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Toma decisiones`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(I)')>=0&&x.score==scores[s]){
                              this.liderazgoArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='t'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Activo`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(T)')>=0&&x.score==scores[s]){
                              this.modoDeVidaArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='v'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Vigoroso`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(V)')>=0&&x.score==scores[s]){
                              this.modoDeVidaArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='s'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Socibilidad`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(S)')>=0&&x.score==scores[s]){
                              this.naturalezaSocialArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='r'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Tipo teórico`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(R)')>=0&&x.score==scores[s]){
                              this.adaptacionAlTrabajoArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='c'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Tipo organizado`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(C)')>=0&&x.score==scores[s]){
                              this.adaptacionAlTrabajoArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='e'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Introversión`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(E)')>=0&&x.score==scores[s]){
                              this.naturalezaEmocionalArray.push(x);
                            }
                          }
                        )
                      }
                      if(s=='d'){
                        this.barChartLabels2.push(`${s.toUpperCase()} - Detalles`)
                        this.radarChartLabels.push(`${s.toUpperCase()} `)
                        factors.map(
                          x=>{
                            if(x.dimension.indexOf('(D)')>=0&&x.score==scores[s]){
                              this.adaptacionAlTrabajoArray.push(x);
                            }
                          }
                        )
                      }
                      this.lineChartDataKostik2[0].data.push(scores[s]);
                      this.radarChartData[0].data.push(scores[s]);
                      colors2.push('#fdeb48');
          
    
                    }
                    cont++;
                  }
                  let sortedValues = ['D ', 'C ', 'R ', 'O ', 'B ', 'S ', 'X ', 'V ', 'T ', 'I ', 'P ', 'L ', 'A ', 'G ', 'N ', 'W ', 'F ', 'K ', 'E ', 'Z '];

                  //1) combine the arrays:
                  var list = [];
                  for (var j = 0; j < this.radarChartLabels.length; j++) 
                      list.push({'letter': this.radarChartLabels[j], 'value': this.radarChartData[0].data[j]});

                  //2) sort:
                  list.sort(function(a, b) {
                    if (sortedValues.indexOf(a.letter.toString().toUpperCase()) > sortedValues.indexOf(b.letter.toString().toUpperCase())) return 1
                    if (sortedValues.indexOf(a.letter.toString().toUpperCase()) < sortedValues.indexOf(b.letter.toString().toUpperCase())) return -1
                    return 0
                  });

                  //3) separate them back out:
                  for (var k = 0; k < list.length; k++) {
                    this.radarChartData[0].data[k] = list[k].value;
                    this.radarChartLabels[k] = list[k].letter;
                  }

                  // this.radarChartLabels.sort((a, b) =>{
                  //   if (sortedValues.indexOf(a.toString().toUpperCase()) > sortedValues.indexOf(b.toString().toUpperCase())) return 1
                  //   if (sortedValues.indexOf(a.toString().toUpperCase()) < sortedValues.indexOf(b.toString().toUpperCase())) return -1
                  //   return 0
                  // })

    
                  this.lineChartDataKostik[0].backgroundColor=colors;
                  this.lineChartDataKostik2[0].backgroundColor=colors2;
                },
                err=>console.log(err)
                )
            },
            err=>console.log(err)
          )
        },
        err=>{
          console.log(err)
        }
      )
    }

    if(this.selectedType=='TERMAN'){
      setTimeout(()=>{
        this.termanReport.nativeElement.innerHTML = this.description.termanReportText;
      }, 500)
      var factors=[];
      this.termanService.getFactors().subscribe(
        resp=>{
          factors=resp;
          //console.log(factors)
          this.termanService.getReport(test.reportId).subscribe(
            resp=>{
              this.setCustomColors()
              this.report = resp;
              this.report.answers.map(
                x=>{
                  if(typeof(x)=="string"){
                    this.termanAnswers.push(x);
                  }
                  if(typeof(x)=="number"){
                    this.termanAnswers.push(x.toString());
                  }
                  if(typeof(x)=="object"){
                    var aux='';
                    for(let o in x){
                      
                      if(o.indexOf('opc')>=0&&x[o]==true){
                        this.termanAnswers.push(o);
                      }else{
                        if(o.indexOf('opc')<0) aux = aux + x[o] + " - ";
                      }
                    }
                    if (aux!="") this.termanAnswers.push(aux);
                  }
                  if(typeof(x)=="boolean") {
                  
                    if(x) this.termanAnswers.push('Si / Iguales');
                    else this.termanAnswers.push('No / Distintos');
                    
                  
                  }
                }
              )

              var scores = resp.score;
              this.termanScore = scores[1]+scores[2]+scores[3]+scores[4]+scores[5]+scores[6]+scores[7]+scores[8]+scores[9]+scores[10];
              if (this.termanScore==0) this.termanIq = 1;
              else{
                this.termanIq = Math.round(this.termanScore*0.45+41);
              }
              if (this.termanIq<=69){
                this.termanRank="Debilidad Mental Mediana"
              }
              if(this.termanIq>=70&&this.termanIq<=79){
                this.termanRank="Debilidad Mental Superficial"
              }
              if(this.termanIq>=80&&this.termanIq<=89){
                this.termanRank="Inteligencia Limítrofe"
              }
              if(this.termanIq>=90&&this.termanIq<=110){
                this.termanRank="Inteligencia Normal"
              }
              if(this.termanIq>=111&&this.termanIq<=120){
                this.termanRank="Inteligencia Superior"
              }
              if(this.termanIq>120){
                this.termanRank="Inteligencia Sobresaliente"
              }

              if (this.termanIq<=94){
                this.termanCa="Deficiente"
              }
              if(this.termanIq>=95&&this.termanIq<=101){
                this.termanCa="Abajo del término medio"
              }
              if(this.termanIq>=102&&this.termanIq<=122){
                this.termanCa="Término medio bajo"
              }
              if(this.termanIq>=123&&this.termanIq<=136){
                this.termanCa="Término medio"
              }
              if(this.termanIq>=137&&this.termanIq<=150){
                this.termanCa="Término medio alto"
              }
              if(this.termanIq>=151&&this.termanIq<=171){
                this.termanCa="Superior al término medio"
              }
              if(this.termanIq>172){
                this.termanCa="Superior"
              }
              //console.log(this.termanScore)
              var colors=[];
  
              for (let s in scores){

                    if(s=='1'){
                      this.barChartLabels.push(`Información`)

                      if(scores[s]<=7){
                        let aux={
                          serie:'I',
                          category:'Información',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=8&&scores[s]<=9){
                        let aux={
                          serie:'I',
                          category:'Información',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=10&&scores[s]<=11){
                        let aux={
                          serie:'I',
                          category:'Información',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=12&&scores[s]<=13){
                        let aux={
                          serie:'I',
                          category:'Información',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=14&&scores[s]<=14){
                        let aux={
                          serie:'I',
                          category:'Información',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=15&&scores[s]<=15){
                        let aux={
                          serie:'I',
                          category:'Información',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=16){
                        let aux={
                          serie:'I',
                          category:'Información',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }

                      factors.map(
                        x=>{
                          if(x.serie=='informacion'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`I - Información`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )


                    }
                    
                    if(s=='2'){
                      this.barChartLabels.push(`Juicio`)
                      if(scores[s]<=6){
                        let aux={
                          serie:'II',
                          category:'Juicio',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=7&&scores[s]<=8){
                        let aux={
                          serie:'II',
                          category:'Juicio',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=9&&scores[s]<=10){
                        let aux={
                          serie:'II',
                          category:'Juicio',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=10&&scores[s]<=16){
                        let aux={
                          serie:'II',
                          category:'Juicio',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=17&&scores[s]<=18){
                        let aux={
                          serie:'II',
                          category:'Juicio',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=19&&scores[s]<=20){
                        let aux={
                          serie:'II',
                          category:'Juicio',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=21){
                        let aux={
                          serie:'II',
                          category:'Juicio',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='juicio'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`II - Juicio`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                    }
                    
                    if(s=='3'){
                      this.barChartLabels.push(`Vocabulario`)
                      if(scores[s]<=7){
                        let aux={
                          serie:'III',
                          category:'Vocabulario',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=8&&scores[s]<=11){
                        let aux={
                          serie:'III',
                          category:'Vocabulario',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=12&&scores[s]<=13){
                        let aux={
                          serie:'III',
                          category:'Vocabulario',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=14&&scores[s]<=22){
                        let aux={
                          serie:'III',
                          category:'Vocabulario',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=23&&scores[s]<=26){
                        let aux={
                          serie:'III',
                          category:'Vocabulario',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=27&&scores[s]<=28){
                        let aux={
                          serie:'III',
                          category:'Vocabulario',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=29){
                        let aux={
                          serie:'III',
                          category:'Vocabulario',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='vocabulario'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`III - Vocabulario`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                    }
                    
                    if(s=='4'){
                      this.barChartLabels.push(`Síntesis`)
                      if(scores[s]<=5){
                        let aux={
                          serie:'IV',
                          category:'Síntesis',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=6&&scores[s]<=6){
                        let aux={
                          serie:'IV',
                          category:'Síntesis',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=7&&scores[s]<=9){
                        let aux={
                          serie:'IV',
                          category:'Síntesis',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=10&&scores[s]<=13){
                        let aux={
                          serie:'IV',
                          category:'Síntesis',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=14&&scores[s]<=15){
                        let aux={
                          serie:'IV',
                          category:'Síntesis',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=16&&scores[s]<=17){
                        let aux={
                          serie:'IV',
                          category:'Síntesis',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=18){
                        let aux={
                          serie:'IV',
                          category:'Síntesis',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='sintesis'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`IV - Síntesis`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                    }
                    
                    if(s=='5'){
                      this.barChartLabels.push(`Concentración`)
                      if(scores[s]<=4){
                        let aux={
                          serie:'V',
                          category:'Concentración',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=5&&scores[s]<=6){
                        let aux={
                          serie:'V',
                          category:'Concentración',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=7&&scores[s]<=9){
                        let aux={
                          serie:'V',
                          category:'Concentración',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=10&&scores[s]<=14){
                        let aux={
                          serie:'V',
                          category:'Concentración',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=15&&scores[s]<=20){
                        let aux={
                          serie:'V',
                          category:'Concentración',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=21&&scores[s]<=22){
                        let aux={
                          serie:'V',
                          category:'Concentración',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=24){
                        let aux={
                          serie:'V',
                          category:'Concentración',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='Concentración'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`V - Concentración`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                      
                    }
                    
                    if(s=='6'){
                      this.barChartLabels.push(`Análisis`)
                      if(scores[s]<=4){
                        let aux={
                          serie:'VI',
                          category:'Análisis',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=5&&scores[s]<=6){
                        let aux={
                          serie:'VI',
                          category:'Análisis',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=7&&scores[s]<=8){
                        let aux={
                          serie:'VI',
                          category:'Análisis',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=9&&scores[s]<=14){
                        let aux={
                          serie:'VI',
                          category:'Análisis',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=15&&scores[s]<=17){
                        let aux={
                          serie:'VI',
                          category:'Análisis',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=18&&scores[s]<=19){
                        let aux={
                          serie:'VI',
                          category:'Análisis',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=20){
                        let aux={
                          serie:'VI',
                          category:'Análisis',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='analisis'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`VI - Análisis`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                    }
                    
                    if(s=='7'){
                      this.barChartLabels.push(`Abstracción`)
                      if(scores[s]<=4){
                        let aux={
                          serie:'VII',
                          category:'Abstracción',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=5&&scores[s]<=5){
                        let aux={
                          serie:'VII',
                          category:'Abstracción',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=6&&scores[s]<=8){
                        let aux={
                          serie:'VII',
                          category:'Abstracción',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=9&&scores[s]<=15){
                        let aux={
                          serie:'VII',
                          category:'Abstracción',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=16&&scores[s]<=17){
                        let aux={
                          serie:'VII',
                          category:'Abstracción',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=18&&scores[s]<=18){
                        let aux={
                          serie:'VII',
                          category:'Abstracción',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=19){
                        let aux={
                          serie:'VII',
                          category:'Abstracción',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='abstraccion'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`VII - Abstracción`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                    }
                    
                    if(s=='8'){
                      this.barChartLabels.push(`Planeación`)
                      if(scores[s]<=5){
                        let aux={
                          serie:'VIII',
                          category:'Planeación',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=6&&scores[s]<=6){
                        let aux={
                          serie:'VIII',
                          category:'Planeación',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=7&&scores[s]<=7){
                        let aux={
                          serie:'VIII',
                          category:'Planeación',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=8&&scores[s]<=12){
                        let aux={
                          serie:'VIII',
                          category:'Planeación',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=13&&scores[s]<=14){
                        let aux={
                          serie:'VIII',
                          category:'Planeación',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=15&&scores[s]<=16){
                        let aux={
                          serie:'VIII',
                          category:'Planeación',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=17){
                        let aux={
                          serie:'VIII',
                          category:'Planeación',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='planeacion'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`VIII - Planeación`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                    }
                    
                    if(s=='9'){
                      this.barChartLabels.push(`Organización`)
                      if(scores[s]<=6){
                        let aux={
                          serie:'IX',
                          category:'Organización',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=7&&scores[s]<=7){
                        let aux={
                          serie:'IX',
                          category:'Organización',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=8&&scores[s]<=9){
                        let aux={
                          serie:'IX',
                          category:'Organización',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=10&&scores[s]<=14){
                        let aux={
                          serie:'IX',
                          category:'Organización',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=15&&scores[s]<=16){
                        let aux={
                          serie:'IX',
                          category:'Organización',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=17&&scores[s]<=17){
                        let aux={
                          serie:'IX',
                          category:'Organización',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=18){
                        let aux={
                          serie:'IX',
                          category:'Organización',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='organizacion'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`IX - Organización`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                    }
                    
                    if(s=='10'){
                      this.barChartLabels.push(`Atención`)
                      if(scores[s]<=4){
                        let aux={
                          serie:'X',
                          category:'Atención',
                          score:scores[s],
                          rank:'Deficiente'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=5&&scores[s]<=7){
                        let aux={
                          serie:'X',
                          category:'Atención',
                          score:scores[s],
                          rank:'Inferior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=8&&scores[s]<=9){
                        let aux={
                          serie:'X',
                          category:'Atención',
                          score:scores[s],
                          rank:'Término Medio Bajo'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=10&&scores[s]<=11){
                        let aux={
                          serie:'X',
                          category:'Atención',
                          score:scores[s],
                          rank:'Término Medio'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=12&&scores[s]<=16){
                        let aux={
                          serie:'X',
                          category:'Atención',
                          score:scores[s],
                          rank:'Término Medio Alto'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=17&&scores[s]<=19){
                        let aux={
                          serie:'X',
                          category:'Atención',
                          score:scores[s],
                          rank:'Superior'
                        }
                        this.termanArray.push(aux);
                      }
                      if(scores[s]>=20){
                        let aux={
                          serie:'X',
                          category:'Atención',
                          score:scores[s],
                          rank:'Excelente'
                        }
                        this.termanArray.push(aux);
                      }
                      factors.map(
                        x=>{
                          if(x.serie=='atencion'){
                            x.rank.map(
                              rank=>{
                                if(scores[s]>=rank.low&&scores[s]<=rank.high){
                                  let aux={
                                    title:`X - Atención`,
                                    desc:rank.description
                                  }
                                  this.termanDescriptionsArray.push(aux);
                                }
                              })
                          }
                        }
                      )
                    }

                    this.barChartData[0].data.push(scores[s]);
                    this.barChartData[0].borderColor = 'transparent';
                    this.barChartData[0].backgroundColor = '#019EFA';

                    colors.push('#019EFA');

                  //this.pf16Array.push({title:`Factor ${s}`, desc:factors[cont].lowDesc})

                }
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }

    if(this.selectedType=='ZAVIC'){
      setTimeout(()=>{
        this.zavicReport.nativeElement.innerHTML = this.description.zavicReportText;
      }, 500)
      var factors=[];
      this.zavicService.getFactors().subscribe(
        resp=>{
          factors=resp;
          
          this.zavicService.getReport(test.reportId).subscribe(
            resp=>{
              this.setCustomColors()
              this.report = resp;
              var scores = resp.score;
              var colors=[];
              var cont=0;
              for (let s in scores){
                if(s=="moral"||s=="legalidad"||s=="indiferencia"||s=="corrupto"){
                  this.barChartLabels.push(`${s.toUpperCase()}`)
                  this.barChartData[0].data.push(scores[s]);
                  if(scores[s]<=12){
                    this.zavicArray.push({title:`${s.toUpperCase()} - BAJO`, desc:factors[cont].lowDesc})
                    colors.push('#f26d24');

                  }
                  if(scores[s]>=13&&scores[s]<27){
                    this.zavicArray.push({title:`${s.toUpperCase()} - PROMEDIO`, desc:factors[cont].lowDesc})
                    colors.push('#fdeb48');

                  }
                  if(scores[s]>=27){
                    this.zavicArray.push({title:`${s.toUpperCase()} - ALTO`, desc:factors[cont].highDesc})
                    colors.push('#4c9f00');
                  }
                  
                  cont++;
                }
                if(s=="economico"||s=="politico"||s=="social"||s=="religioso"){
                  this.barChartLabels.push(`${s.toUpperCase()}`)
                  this.barChartData[0].data.push(scores[s]);
                  if(scores[s]<=12){
                    this.zavicArray1.push({title:`${s.toUpperCase()} - BAJO`, desc:factors[cont].lowDesc})
                    colors.push('#f26d24');
                  }
                  if(scores[s]>=13&&scores[s]<27){
                    this.zavicArray1.push({title:`${s.toUpperCase()} - PROMEDIO`, desc:factors[cont].lowDesc})
                    colors.push('#fdeb48');
                  }
                  if(scores[s]>=27){
                    this.zavicArray1.push({title:`${s.toUpperCase()} - ALTO`, desc:factors[cont].highDesc})
                    colors.push('#4c9f00');
                  }
                  
                  cont++;
                }
              }
              this.barChartData[0].backgroundColor=colors;
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }

    if(this.selectedType=='MMPI2'){
      this.isLoading = true;
      setTimeout(()=>{
        this.mmpi2Report.nativeElement.innerHTML = this.description.mmpi2ReportText;
      }, 1000)
      this.mmpi2Service.getQuestion().subscribe(
        resp=>{
          this.mmpi2Questions = resp;
        },
        err=>console.log(err)
      )
      var factors=[]; //factores para comparar puntajes T
      this.mmpi2Service.getInterpretations().subscribe(
        resp=>{
          factors=resp;
          this.mmpi2Service.getReport(test.reportId).subscribe(
            async resp=>{
              this.report = resp;
              this.userService.getUserByEmail(test.evaluated).subscribe(
                resp=>{
                  this.mmpi2Service.getScalesT({sex:resp.sex=='Masculino'?'M':'F', baremo:test.baremo}).subscribe(
                    async resp=>{
                      
                      let scores = {
                        "?":{
                          title:'Interrogante',
                          value:0,
                          type:'Validez',
                          pd:0
                        }
                      };
                      this.mmpi2Baremos = resp;
                      let acceptedScales;
                      if (this.selectedTest.extra =='Abreviado') acceptedScales = await this.mmpi2Service.getShortScales().toPromise();
                      else acceptedScales = await this.mmpi2Service.getScales().toPromise();
                      for (let s in acceptedScales){
                        if (s!='all'){
                          acceptedScales[s].map(
                            x=>{
                              if (this.selectedTest.extra =='Abreviado'){
                                if (x.value!='FB'&&x.value!='F(P)'&&x.value!='VRIN'&&x.value!='TRIN'){
                                  if (x.value!=''){
                                    if (!scores[x.value]) scores[x.value] = {};
                                    scores[x.value].value = 0;
                                    scores[x.value].pd = 0;
                                    scores[x.value].title = x.title;
                                    if (s=='validez') scores[x.value].type = 'Validez';
                                    if (s=='clinicas') scores[x.value].type = 'Clínicas';
                                  }
                                } 
                              }else {
                                if (x.value!=''){
                                  if (!scores[x.value]) scores[x.value] = {};
                                  if (s=='validez') scores[x.value].type = 'Validez';
                                  if (s=='clinicas') scores[x.value].type = 'Clínicas';
                                  if (s=='suplementarias') scores[x.value].type = 'Suplementarias';
                                  if (s=='contenido') scores[x.value].type = 'Contenido';
                                  scores[x.value].value = 0;
                                  scores[x.value].pd = 0;
                                  scores[x.value].title = x.title
                                }
                              }
                            }
                          )
                        }
                      }
                      if (this.evaluated.sex=='Femenino'){
                        scores['Mf'].title = scores['MfM'].title;
                      }
                      if (this.selectedTest.extra !='Abreviado') scores['TRIN'].value = 9;
                      let questions = await this.mmpi2Service.getQuestion().toPromise();
                      if (this.selectedTest.extra =='Abreviado') questions = questions.splice(0,370);
                      let i = 0;
                      questions.map(
                        question=>{
                          if(this.report.answers[i]===null){
                            this.mmpi2NullAnswers.push(i);
                            scores["?"].value++;
                            scores["?"].pd++;
                          }
                          question.values.map(
                            q=>{
                              if (q.value==this.report.answers[i]){
                                if (scores[q.scale]) scores[q.scale].value++;
                              }
                            }
                          )
                          if (this.selectedTest.extra !='Abreviado'&&question.isPair){
                            question.equalPairs.map(
                              pair=>{
                                if(pair.scale=='TRIN'){
                                  if(pair.value1==this.report.answers[pair.index1]&&pair.value2==this.report.answers[pair.index2]&&pair.index2>i){
                                    if (pair.value1) if (scores[pair.scale]) scores[pair.scale].value++;
                                    else if (scores[pair.scale]) scores[pair.scale].value--;
                                  }
                                }else{
                                  if(pair.value1==this.report.answers[pair.index1]&&pair.value2==this.report.answers[pair.index2]&&pair.index2>i){
                                    if (scores[pair.scale]) scores[pair.scale].value++;
                                  }
                                }
                              }
                            )
                          }
                          i++;
                        }
                      )
                      let convertedScores = scores;
                      for (let s in scores){
                        this.mmpi2Baremos.map(
                          scale=>{
                            if (scale.scale==s){
                              let maxPd = 0;
                              let maxT = 0;
                              let founded = false;
                              scale.data.map(
                                value=>{
                                  value.pd = value.pd;
                                  if (value.pd>maxPd) {
                                    maxPd = value.pd;
                                    maxT = value.t;
                                  }
                                  if(value.pd==scores[s].value){
                                    founded = true;
                                    convertedScores[s].pd = convertedScores[s].value; 
                                    convertedScores[s].value = value.t-20<=90?value.t-20:90;
                                  } 
                                }
                              )
                              if (!founded){
                                convertedScores[s].pd = convertedScores[s].value; 
                                convertedScores[s].value = maxT-20<=90?maxT-20:90 ;
                              }
                            }
                          }
                        )
                      }
                      var colors=[];
                      var colors2=[];
                      var colors3=[];
                      var colors4=[];
                      let interpretations = await this.mmpi2Service.getInterpretations().toPromise();
                      this.mmpi2Results = convertedScores;
                      this.mmpi2Results['?'].value = this.mmpi2Results['?'].pd;
                      let clinicas = [];
                      for (let result in this.mmpi2Results){
                        if (this.mmpi2Results[result].type=='Clínicas'&&(result=='Hs'||result=='D'||result=='Hy'||result=='Pd'||result=='Mf'||result=='Pa'||result=='Pt'||result=='Sc'||result=='Ma'||result=='Si')) clinicas.push(this.mmpi2Results[result]);
                      }
                      clinicas.sort(function(a,b){
                        return (b.value-a.value)
                      })
                      setTimeout(async()=>{
                        let codeNumber1="";
                        let codeNumber2="";
                        if (clinicas[0].scale == 'Hs') codeNumber1 = '1'; 
                        if (clinicas[0].scale == 'D') codeNumber1 = '2'; 
                        if (clinicas[0].scale == 'Hy') codeNumber1 = '3'; 
                        if (clinicas[0].scale == 'Pd') codeNumber1 = '4'; 
                        if (clinicas[0].scale == 'Mf') codeNumber1 = '5'; 
                        if (clinicas[0].scale == 'Pa') codeNumber1 = '6'; 
                        if (clinicas[0].scale == 'Pt') codeNumber1 = '7'; 
                        if (clinicas[0].scale == 'Sc') codeNumber1 = '8'; 
                        if (clinicas[0].scale == 'Ma') codeNumber1 = '9'; 
                        if (clinicas[0].scale == 'Si') codeNumber1 = '0'; 

                        if (clinicas[1].scale == 'Hs') codeNumber2 = '1'; 
                        if (clinicas[1].scale == 'D') codeNumber2 = '2'; 
                        if (clinicas[1].scale == 'Hy') codeNumber2 = '3'; 
                        if (clinicas[1].scale == 'Pd') codeNumber2 = '4'; 
                        if (clinicas[1].scale == 'Mf') codeNumber2 = '5'; 
                        if (clinicas[1].scale == 'Pa') codeNumber2 = '6'; 
                        if (clinicas[1].scale == 'Pt') codeNumber2 = '7'; 
                        if (clinicas[1].scale == 'Sc') codeNumber2 = '8'; 
                        if (clinicas[1].scale == 'Ma') codeNumber2 = '9'; 
                        if (clinicas[1].scale == 'Si') codeNumber2 = '0'; 
                        let combination = `${clinicas[0].scale}${clinicas[1].scale}`;
                        this.mmpi2Combination.code = combination + ` ${codeNumber1}-${codeNumber2}/${codeNumber2}-${codeNumber1}`;
                        let combinations = await this.mmpi2Service.getCombinations().toPromise();
                        this.setCustomColors()
                        combinations.map(
                          c=>{
                            if (`${c.code1}${c.code2}`== combination||`${c.code2}${c.code1}`== combination) this.mmpi2Combination.description = c.text;
                          }
                        )
                        if (clinicas[1].value-clinicas[2].value>=10){
                          this.mmpi2Combination.definition = "Muy elevado";
                        }else{
                          if (clinicas[1].value-clinicas[2].value>=5){
                            this.mmpi2Combination.definition = "Elevado";
                          }else this.mmpi2Combination.definition = "Bajo";
                        }
                      },100);
                      for (let s in convertedScores){
                        interpretations.map(
                          i=>{
                            if (i.scale==s){
                              i.ranks.map(
                                r=>{
                                  if (convertedScores[s].value>=r.min&&convertedScores[s].value<=r.max){
                                    if (s=='Mf'){
                                      if (this.evaluated.sex=='Masculino'){
                                        this.mmpi2Array.push({title:`${s} - ${convertedScores[s].title}`, desc:r.name+" : " + r.text, type:convertedScores[s].type});
                                      }else{
                                        interpretations.map(
                                          x=>{
                                            if(x.scale=='MfM'){
                                              x.ranks.map(
                                                t=>{
                                                  if (convertedScores[s].value>=t.min&&convertedScores[s].value<=t.max){
                                                    this.mmpi2Array.push({title:`Mf - Masculinidad-Feminidad`, desc:t.name+" : " + t.text, type:convertedScores[s].type});
                                                  }
                                                }
                                              )
                                            }
                                          }
                                        )
                                        this.mmpi2Array.push({title:`${s} - ${convertedScores[s].title}`, desc:r.name+" : " + r.text, type:convertedScores[s].type});
                                      }
                                    }else{
                                      this.mmpi2Array.push({title:`${s} - ${convertedScores[s].title}`, desc:r.name+" : " + r.text, type:convertedScores[s].type});
                                    }
                                  }
                                }
                              )
                            }
                          }
                        )
                        if (this.selectedTest.extra=='Abreviado'){
     
                          if (convertedScores[s].type=='Validez') {
                            this.barChartLabels.push(`${s}`)
                            this.barChartDataMmpi2[0].data.push(convertedScores[s].value);
                            if(convertedScores[s].value<=40) {
                              colors.push('green');
                            }
                            if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                              colors.push('green');
                            }
                            if(convertedScores[s].value>80) {
                              colors.push('green');
                            }
                          }
                          if (convertedScores[s].type=='Clínicas') {
                            if (s=='Hs'||s=='D'||s=='Hy'||s=='Pd'||s=='Mf'||s=='Pa'||s=='Pt'||s=='Sc'||s=='Ma'||s=='Si'||s=='L'){
                              let title;
                              let code = "";
                              if (s == 'Hs') code = '1'; 
                              if (s == 'D') code = '2'; 
                              if (s == 'Hy') code = '3'; 
                              if (s == 'Pd') code = '4'; 
                              if (s == 'Mf') code = '5'; 
                              if (s == 'Pa') code = '6'; 
                              if (s == 'Pt') code = '7'; 
                              if (s == 'Sc') code = '8'; 
                              if (s == 'Ma') code = '9'; 
                              if (s=='Mf'){
                                if (this.evaluated.sex=='Masculino') title = `${code} Mf`;
                                else title = `${code} Mf`;
                              }else{
                                title = `${code} ${s} `
                              }
                              this.barChartLabels.push(title)
                              this.barChartDataMmpi2[0].data.push(convertedScores[s].value);
                              if(convertedScores[s].value<=40) {
                                colors.push('green');
                              }
                              if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                                colors.push('green');
                              }
                              if(convertedScores[s].value>80) {
                                colors.push('green');
                              }
                            }
                              if (s!='Hs'&&s!='D'&&s!='Hy'&&s!='Pd'&&s!='Mf'&&s!='MfM'&&s!='Pa'&&s!='Pt'&&s!='Sc'&&s!='Ma'&&s!='Si'&&s!='L'&&s!='?'&&s!='F'&&s!='K'&&s!='FB'&&s!='F(P)'&&s!='VRIN'&&s!='TRIN'){
                                this.barChartLabels4.push(`${s} `)
                                this.barChartDataMmpi24[0].data.push(convertedScores[s].value);
                                if(convertedScores[s].value<=40) {
                                  colors4.push('green');
                                }
                                if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                                  colors4.push('green');
                                }
                                if(convertedScores[s].value>80) {
                                  colors4.push('green');
                                }
                              }
                            
                          }
                          
                        }else{
                          if (convertedScores[s].type=='Validez') {
                            this.barChartLabels.push(`${s} `)
                            this.barChartDataMmpi2[0].data.push(convertedScores[s].value);
                            if(convertedScores[s].value<=40) {
                              colors.push('green');
                            }
                            if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                              colors.push('green');
                            }
                            if(convertedScores[s].value>80) {
                              colors.push('green');
                            }
                          }
                          if (convertedScores[s].type=='Clínicas') {
                            if (s=='Hs'||s=='D'||s=='Hy'||s=='Pd'||s=='Mf'||s=='Pa'||s=='Pt'||s=='Sc'||s=='Ma'||s=='Si'||s=='L'){
                              let title;
                              let code = "";
                              if (s == 'Hs') code = '1'; 
                              if (s == 'D') code = '2'; 
                              if (s == 'Hy') code = '3'; 
                              if (s == 'Pd') code = '4'; 
                              if (s == 'Mf') code = '5'; 
                              if (s == 'Pa') code = '6'; 
                              if (s == 'Pt') code = '7'; 
                              if (s == 'Sc') code = '8'; 
                              if (s == 'Ma') code = '9'; 
                              if (s == 'Si') code = '0'; 
                              if (s=='Mf'){
                                if (this.evaluated.sex=='Masculino') title = `${code} Mf`;
                                else title = `${code} Mf`;
                              }else{
                                title = `${code} ${s} `
                              }
                              this.barChartLabels.push(title)
                              this.barChartDataMmpi2[0].data.push(convertedScores[s].value);
                              if(convertedScores[s].value<=40) {
                                colors.push('green');
                              }
                              if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                                colors.push('green');
                              }
                              if(convertedScores[s].value>80) {
                                colors.push('green');
                              }
                            }
                              if (s!='Hs'&&s!='D'&&s!='Hy'&&s!='Pd'&&s!='Mf'&&s!='MfM'&&s!='Pa'&&s!='Pt'&&s!='Sc'&&s!='Ma'&&s!='Si'&&s!='L'&&s!='?'&&s!='F'&&s!='K'&&s!='FB'&&s!='F(P)'&&s!='VRIN'&&s!='TRIN'){
                                this.barChartLabels4.push(`${s} `)
                                this.barChartDataMmpi24[0].data.push(convertedScores[s].value);
                                if(convertedScores[s].value<=40) {
                                  colors4.push('green');
                                }
                                if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                                  colors4.push('green');
                                }
                                if(convertedScores[s].value>80) {
                                  colors4.push('green');
                                }
                              }
                            
                          }
                          if (convertedScores[s].type=='Contenido'){
                            this.barChartLabels2.push(`${s} `)
                            this.barChartDataMmpi22[0].data.push(convertedScores[s].value);
                            if(convertedScores[s].value<=40) {
                              colors2.push('green');
                            }
                            if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                              colors2.push('green');
                            }
                            if(convertedScores[s].value>80) {
                              colors2.push('green');
                            }
                          }
                          if (convertedScores[s].type=='Suplementarias'){
                            this.barChartLabels3.push(`${s} `)
                            this.barChartDataMmpi23[0].data.push(convertedScores[s].value);
                            if(convertedScores[s].value<=40) {
                              colors3.push('green');
                            }
                            if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                              colors3.push('green');
                            }
                            if(convertedScores[s].value>80) {
                              colors3.push('green');
                            }
                        }
                      }
                      }

                      if (this.selectedTest.extra == 'Abreviado'){
                        colors = colors.concat(colors4);
                        let auxArray = [];
                        auxArray = this.barChartDataMmpi2[0].data;
                        auxArray = auxArray.concat(this.barChartDataMmpi24[0].data);
                        this.barChartDataMmpi2[0].data = auxArray;
                        auxArray = this.barChartLabels;
                        auxArray = auxArray.concat(this.barChartLabels4);
                        this.barChartLabels = auxArray;
                      }
                      this.barChartDataMmpi2[0].backgroundColor=colors;
                      this.barChartDataMmpi22[0].backgroundColor=colors2;
                      this.barChartDataMmpi23[0].backgroundColor=colors3;
                      this.barChartDataMmpi24[0].backgroundColor=colors4;
                      this.isLoading = false;
                    },
                    err=>console.log(err)
                  )
                },
                err=>console.log(err)
              )
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }


    //MMPI-A

    if(this.selectedType=='MMPIA'){
      this.isLoading = true;
      setTimeout(()=>{
        this.mmpiaReport.nativeElement.innerHTML = this.description.mmpiaReportText;
      }, 500)
      this.mmpiaService.getQuestion().subscribe(
        resp=>{
          this.mmpiaQuestions = resp;
        },
        err=>console.log(err)
      )
      var factors=[]; //factores para comparar puntajes T
      this.mmpiaService.getInterpretations().subscribe(
        resp=>{
          factors=resp;
          this.mmpiaService.getReport(test.reportId).subscribe(
            async resp=>{
              this.report = resp;
              this.userService.getUserByEmail(test.evaluated).subscribe(
                resp=>{
                  this.mmpiaService.getScalesT({sex:resp.sex=='Masculino'?'M':'F', baremo:test.baremo}).subscribe(
                    async resp=>{
                      let scores = {
                        "?":{
                          title:'Interrogante',
                          value:0,
                          type:'Validez',
                          pd:0
                        }
                      };
                      this.mmpiaBaremos = resp;
                      let acceptedScales;
                      if (this.selectedTest.extra =='Abreviado') acceptedScales = await this.mmpiaService.getShortScales().toPromise();
                      else acceptedScales = await this.mmpiaService.getScales().toPromise();
                      for (let s in acceptedScales){
                        if (s!='all'){
                          acceptedScales[s].map(
                            x=>{
                              if (this.selectedTest.extra =='Abreviado'){
                                if (x.value!='FB'&&x.value!='F(P)'&&x.value!='VRIN'&&x.value!='TRIN'){
                                  if (x.value!=''){
                                    if (!scores[x.value]) scores[x.value] = {};
                                    scores[x.value].value = 0;
                                    scores[x.value].pd = 0;
                                    scores[x.value].title = x.title;
                                    if (s=='validez') scores[x.value].type = 'Validez';
                                    if (s=='clinicas') scores[x.value].type = 'Clínicas';
                                  }
                                } 
                              }else {
                                if (x.value!=''){
                                  if (!scores[x.value]) scores[x.value] = {};
                                  if (s=='validez') scores[x.value].type = 'Validez';
                                  if (s=='clinicas') scores[x.value].type = 'Clínicas';
                                  if (s=='suplementarias') scores[x.value].type = 'Suplementarias';
                                  if (s=='contenido') scores[x.value].type = 'Contenido';
                                  scores[x.value].value = 0;
                                  scores[x.value].pd = 0;
                                  scores[x.value].title = x.title;
                                }
                              }
                            }
                          )
                        }
                      }
                      if (this.evaluated.sex=='Femenino'){
                        scores['Mf'].title = scores['MfM'].title;
                      }
                      if (this.selectedTest.extra !='Abreviado') scores['TRIN'].value = 9;
                      let questions = await this.mmpiaService.getQuestion().toPromise();
                      if (this.selectedTest.extra =='Abreviado') questions = questions.splice(0,350);
                      let i = 0;
                      questions.map(
                        question=>{
                          if(this.report.answers[i]===null){
                            this.mmpiaNullAnswers.push(i);
                            scores["?"].value++;
                            scores["?"].pd++;
                          }
                          question.values.map(
                            q=>{
                              if (q.value==this.report.answers[i]){
                                if (scores[q.scale]) scores[q.scale].value++;
                              }
                            }
                          )
                          if (this.selectedTest.extra !='Abreviado'&&question.isPair){
                            question.equalPairs.map(
                              pair=>{
                                if(pair.scale=='TRIN'){
                                  if(pair.value1==this.report.answers[pair.index1]&&pair.value2==this.report.answers[pair.index2]&&pair.index2>i){
                                    if (pair.value1) if (scores[pair.scale]) scores[pair.scale].value++;
                                    else if (scores[pair.scale]) scores[pair.scale].value--;
                                  }
                                }else{
                                  if(pair.value1==this.report.answers[pair.index1]&&pair.value2==this.report.answers[pair.index2]&&pair.index2>i){
                                    if (scores[pair.scale]) scores[pair.scale].value++;
                                  }
                                }
                              }
                            )
                          }
                          i++;
                        }
                      )
                      let convertedScores = scores;
                      for (let s in scores){
                        this.mmpiaBaremos.map(
                          scale=>{
                            if (scale.scale==s){
                              let maxPd = 0;
                              let maxT = 0;
                              let founded = false;
                              scale.data.map(
                                value=>{
                                  if (value.pd>maxPd) {
                                    maxPd = value.pd;
                                    maxT = value.t;
                                  }
                                  if(value.pd==scores[s].value){
                                    founded = true;
                                    convertedScores[s].pd = convertedScores[s].value; 
                                    convertedScores[s].value = value.t;
                                    if (s=='F') convertedScores[s].value = convertedScores[s].value/1.5;
                                    if (s=='F1') convertedScores[s].value = convertedScores[s].value - 15;
                                  } 
                                }
                              )
                              if (!founded){
                                convertedScores[s].pd = convertedScores[s].value; 
                                convertedScores[s].value = maxT;
                                if (s=='F') convertedScores[s].value = convertedScores[s].value/1.5;
                                if (s=='F1') convertedScores[s].value = convertedScores[s].value - 15;
                              }
                            }
                          }
                        )
                      }
                      var colors=[];
                      var colors2=[];
                      var colors3=[];
                      var colors4=[];
                      let interpretations = await this.mmpiaService.getInterpretations().toPromise();
                      this.mmpiaResults = convertedScores;
                      this.mmpiaResults['?'].value = this.mmpiaResults['?'].pd;
                      let clinicas = [];
                      for (let result in this.mmpiaResults){
                        if (this.mmpiaResults[result].type=='Clínicas'&&(result=='Hs'||result=='D'||result=='Hi'||result=='Dp'||result=='Mf'||result=='Pa'||result=='Pt'||result=='Es'||result=='Ma'||result=='Is')) clinicas.push(this.mmpiaResults[result]);
                      }
                      clinicas.sort(function(a,b){
                        return (b.value-a.value)
                      })
                      setTimeout(async()=>{
                        let codeNumber1="";
                        let codeNumber2="";
                        if (clinicas[0].scale == 'Hs') codeNumber1 = '1'; 
                        if (clinicas[0].scale == 'D') codeNumber1 = '2'; 
                        if (clinicas[0].scale == 'Hi') codeNumber1 = '3'; 
                        if (clinicas[0].scale == 'Dp') codeNumber1 = '4'; 
                        if (clinicas[0].scale == 'Mf') codeNumber1 = '5'; 
                        if (clinicas[0].scale == 'Pa') codeNumber1 = '6'; 
                        if (clinicas[0].scale == 'Pt') codeNumber1 = '7'; 
                        if (clinicas[0].scale == 'Es') codeNumber1 = '8'; 
                        if (clinicas[0].scale == 'Ma') codeNumber1 = '9'; 
                        if (clinicas[0].scale == 'Is') codeNumber1 = '0'; 

                        if (clinicas[1].scale == 'Hs') codeNumber2 = '1'; 
                        if (clinicas[1].scale == 'D') codeNumber2 = '2'; 
                        if (clinicas[1].scale == 'Hi') codeNumber2 = '3'; 
                        if (clinicas[1].scale == 'Dp') codeNumber2 = '4'; 
                        if (clinicas[1].scale == 'Mf') codeNumber2 = '5'; 
                        if (clinicas[1].scale == 'Pa') codeNumber2 = '6'; 
                        if (clinicas[1].scale == 'Pt') codeNumber2 = '7'; 
                        if (clinicas[1].scale == 'Es') codeNumber2 = '8'; 
                        if (clinicas[1].scale == 'Ma') codeNumber2 = '9'; 
                        if (clinicas[1].scale == 'Is') codeNumber2 = '0'; 
                        let combination = `${clinicas[0].scale}${clinicas[1].scale}`;
                        this.mmpiaCombination.code = combination + ` ${codeNumber1}-${codeNumber2}/${codeNumber2}-${codeNumber1}`;
                        let combinations = await this.mmpiaService.getCombinations().toPromise();
                        this.setCustomColors()
                        combinations.map(
                          c=>{
                            if (`${c.code1}${c.code2}`== combination||`${c.code2}${c.code1}`== combination) this.mmpiaCombination.description = c.text;
                          }
                        )
                        if (clinicas[1].value-clinicas[2].value>=10){
                          this.mmpiaCombination.definition = "Muy elevado";
                        }else{
                          if (clinicas[1].value-clinicas[2].value>=5){
                            this.mmpiaCombination.definition = "Elevado";
                          }else this.mmpiaCombination.definition = "Bajo";
                        }
                      },100);
                      for (let s in convertedScores){
                        interpretations.map(
                          i=>{
                            if (i.scale==s){
                              i.ranks.map(
                                r=>{
                                  if (convertedScores[s].value>=r.min&&convertedScores[s].value<=r.max){
                                    if (s=='Mf'){
                                      if (this.evaluated.sex=='Masculino'){
                                        this.mmpiaArray.push({title:`${s} - ${convertedScores[s].title}`, desc:r.name+" : " + r.text, type:convertedScores[s].type});
                                      }else{
                                        interpretations.map(
                                          x=>{
                                            if(x.scale=='MfM'){
                                              x.ranks.map(
                                                t=>{
                                                  if (convertedScores[s].value>=t.min&&convertedScores[s].value<=t.max){
                                                    this.mmpiaArray.push({title:`Mf - Masculinidad-Feminidad`, desc:t.name+" : " + t.text, type:convertedScores[s].type});
                                                  }
                                                }
                                              )
                                            }
                                          }
                                        )
                                        this.mmpiaArray.push({title:`${s} - ${convertedScores[s].title}`, desc:r.name+" : " + r.text, type:convertedScores[s].type});
                                      }
                                    }else{
                                      this.mmpiaArray.push({title:`${s} - ${convertedScores[s].title}`, desc:r.name+" : " + r.text, type:convertedScores[s].type});
                                    }
                                  }
                                }
                              )
                            }
                          }
                        )
                        if (this.selectedTest.extra=='Abreviado'){
                          if (convertedScores[s].type=='Validez') {
                            this.barChartLabels.push(`A-${s}`)
                            this.barChartDataMmpi2[0].data.push(convertedScores[s].value);
                            if(convertedScores[s].value<=40) {
                              colors.push('green');
                            }
                            if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                              colors.push('green');
                            }
                            if(convertedScores[s].value>80) {
                              colors.push('green');
                            }
                          }
                          if (convertedScores[s].type=='Clínicas') {
                            if (s=='Hs'||s=='D'||s=='Hi'||s=='Dp'||s=='Mf'||s=='Pa'||s=='Pt'||s=='Es'||s=='Ma'||s=='Is'||s=='L'){
                              let title;
                              let code;
                              if (s == 'Hs') code = '1'; 
                              if (s == 'D') code = '2'; 
                              if (s == 'Hi') code = '3'; 
                              if (s == 'Dp') code = '4'; 
                              if (s == 'Mf') code = '5'; 
                              if (s == 'Pa') code = '6'; 
                              if (s == 'Pt') code = '7'; 
                              if (s == 'Es') code = '8'; 
                              if (s == 'Ma') code = '9'; 
                              if (s == 'Is') code = '0'; 
                              if (s=='Mf'){
                                if (this.evaluated.sex=='Masculino') title = `A-${code} Mf`;
                                else title = `A-${code} Mf`;
                              }else{
                                title = `A-${code} ${s}`
                              }
                              this.barChartLabels.push(title)
                              this.barChartDataMmpi2[0].data.push(convertedScores[s].value);
                              if(convertedScores[s].value<=40) {
                                colors.push('green');
                              }
                              if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                                colors.push('green');
                              }
                              if(convertedScores[s].value>80) {
                                colors.push('green');
                              }
                            }
                              if (s!='Hs'&&s!='D'&&s!='Hi'&&s!='Dp'&&s!='Mf'&&s!='MfM'&&s!='Pa'&&s!='Pt'&&s!='Es'&&s!='Ma'&&s!='Is'&&s!='L'&&s!='?'&&s!='F'&&s!='K'&&s!='F1'&&s!='F2'&&s!='VRIN'&&s!='TRIN'){
                                this.barChartLabels4.push(`A-${s}`)
                                this.barChartDataMmpi24[0].data.push(convertedScores[s].value);
                                if(convertedScores[s].value<=40) {
                                  colors4.push('green');
                                }
                                if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                                  colors4.push('green');
                                }
                                if(convertedScores[s].value>80) {
                                  colors4.push('green');
                                }
                              }
                            
                          }
                          
                        }else{
                          if (convertedScores[s].type=='Validez') {
                            this.barChartLabels.push(`A-${s}`)
                            this.barChartDataMmpi2[0].data.push(convertedScores[s].value);
                            if(convertedScores[s].value<=40) {
                              colors.push('green');
                            }
                            if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                              colors.push('green');
                            }
                            if(convertedScores[s].value>80) {
                              colors.push('green');
                            }
                          }
                          if (convertedScores[s].type=='Clínicas') {
                            if (s=='Hs'||s=='D'||s=='Hi'||s=='Dp'||s=='Mf'||s=='Pa'||s=='Pt'||s=='Es'||s=='Ma'||s=='Is'||s=='L'){
                              let title;
                              let code;
                              if (s == 'Hs') code = '1'; 
                              if (s == 'D') code = '2'; 
                              if (s == 'Hi') code = '3'; 
                              if (s == 'Dp') code = '4'; 
                              if (s == 'Mf') code = '5'; 
                              if (s == 'Pa') code = '6'; 
                              if (s == 'Pt') code = '7'; 
                              if (s == 'Es') code = '8'; 
                              if (s == 'Ma') code = '9'; 
                              if (s == 'Is') code = '0'; 
                              if (s=='Mf'){
                                if (this.evaluated.sex=='Masculino') title = `A-${code} Mf`;
                                else title = `A-${code} Mf}`;
                              }else{
                                title = `A-${code} ${s}`
                              }
                              this.barChartLabels.push(title)
                              this.barChartDataMmpi2[0].data.push(convertedScores[s].value);
                              if(convertedScores[s].value<=40) {
                                colors.push('green');
                              }
                              if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                                colors.push('green');
                              }
                              if(convertedScores[s].value>80) {
                                colors.push('green');
                              }
                            }
                              if (s!='Hs'&&s!='D'&&s!='Hi'&&s!='Dp'&&s!='Mf'&&s!='MfM'&&s!='Pa'&&s!='Pt'&&s!='Es'&&s!='Ma'&&s!='Is'&&s!='L'&&s!='?'&&s!='F'&&s!='K'&&s!='F1'&&s!='F2'&&s!='VRIN'&&s!='TRIN'){
                                this.barChartLabels4.push(`A-${s}`)
                                this.barChartDataMmpi24[0].data.push(convertedScores[s].value);
                                if(convertedScores[s].value<=40) {
                                  colors4.push('green');
                                }
                                if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                                  colors4.push('green');
                                }
                                if(convertedScores[s].value>80) {
                                  colors4.push('green');
                                }
                              }
                            
                          }
                          if (convertedScores[s].type=='Contenido'){
                            this.barChartLabels2.push(`A-${s}`)
                            this.barChartDataMmpi22[0].data.push(convertedScores[s].value);
                            if(convertedScores[s].value<=40) {
                              colors2.push('green');
                            }
                            if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                              colors2.push('green');
                            }
                            if(convertedScores[s].value>80) {
                              colors2.push('green');
                            }
                          }
                          if (convertedScores[s].type=='Suplementarias'){
                            this.barChartLabels3.push(`A-${s}`)
                            this.barChartDataMmpi23[0].data.push(convertedScores[s].value);
                            if(convertedScores[s].value<=40) {
                              colors3.push('green');
                            }
                            if(convertedScores[s].value<=80&&convertedScores[s].value>40) {
                              colors3.push('green');
                            }
                            if(convertedScores[s].value>80) {
                              colors3.push('green');
                            }
                        }
                      }
                      }
                      let aux = this.barChartLabels4[13];
                      this.barChartLabels4.splice(13,1);
                      this.barChartLabels4.splice(8,0, aux);
                      aux = this.barChartLabels4[14];
                      this.barChartLabels4.splice(14,1);
                      this.barChartLabels4.splice(9,0, aux);

                      let n;
                      n = this.barChartDataMmpi24[0].data[13];
                      this.barChartDataMmpi24[0].data.splice(13,1);
                      this.barChartDataMmpi24[0].data.splice(8,0, n);
                      n = this.barChartDataMmpi24[0].data[14];
                      this.barChartDataMmpi24[0].data.splice(14,1);
                      this.barChartDataMmpi24[0].data.splice(9,0, n);


                      if (this.selectedTest.extra == 'Abreviado'){
                        colors = colors.concat(colors4);
                        let auxArray = [];
                        auxArray = this.barChartDataMmpi2[0].data;
                        auxArray = auxArray.concat(this.barChartDataMmpi24[0].data);
                        this.barChartDataMmpi2[0].data = auxArray;
                        auxArray = this.barChartLabels;
                        auxArray = auxArray.concat(this.barChartLabels4);
                        this.barChartLabels = auxArray;
                      }
                      this.barChartDataMmpi2[0].backgroundColor=colors;
                      this.barChartDataMmpi22[0].backgroundColor=colors2;
                      this.barChartDataMmpi23[0].backgroundColor=colors3;
                      this.barChartDataMmpi24[0].backgroundColor=colors4;
                      this.isLoading = false;
                    },
                    err=>console.log(err)
                  )
                },
                err=>console.log(err)
              )
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }


    //MIPS

    if(this.selectedType=='MIPS'){
      setTimeout(()=>{
        if (this.description.mipsReportText) this.mipsReport.nativeElement.innerHTML = this.description.mipsReportText;
      }, 500)
      var interpretations=[];
      this.mipsService.getInterpretations().subscribe(
        resp=>{
          interpretations = resp;
          this.mipsService.getReport(test.reportId).subscribe(
            async resp=>{
              this.report = resp;
              let dataQuestions = await this.mipsService.getQuestions().toPromise();
              let baremo = await this.mipsService.getScales().toPromise();
              this.setCustomColors()
              // console.log(this.report.answers)
              // console.log(dataQuestions);
              // console.log(baremo);
              let convertedScores = {};
              for (let scale of baremo){
                convertedScores[scale.scale] = {pd:0, pp:0, group:scale.group, itemsCount: 0, itemsCorrect: 0};
              }
              convertedScores["Impresión Positiva"] = {pd:0, pp:0, itemsCount: 0, itemsCorrect: 0};
              convertedScores["Impresión Negativa"] = {pd:0, pp:0, itemsCount: 0, itemsCorrect: 0};
              convertedScores["Consistencia"] = {pd:0, pp:0, itemsCount: 0, itemsCorrect: 0};
              let i = 0;
              for (let a of this.report.answers){
                for (let v of dataQuestions[i].values){
                  convertedScores[v.scale].itemsCount++;
                  if (a==v.value){
                    convertedScores[v.scale].pd+=v.score;
                    convertedScores[v.scale].itemsCorrect++;
                  }
                }
                i++;
              }
              for (let q in convertedScores){
                for (let b of baremo){
                  if (q == b.scale){
                    b.data.map(
                      resp=>{
                      if (resp.pd==convertedScores[q].pd) convertedScores[q].pp = resp.pp;
                      }
                    )
                  }
                }
                if (convertedScores[q].pp == 0 && convertedScores[q].pd >20){
                  convertedScores[q].pp = 100;
                }
              }
              if (this.report.answers[87]!=this.report.answers[141]) convertedScores['Consistencia'].pd++;
              if (this.report.answers[164]!=this.report.answers[116]) convertedScores['Consistencia'].pd++;
              if (this.report.answers[175]!=this.report.answers[142]) convertedScores['Consistencia'].pd++;
              if (this.report.answers[178]!=this.report.answers[117]) convertedScores['Consistencia'].pd++;
              if (this.report.answers[138]!=this.report.answers[87]) convertedScores['Consistencia'].pd++;
              this.mipsAjuste = 50 + ((((convertedScores['1A - Apertura'].pp+(convertedScores['8B- Comunicatividad'].pp+convertedScores['9B- Firmeza'].pp+convertedScores['10B- Conformismo'].pp+convertedScores['11B- Control'].pp+convertedScores['12B- Concordancia'].pp)/5)/2) - ((convertedScores['1B - Preservación'].pp+(convertedScores['8A- Retraimiento'].pp+convertedScores['9A- Vacilación'].pp+convertedScores['10A- Discrepancia'].pp+convertedScores['11A- Sometimiento'].pp+convertedScores['12A- Insatisfacción'].pp)/5)/2) - 19)/38)*10;
              this.mipsAjuste = Number(this.mipsAjuste.toFixed(2));
              // console.log(convertedScores)
              // console.log(this.mipsAjuste)
              //console.log(interpretations)
              var colors=[];
              for (let s in convertedScores){
                if (!convertedScores[s].group) {
                  interpretations.map(
                    i=>{
                      if (i.scale == s){
                        i.ranks.map(
                          r=>{
                            if (r.min<=convertedScores[s].pd&&r.max>=convertedScores[s].pd){
                              convertedScores[s].title = s +" - "+ r.name;
                              convertedScores[s].desc = r.text;
                            }
                          }
                        )
                      }
                    }
                  )
                  if (convertedScores[s].title) this.mipsValidezArray.push(convertedScores[s]);
                }
                else{
                  colors.push('#4c9f00');
                  this.barChartLabels.push(`${s.toUpperCase()}`)
                  this.barChartData[0].data.push(convertedScores[s].pp);
                  interpretations.map(
                    i=>{
                      if (i.scale == s){
                        i.ranks.map(
                          r=>{
                            if (r.min<=convertedScores[s].pp&&r.max>=convertedScores[s].pp){
                              convertedScores[s].title = s +" - "+ r.name;
                              convertedScores[s].desc = r.text;
                            }
                          }
                        )
                        if (!convertedScores[s].title){
                          convertedScores[s].title = s;
                          convertedScores[s].desc = i.ranks[0].text.replace("Lo que supone que el evaluado comparte características con el grupo poseedor del rasgo.", "");
                        }
                      }
                    }
                  )
                  if (convertedScores[s].title){
                    if (convertedScores[s].group=='Metas Motivacionales') this.mipsMotivacionalesArray.push(convertedScores[s]);
                    if (convertedScores[s].group=='Modos Cognitivos') this.mipsCognitivosArray.push(convertedScores[s]);
                    if (convertedScores[s].group=='Conductas Interpersonales') this.mipsInterpersonalesArray.push(convertedScores[s]);
                  }
                }
                let obj = convertedScores[s];
                obj.scale = s;
                this.mipsArray.push(obj)
              }
              // console.log(this.mipsArray)
              //console.log(this.mipsValidezArray)
              this.barChartData[0].backgroundColor=colors;
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }

    //BIS11

    if(this.selectedType=='BIS11'){
      setTimeout(()=>{
        this.bis11Report.nativeElement.innerHTML = this.description.bis11ReportText;
      }, 500)
      var interpretations=[];
      this.bis11Service.getInterpretations().subscribe(
        resp=>{
          interpretations=resp;
          this.bis11Service.getReport(test.reportId).subscribe(
            async resp=>{
              this.report = resp;
              let questions = await this.bis11Service.getQuestions().toPromise();
              this.setCustomColors()
              let i = 0;
              this.report.answers.map(
                a=>{
                  questions[i].scale
                  if (questions[i].ascendent){
                    if (a=="A") {
                      this.bis11Results[questions[i].scale]+=1;
                      this.bis11Results["Puntuación total"]+=1;
                    }
                    if (a=="B") {
                      this.bis11Results[questions[i].scale]+=2;
                      this.bis11Results["Puntuación total"]+=2;
                    }
                    if (a=="C") {
                      this.bis11Results[questions[i].scale]+=3;
                      this.bis11Results["Puntuación total"]+=3;
                    }
                    if (a=="D") {
                      this.bis11Results[questions[i].scale]+=4;
                      this.bis11Results["Puntuación total"]+=4;
                    }
                  }
                  if (!questions[i].ascendent){
                    if (a=="A") {
                      this.bis11Results[questions[i].scale]+=4;
                      this.bis11Results["Puntuación total"]+=4;
                    }
                    if (a=="B") {
                      this.bis11Results[questions[i].scale]+=3;
                      this.bis11Results["Puntuación total"]+=3;
                    }
                    if (a=="C"){ 
                      this.bis11Results[questions[i].scale]+=2;
                      this.bis11Results["Puntuación total"]+=2;
                    }
                    if (a=="D") {
                      this.bis11Results[questions[i].scale]+=1;
                      this.bis11Results["Puntuación total"]+=1;
                    }
                  }
                  i++;
                }
              )
              for (let s in this.bis11Results){
                interpretations.map(
                  i=>{
                    if (s==i.scale){
                      i.rank.map(
                        r=>{
                          if (this.bis11Results[s]>=r.low&&this.bis11Results[s]<r.high){
                            let obj = {
                              scale:s,
                              title:s+" - "+r.title,
                              desc:r.description
                            }
                            this.bis11Array.push(obj)                      
                          }
                        }
                      )
                    }
                  }
                )
              }
              let cont = 0
              this.report.answers.map(
                r=>{
                  if (r=='A'){
                    this.bis11NuncaArray.push({
                      number:cont+1,
                      question:questions[cont].title
                    })
                  }
                  if (r=='B'){
                    this.bis11OcasionalmenteArray.push({
                      number:cont+1,
                      question:questions[cont].title
                    })
                  }
                  if (r=='C'){
                    this.bis11AMenudoArray.push({
                      number:cont+1,
                      question:questions[cont].title
                    })
                  }
                  if (r=='D'){
                    this.bis11SiempreArray.push({
                      number:cont+1,
                      question:questions[cont].title
                    })
                  }
                  cont++
                }
              )
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }


    if(this.selectedType=='CHASIDE'){
      setTimeout(()=>{
        this.chasideReport.nativeElement.innerHTML = this.description.chasideReportText;
      }, 500)
      var interpretations=[];
      this.chasideService.getInterpretations().subscribe(
        resp=>{
          this.chasideInterpretations = resp;
          this.chasideService.getReport(test.reportId).subscribe(
            async resp=>{
              let questions = await this.chasideService.getQuestions().toPromise();
              this.setCustomColors()
              this.report = resp;
              let scores = {
                Intereses:{

                },
                Aptitudes:{

                }
              }
              let i = 0;
              for (let a of this.report.answers){
                if (!scores[questions[i].group][questions[i].scale]) scores[questions[i].group][questions[i].scale] = 0;
                if (a){
                  scores[questions[i].group][questions[i].scale]++;
                }
                i++;
              }
              this.chasideScores = scores;
              let maxIntereses={
                scale:"",
                value:0
              };
              let maxAptitudes={
                scale:"",
                value:0
              };;
              for (let s in scores.Intereses){
                let index = 0;
                let type = ""
                if (s=='C'){
                  type = "C. CONTABLES";
                  index = 0
                } 
                if (s=='H'){
                  type = "C. HUMANAS";
                  index = 1
                } 
                if (s=='A'){
                  type = "C. ARTÍSTICAS";
                  index = 2
                } 
                if (s=='S'){
                  type = "C. SALUD";
                  index = 3
                } 
                if (s=='I'){
                  type = "C. INGENIERIAS";
                  index = 4
                } 
                if (s=='D'){
                  type = "C. DEFENSA";
                  index = 5
                } 
                if (s=='E'){
                  type = "C. EXACTAS";
                  index = 6
                } 
                this.barChartLabels[index] = type;
                this.barChartDataChaside[0].data[index] = scores.Intereses[s];
                if (scores.Intereses[s]>maxIntereses.value){
                  maxIntereses.value = scores.Intereses[s];
                  maxIntereses.scale = s
                }
              }
              for (let s in scores.Aptitudes){

                let index = 0;
                if (s=='C'){
                  index = 0
                } 
                if (s=='H'){
                  index = 1
                } 
                if (s=='A'){
                  index = 2
                } 
                if (s=='S'){
                  index = 3
                } 
                if (s=='I'){
                  index = 4
                } 
                if (s=='D'){
                  index = 5
                } 
                if (s=='E'){
                  index = 6
                } 

                this.barChartDataChaside[1].data[index] = scores.Aptitudes[s];
                if (scores.Aptitudes[s]>maxAptitudes.value){
                  maxAptitudes.value = scores.Aptitudes[s];
                  maxAptitudes.scale = s
                }
              }
              for (let i of this.chasideInterpretations){
                this.chasideArray.push({interpretation:i, value: maxIntereses.value})                
              }
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }


    if(this.selectedType=='DOMINO'){
      let startDate = new Date(this.selectedTest.startDate);
      let endDate = new Date(this.selectedTest.completeDate);
      this.testTime = endDate.getTime() - startDate.getTime();
      setTimeout(()=>{
        this.dominoReport.nativeElement.innerHTML = this.description.dominoReportText;
      }, 500)
      var factors=[];
      this.dominoService.getInterpretations().subscribe(
        resp=>{
          let factor: DominoInterpretation = resp;
          this.dominoService.getReport(test.reportId).subscribe(
            resp=>{
              this.setCustomColors()
              this.report = resp;
              this.directScore = resp.directScore
              this.naturalScore = resp.naturalScore

              let report;
              if (this.naturalScore >= 95){
                report = factor.veryHighDesc
              }
              if (this.naturalScore >= 75 && this.naturalScore < 95){
                report = factor.highDesc
              }
              if (this.naturalScore >= 50 && this.naturalScore < 75){
                report = factor.midDesc
              }
              if (this.naturalScore >= 10 && this.naturalScore < 50){
                report = factor.lowDesc
              }
              if (this.naturalScore < 10){
                report = factor.veryLowDesc
              }

              this.dominoFactor.nativeElement.innerHTML = toHTML(report);
              
             
              // var scores = resp.scoreConverted;
              // var colors=[];
              // var cont=0;
              // for (let s in scores){
              //   this.barChartLabels.push(`Factor ${s}`)
              //   this.barChartData[0].data.push(scores[s]);
              //   if(scores[s]<=5) {
              //     if(scores[s]==5){
              //       colors.push('#4c9f00');
              //     }else{
              //       colors.push('#f7b11e');

              //     }

              //     this.pf16Array.push({title:`Factor ${s}`, desc:factors[cont].lowDesc, high: false})

              //   }else {
              //     if(scores[s]==6){
              //       colors.push('#4c9f00');
              //     }else{
              //       colors.push('#f7b11e');
              //     }

              //     this.pf16Array.push({title:`Factor ${s}`, desc:factors[cont].highDesc, high: true})
              //   }
              //   cont++;
              // }
              // this.barChartData[0].backgroundColor=colors;
            },
            err=>console.log(err)
            )
        },
        err=>{
          console.log(err)
        }
      )
    }

  }

  disableScroll(){  
    window.scrollTo(0, 0);
  }
  
  filterScales (value, arg, se=''){

    let response = [];
    for (let i in value){
      if (arg!='Clínicas'&&arg!='Lingoes'){
        if (value[i].type==arg) {
          value[i].scale = i;
          if (arg!='Suplementarias') response.push(value[i]);
          else{
            if (se=='cg'&&(i=='A'||i=='R'||i=='Es'||i=='Do'||i=='Re')) response.push(value[i]);
            if (se=='me'&&(i=='MT'||i=='PK'||i=='MDS'||i=='PS')) response.push(value[i]);
            if (se=='dc'&&(i=='O-H'||i=='Mac-R'||i=='AAS'||i=='APS')) response.push(value[i]);
            if (se=='rg'&&(i=='GM'||i=='GF')) response.push(value[i]);

            if (se=='cg'&&(value[i].title.indexOf('A ')==0||value[i].title.indexOf('R ')==0||value[i].title.indexOf('Es ')==0||value[i].title.indexOf('Do')==0||value[i].title.indexOf('Re ')==0)&&value[i].title!='AAS - Reconocimiento de adicción'&&value[i].title!='APS') response.push(value[i]);
            if (se=='me'&&(value[i].title.indexOf('MT')==0||value[i].title.indexOf('PK')==0||value[i].title.indexOf('MDS')==0||value[i].title.indexOf('PS')==0)) response.push(value[i]);
            if (se=='dc'&&(value[i].title.indexOf('O-H')==0||value[i].title.indexOf('Mac-R')==0||value[i].title.indexOf('AAS')==0||value[i].title.indexOf('APS')==0)) response.push(value[i]);
            if (se=='rg'&&(value[i].title.indexOf('GM')==0||value[i].title.indexOf('GF')==0)) response.push(value[i]);
          }
        }
      }
      if (arg=='Clínicas'){
        if (i=='Hs'||i=='D'||i=='Hy'||i=='Pd'||i=='Mf'||i=='Pa'||i=='Pt'||i=='Sc'||i=='Ma'||i=='Si'||value[i].title.indexOf('Hs ')==0||value[i].title.indexOf('D ')==0||value[i].title.indexOf('Hy ')==0||value[i].title.indexOf('Pd ')==0||value[i].title.indexOf('Mf ')==0||value[i].title.indexOf('Pa ')==0||value[i].title.indexOf('Pt ')==0||value[i].title.indexOf('Sc ')==0||value[i].title.indexOf('Ma ')==0||value[i].title.indexOf('Si ')==0){
          value[i].scale = i;
          response.push(value[i])
        }
      }
      if (arg=='Lingoes'){
        if (value[i].type=='Clínicas'&&i!='Hs'&&i!='D'&&i!='Hy'&&i!='Pd'&&i!='Mf'&&i!='MfM'&&i!='Pa'&&i!='Pt'&&i!='Sc'&&i!='Ma'&&i!='Si'&&i!='L'&&i!='?'&&i!='F'&&i!='K'&&i!='FB'&&i!='F(P)'&&i!='VRIN'&&i!='TRIN'){
          value[i].scale = i;
          if (i.indexOf(se)==0||(value[i].title.indexOf(se)==0&&value[i].title!='D - Depresión'&&value[i].title!='Discordia familiar')) {
            response.push(value[i])
          }
            
        }
      }
    }
    return response;
  }

  filterScalesMMpia (value, arg, se=''){

    let response = [];
    for (let i in value){
      if (arg!='Clínicas'&&arg!='Lingoes'){
        if (value[i].type==arg) {
          value[i].scale = i;
          if (arg!='Suplementarias') response.push(value[i]);
          else{
            if ((i=='A'||i=='INM'||i=='Mac-R'||i=='PPA'||i=='R'||i=='RA')) response.push(value[i]);
            if ((value[i].title.indexOf('A ')==0||value[i].title.indexOf('INM')==0||value[i].title.indexOf('Mac-R')==0||value[i].title.indexOf('PPA')==0||value[i].title.indexOf('R')==0||value[i].title.indexOf('RA')==0)) response.push(value[i]);
          }
        }
      }
      if (arg=='Clínicas'){
        if (i=='Hs'||i=='D'||i=='Hi'||i=='Dp'||i=='Mf'||i=='Pa'||i=='Pt'||i=='Es'||i=='Ma'||i=='Is'||value[i].title.indexOf('Hs ')==0||value[i].title.indexOf('D ')==0||value[i].title.indexOf('Hi ')==0||value[i].title.indexOf('Dp ')==0||value[i].title.indexOf('Mf ')==0||value[i].title.indexOf('Pa ')==0||value[i].title.indexOf('Pt ')==0||value[i].title.indexOf('Es ')==0||value[i].title.indexOf('Ma ')==0||value[i].title.indexOf('Is ')==0){
          value[i].scale = i;
          response.push(value[i])
        }
      }
      if (arg=='Lingoes'){
        if (value[i].type=='Clínicas'&&i!='Hs'&&i!='D'&&i!='Hi'&&i!='Dp'&&i!='Mf'&&i!='MfM'&&i!='Pa'&&i!='Pt'&&i!='Es'&&i!='Ma'&&i!='Is'&&i!='L'&&i!='?'&&i!='F'&&i!='K'&&i!='F1'&&i!='F2'&&i!='VRIN'&&i!='TRIN'){
          value[i].scale = i;
          if (i.indexOf(se)==0||(value[i].title.indexOf(se)==0&&value[i].title!='D - Depresión'&&value[i].title!='Discordia familiar'&&value[i].title!='Es - Esquizofrenia')) {
            if (se=='D'&&(value[i].scale!='Dp1'&&value[i].scale!='Dp2'&&value[i].scale!='Dp3'&&value[i].scale!='Dp4'&&value[i].scale!='Dp5')&&(value[i].title.indexOf('Dp')==-1)){
              if (response.indexOf(value[i])==-1) response.push(value[i])
            }else if (se!='D') if (response.indexOf(value[i])==-1) response.push(value[i])
          }
        }
      }
    }
    return response;
  }

  viewPhoto(url){
    this.userPhoto = url;
    $('#userPhotoModal').modal('show');
  }

  viewForm(test, showPdf = false){
    this.testData = test;
    this.documentReady = false
    if (showPdf){
      $('#exportingModal').modal('show');
      this.isExporting = true;
    }
    setTimeout(()=>{
      $('#exportingModal').modal('hide');
      this.documentReady = true;
      if (showPdf) this.generatePdf();
    },3000)
    this.scrollTop();
    this.selectedTest = test;
    this.selectedType = test.type;
    // console.log(this.selectedTest)


    this.userService.getUserByEmail(test.evaluated).subscribe(
      resp=>{
        this.evaluated = resp;
        this.setCustomColors()
        if(this.selectedTest.type=='MMPI2') this.mmpi2Service.getScalesT({sex:this.evaluated.sex=='Masculino'?'M':'F', baremo:this.selectedTest.baremo}).subscribe(
          resp=>{
            this.mmpi2Baremos = resp;
          },
          err=>console.log(err)
        )
        var fechaInicio = new Date(resp.birthDate).getTime();
        var fechaFin    = new Date(Date.now()).getTime();

        var diff = fechaFin - fechaInicio;

        this.age = Math.round(diff/(1000*60*60*24*365));
      },
      err=>console.log(err)
    )


    // setTimeout(()=>{
    //   this.pfReport.nativeElement.innerHTML = this.description.pf16ReportText;
    // }, 500)

    // this.testData = test;
    // console.log(this.testData)
    // setTimeout(()=>{
    //   $('#formModal').modal('show');
    // },200);
  }

  async share(){
    let url = `${location.origin}/dashboard/clientEvaluated?share=${this.selectedTest._id}`;
    await navigator.clipboard.writeText(url);
    Swal.fire({
      icon:'success',
      text:'Enlace copiado al portapapeles',
      showConfirmButton: false,
      timer: 1500
    })
  }

  deleteTest(test){
    Swal.fire({
      icon:'question',
      text:'¿Eliminar prueba? Esta acción no podrá revertirse. Los créditos serán devueltos a su cuenta.',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    }).then(
      resp => {
        if (resp.isConfirmed){
          this.testService.removeTest(test._id).subscribe(
            resp=>{
              location.reload();
            },
            err=>{
              console.log(err)
            }
          )
        }
      }
    )
  }

  getMipsTextColor(stringValue: string){
    let value = Number(stringValue);
    if (value < 50) return ''
    if (value >= 50 && value < 70) return 'text-yellow'
    if (value >= 70) return 'text-danger'
  }

  addTag(test: any){
    let found = this.tests.findIndex(t => t._id == test._id);
    this.addingTagTestIndex = found;
    $('#newTagModal').modal('show');

  }

  createTag(){
    this.tests[this.addingTagTestIndex + (this.actualPage - 1) * 7].tags.push({
      name: this.newTagName,
      color: this.newTagColor || '#3A8BF7'
    });
    this.testService.updateTest(this.tests[this.addingTagTestIndex + (this.actualPage - 1) * 7], false).subscribe()
    $('#newTagModal').modal('hide');
    this.newTagColor = '';
    this.newTagName = '';
    this.addingTagTestIndex = -1;

  }

  removeTag(test: any, index: number){
    Swal.fire({
      title: '¿Eliminar etiqueta?',
      text: test.tags[index].name,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(
      resp => {
        if (resp.isConfirmed){
          test.tags.splice(index, 1);
          this.testService.updateTest(test, false).subscribe()
        }
      }
    )
  }

  changePage(toAdd: number){
    if (!this.viewMassive){
      if (this.actualPage+toAdd>=1&&this.actualPage+toAdd<=this.getPages(this.testFilterPipe.transform(this.foldersPipe.transform(this.tests, this.folderFilter), this.testFilter).length)){
        this.actualPage+=toAdd;
      }
    }else{
      if (this.actualPage+toAdd>=1&&this.actualPage+toAdd<=Math.ceil(this.massiveData.length/7)){
        this.actualPage+=toAdd;
      }
    }
  }

  getQuestionScore(i: number){
    let value = this.testData.formData[i];
    if (this.testData.formModel[i].type == 'number'){
      if (value == this.testData.formModel[i].correctValue) return `${this.testData.formModel[i].value} puntos`;
    }
    if (this.testData.formModel[i].type == 'radio' || this.testData.formModel[i].type == 'multiple') {
      let total = 0
      for (let v of value){
        for (let c of this.testData.formModel[i].data){
          if (c.text == v) total += c.value;
        }
      }
      return `${total} puntos`;
    }

    return '0 puntos'
  }

  getTextResponse(value: any){
    if (typeof value == 'string') return value;
    if (Array.isArray(value)) return value.join(', ');
  }

  sortByScore(){

    let tests = this.tests.sort(
      (a, b) => {
        if (!a.formScore) a.formScore = 0;
        if (!b.formScore) b.formScore = 0;

        if (a.formScore > b.formScore) {
          if (this.ascending) return 1;
          return -1
        }
        if (a.formScore < b.formScore) {
          if (this.ascending) return -1;
          return 1
        }
        return 0
      })
      return tests
  }

  executeSort(){
    this.tests = this.sortByScore();
  }

  getCompletedFormsCount(massiveData){
    let count = 0;
    for (let d of massiveData){
      if (d.test.isCompleted) count++;
    }
    return count
  }

  getIncompletedFormsCount(massiveData){
    let count = 0;
    for (let d of massiveData){
      if (!d.test.isCompleted) count++;
    }
    return count
  }

  showUsers(status, index){
    let users = [];
    this.massiveData[index].map(
      t => {
        if (status == 'completed' && t.test.isCompleted) users.push(t.test.evaluatedName);
        if (status == 'pending' && !t.test.isCompleted) users.push(t.test.evaluatedName);
        if (status == 'total') users.push(t.test.evaluatedName);        
      }
    )
    this.userList = users;
    $('#userListModal').modal('show');
  }

  exportData(){
    // console.log('EXPORT')
    this.testService.getClientTestsExport(this.user.email).subscribe(
      resp=>{
        // console.log(resp)
        let data = []
        resp.map( test => {

          try {
            
            let date = new Date(test.createDate);
            let formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`
            data.push({
              'Evaluado': test.evaluated,
              'Nombre': test.evaluatedName,
              'Fecha creación': formattedDate,
              'Tipo de test': test.type,
              'Fecha Realizado': test.isCompleted ? this.formatDate(new Date(test.completeDate)): '',
              'Local': test.isLocal ? 'Sí' : 'No',
              'Realizado': test.isCompleted ? 'Sí' : 'No',
  
            })

            data.push({'Evaluado': 'Respuestas'})
  
            if (test.type == "16PF"){
              test.report16pfs[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report}`})
              })
            }
  
            if (test.type == "ALL PORT"){
              test.allportreports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${index+1}: 1=${report[1]} 2=${report[2]} 3=${report[3]} 4=${report[4]}`})
              })
            }
  
            if (test.type == "BARSIC"){
              test.barsicreports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report}`})
              })
            }
  
            if (test.type == "BIS11"){
              test.bis11reports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report}`})
              })
            }
  
  
            if (test.type == "CHASIDE"){
              test.chasidereports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report ? 'SI' : 'NO'}`})
              })
            }
  
            if (test.type == "CLEAVER"){
              test.cleaverreports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: 1=${report[1]} 2=${report[2]} 3=${report[3]} 4=${report[4]}`})
              })
            }
  
            if (test.type == "DOMINO"){
              test.dominoreports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report[0]} - ${report[1]}`})
              })
            }
  
            if (test.type == "KOSTIK"){
              test.kostikreports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report}`})
              })
            }
  
            if (test.type == "MIPS"){
              test.mipsreports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report ? 'SI' : 'NO'}`})
              })
            }
  
            if (test.type == "MMPI2"){
              test.mmpi2reports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report ? 'SI' : 'NO'}`})
              })
            }
  
            if (test.type == "MMPIA"){
              test.mmpiareports[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report ? 'SI' : 'NO'}`})
              })
            }
  
  
            if (test.type == "TERMAN"){
              test.termanreports[0].answers.map( (report, index) => {
                let res = '';

                if (typeof report == 'object'){
                  for (let key in report){
                    res += `${key}=${report[key]} `
                  }
                }else{
                  res = report
                }

                data.push({'Evaluado': `Respuesta ${index+1}: ${res}`})
              })
            }
  
            if (test.type == "IPV"){
              test.reportipvs[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${report}`})
              })
            }
  
            if (test.type == "ZAVIC"){
              test.reportzavics[0].answers.map( (report, index) => {
                data.push({'Evaluado': `Respuesta ${index+1}: ${index+1}: 1=${report[1]} 2=${report[2]} 3=${report[3]} 4=${report[4]}`})
              })
            }

            data.push({'Evaluado': ''})

          } catch (error) {
            console.log(error)
          }


        })

        const headings = [[
          'Evaluado',
          'Nombre',
          'Fecha creación',
          'Tipo de test',
          'Fecha Realizado',
          'Local',
          'Realizado',
        ]];



        let wb = utils.book_new();
        let ws: any = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, data);
        utils.book_append_sheet(wb, ws, 'Report');
        writeFile(wb, 'reporte_pruebas.xlsx');
        
      },
      err=>console.log(err)
    )
  }

  formatDate(date: Date){
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`
  }

  haveMoreThanOneTest(testName: string, userEmail: string){
    let count = 0;
    for (let t of this.tests){
      if (t.type == testName && t.evaluated == userEmail && t.isCompleted) count++;
    }
    return count > 1;
  }

}
